// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import { ToastContainer, toast } from "react-toastify";
// // // // import "react-toastify/dist/ReactToastify.css";
// // // // import Slider from "react-slick";
// // // // import { Helmet } from "react-helmet";
// // // // import { Galleria } from "primereact/galleria";
// // // // import { useNavigate } from "react-router-dom";
// // // // import axios from "axios";
// // // // import Footer from "../components/Footer";
// // // // import Header from "../components/Header";
// // // // import { URLS } from "../Url";
// // // // import CouponSection from "../components/Coupons";
// // // // import PopupModal from "../components/PopUpModal";
// // // // import "slick-carousel/slick/slick.css";
// // // // import "slick-carousel/slick/slick-theme.css";

// // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // import { ToastContainer, toast } from "react-toastify";
// // // // // import "react-toastify/dist/ReactToastify.css";
// // // // // import { Helmet } from "react-helmet";
// // // // // import { Galleria } from "primereact/galleria";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import axios from "axios";
// // // // // import Footer from "./Footer";
// // // // // import Header from "./Header";
// // // // // import { URLS } from "../Url";
// // // // // import CouponSection from "./Coupons";
// // // // // import PopupModal from "./PopUpModal";
// // // // // import "slick-carousel/slick/slick.css";
// // // // // import "slick-carousel/slick/slick-theme.css";

// // // // /* ─── Brand Palette (Matching Carnival Castle) ──────────────────────────── */
// // // // const C = {
// // // //   primary:      "#5E0E73",
// // // //   primaryLight: "#6E1A85",
// // // //   primaryPale:  "#F3E5F7",
// // // //   cream:        "#E8E1D6",
// // // //   beige:        "#D6CFC4",
// // // //   gold:         "#C9A84C",
// // // //   goldLight:    "#E8D5A0",
// // // //   dark:         "#1A0030",
// // // //   dark2:        "#120020",
// // // // };

// // // // /* ─── Static Kids Data ──────────────────────────────────────────────────── */
// // // // const KID_THEMES = [
// // // //   { name: "Dinosaur Adventure", bookings: "487 bookings", tags: ["Dinosaurs", "Jungle", "Roar"], img: "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80" },
// // // //   { name: "Princess Royal", bookings: "562 bookings", tags: ["Princess", "Castle", "Pink"], img: "https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=600&q=80" },
// // // //   { name: "Space Explorer", bookings: "398 bookings", tags: ["Space", "Astronaut", "Galaxy"], img: "https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80" },
// // // //   { name: "Underwater World", bookings: "312 bookings", tags: ["Ocean", "Mermaids", "Blue"], img: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&q=80" },
// // // //   { name: "Superhero Academy", bookings: "445 bookings", tags: ["Superhero", "Action", "Comic"], img: "https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80" },
// // // //   { name: "Candyland", bookings: "534 bookings", tags: ["Candy", "Sweet", "Colorful"], img: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80" },
// // // //   { name: "Jungle Safari", bookings: "276 bookings", tags: ["Animals", "Safari", "Green"], img: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=600&q=80" },
// // // //   { name: "Frozen Fantasy", bookings: "621 bookings", tags: ["Frozen", "Snow", "Ice"], img: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=600&q=80" },
// // // // ];

// // // // const KID_SERVICES = [
// // // //   { label: "Kids Party Packages", img: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", href: "/kids-packages", desc: "Complete party solutions with games, decor & food" },
// // // //   { label: "Character Appearances", img: "https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=600&q=80", href: "/characters", desc: "Favourite superheroes & princesses live!" },
// // // //   { label: "Balloon Decor", img: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80", href: null, desc: "Amazing balloon arches and sculptures" },
// // // //   { label: "Party Favors", img: "https://images.unsplash.com/photo-1513151233558-860c5392816f?w=600&q=80", href: null, desc: "Personalized goodie bags for every child" },
// // // //   { label: "Face Painting", img: "https://images.unsplash.com/photo-1544383835-bda2bc66a55b?w=600&q=80", href: null, desc: "Professional face painting artists" },
// // // //   { label: "Magic Show", img: "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=600&q=80", href: null, desc: "Interactive magic shows for all ages" },
// // // // ];

// // // // const KID_GALLERY = [
// // // //   "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80",
// // // //   "https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=600&q=80",
// // // //   "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80",
// // // //   "https://images.unsplash.com/photo-1513151233558-860c5392816f?w=600&q=80",
// // // //   "https://images.unsplash.com/photo-1544383835-bda2bc66a55b?w=600&q=80",
// // // //   "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=600&q=80",
// // // // ];

// // // // const KID_PACKAGES = [
// // // //   { name: "Mini Munchkin", price: "₹4,999", duration: "2 Hours", guests: "Up to 10 kids", features: ["Basic Decor", "Snacks & Juice", "Party Hat Set", "1 Activity"], popular: false, img: "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=500&q=80" },
// // // //   { name: "Super Star", price: "₹9,999", duration: "3 Hours", guests: "Up to 20 kids", features: ["Themed Decor", "Birthday Cake", "Return Gifts", "2 Activities", "Face Painting"], popular: true, img: "https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=500&q=80" },
// // // //   { name: "Royal Celebration", price: "₹15,999", duration: "4 Hours", guests: "Up to 30 kids", features: ["Premium Themed Decor", "Catering Meal", "3-Tier Cake", "Magic Show", "Goodie Bags", "Photographer"], popular: false, img: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=500&q=80" },
// // // // ];

// // // // const KID_TESTIMONIALS = [
// // // //   { name: "Riya Sharma", childAge: "6 years", rating: 5, text: "My daughter's princess party was absolutely magical! The decor was perfect and she still talks about it.", image: "https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=200&q=80" },
// // // //   { name: "Amit Patel", childAge: "8 years", rating: 5, text: "The superhero theme was a hit with all the kids. Professional setup and great activities. Highly recommend!", image: "https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=200&q=80" },
// // // //   { name: "Neha Gupta", childAge: "4 years", rating: 5, text: "We booked the dinosaur theme and it exceeded expectations. The kids had the time of their lives!", image: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=200&q=80" },
// // // // ];

// // // // const WHY_KIDS_CHOOSE = [
// // // //   { icon: "🎈", title: "Age-Appropriate Entertainment", desc: "Activities and shows designed specifically for kids aged 2-12" },
// // // //   { icon: "🛡️", title: "Child-Safe Environment", desc: "Soft corners, non-toxic materials, and trained staff" },
// // // //   { icon: "🎨", title: "Customizable Themes", desc: "Over 20+ themes to choose from — we bring imagination to life" },
// // // //   { icon: "📸", title: "Memory Capture", desc: "Professional photography and video coverage included" },
// // // // ];

// // // // const KID_ACTIVITIES = [
// // // //   { name: "Bouncy Castle", duration: "30 mins", age: "3-12", img: "https://images.unsplash.com/photo-1513151233558-860c5392816f?w=400&q=80" },
// // // //   { name: "Balloon Twisting", duration: "45 mins", age: "All ages", img: "https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=400&q=80" },
// // // //   { name: "Face Painting", duration: "1 hour", age: "3-12", img: "https://images.unsplash.com/photo-1544383835-bda2bc66a55b?w=400&q=80" },
// // // //   { name: "Magic Show", duration: "30 mins", age: "All ages", img: "https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=400&q=80" },
// // // // ];

// // // // const KID_FAQ = [
// // // //   { q: "What age group are these parties suitable for?", a: "Our kids' parties are designed for children aged 2-12 years. Each theme and activity is age-appropriate and can be customized based on the birthday child's age." },
// // // //   { q: "Do you provide return gifts for guests?", a: "Yes! We have a variety of return gift options including personalized goodie bags, toys, stationery, and more. You can choose based on your budget and theme." },
// // // //   { q: "Can we bring our own cake?", a: "Absolutely! While we offer delicious custom cakes, you're welcome to bring your own. We'll display it beautifully as part of the celebration." },
// // // //   { q: "Is there parental supervision required?", a: "Our staff is trained to supervise activities, but we recommend at least 2-3 parents or guardians stay with the children throughout the party." },
// // // //   { q: "How far in advance should we book?", a: "We recommend booking at least 2-3 weeks in advance for weekends. For popular themes like Princess and Superhero, book 4-6 weeks ahead." },
// // // // ];

// // // // /* ══════════════════════════════════════════════════════════════════════════ */
// // // // function KidsPage() {
// // // //   const [isLoading, setIsLoading] = useState(true);
// // // //   const [themeOff, setThemeOff] = useState(0);
// // // //   const [activeGal, setActiveGal] = useState(0);
// // // //   const [showPopup, setShowPopup] = useState(false);
// // // //   const [popupImage, setPopupImage] = useState("");
// // // //   const [form, setForm] = useState({ name: "", email: "", mobileNumber: "", childAge: "", theme: "", date: "", guests: "" });
// // // //   const galleria = useRef(null);
// // // //   const navigate = useNavigate();

// // // //   useEffect(() => {
// // // //     setTimeout(() => setIsLoading(false), 800);
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     const timer = setInterval(() => setThemeOff(o => (o + 1) % KID_THEMES.length), 4000);
// // // //     return () => clearInterval(timer);
// // // //   }, []);

// // // //   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
// // // //   const handleSubmit = (e) => {
// // // //     e.preventDefault();
// // // //     toast.success("🎉 Booking request sent! We'll call you within 2 hours.");
// // // //     setForm({ name: "", email: "", mobileNumber: "", childAge: "", theme: "", date: "", guests: "" });
// // // //   };

// // // //   const themeTx = `translateX(calc(-${themeOff * (320 + 24)}px))`;

// // // //   const galItem = (item) => <img src={item} alt="Gallery" style={{ width: "100%", display: "block", borderRadius: 16 }} />;
// // // //   const galThumb = (item) => <img src={item} alt="Thumb" style={{ display: "block", width: 60, height: 60, objectFit: "cover", borderRadius: 8 }} />;

// // // //   if (isLoading) {
// // // //     return (
// // // //       <div style={{ background: C.dark, height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
// // // //         <div style={{ width: 80, height: 80, border: `5px solid ${C.primaryPale}`, borderTop: `5px solid ${C.gold}`, borderRadius: "50%", animation: "spin 1s linear infinite" }} />
// // // //         <p style={{ color: C.gold, marginTop: 20, fontSize: 18, fontWeight: 600, letterSpacing: 2 }}>Loading magical experiences...</p>
// // // //         <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <>
// // // //       <Helmet>
// // // //         <title>Carnival Castle Kids | Magical Birthday Parties & Celebrations in Hyderabad</title>
// // // //         <meta name="description" content="Create unforgettable memories with themed birthday parties for kids. Princess, Superhero, Dinosaur themes & more. Book the perfect party today!" />
// // // //       </Helmet>

// // // //       <style>{`
// // // //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
// // // //         * { font-family: 'DM Sans', sans-serif; }
// // // //         .kids-pf { font-family: 'Playfair Display', serif !important; }
        
// // // //         /* Animations */
// // // //         @keyframes kidsFloat {
// // // //           0%, 100% { transform: translateY(0px) rotate(0deg); }
// // // //           50% { transform: translateY(-15px) rotate(5deg); }
// // // //         }
// // // //         @keyframes kidsPulse {
// // // //           0%, 100% { transform: scale(1); opacity: 0.6; }
// // // //           50% { transform: scale(1.1); opacity: 1; }
// // // //         }
// // // //         @keyframes kidsShine {
// // // //           0% { left: -100%; }
// // // //           20% { left: 120%; }
// // // //           100% { left: 120%; }
// // // //         }
// // // //         @keyframes fadeInUp {
// // // //           from { opacity: 0; transform: translateY(40px); }
// // // //           to { opacity: 1; transform: translateY(0); }
// // // //         }
// // // //         @keyframes scaleIn {
// // // //           from { opacity: 0; transform: scale(0.9); }
// // // //           to { opacity: 1; transform: scale(1); }
// // // //         }
        
// // // //         .kids-hero {
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //           background: linear-gradient(135deg, ${C.dark} 0%, ${C.primary} 50%, ${C.dark2} 100%);
// // // //         }
// // // //         .kids-hero::before {
// // // //           content: "🎈";
// // // //           position: absolute;
// // // //           font-size: 180px;
// // // //           opacity: 0.08;
// // // //           bottom: -60px;
// // // //           right: -60px;
// // // //           animation: kidsFloat 8s ease-in-out infinite;
// // // //           pointer-events: none;
// // // //         }
// // // //         .kids-hero::after {
// // // //           content: "🎂";
// // // //           position: absolute;
// // // //           font-size: 150px;
// // // //           opacity: 0.08;
// // // //           top: -60px;
// // // //           left: -60px;
// // // //           animation: kidsFloat 10s ease-in-out infinite reverse;
// // // //           pointer-events: none;
// // // //         }
        
// // // //         /* Floating bubbles */
// // // //         .kids-bubble {
// // // //           position: absolute;
// // // //           background: radial-gradient(circle, rgba(201,168,76,0.15) 0%, rgba(201,168,76,0.05) 100%);
// // // //           border-radius: 50%;
// // // //           pointer-events: none;
// // // //           animation: kidsFloat 6s ease-in-out infinite;
// // // //         }
        
// // // //         /* Buttons */
// // // //         .kids-btn-primary {
// // // //           background: linear-gradient(135deg, ${C.gold}, ${C.goldLight});
// // // //           color: ${C.dark};
// // // //           border: none;
// // // //           border-radius: 60px;
// // // //           padding: 14px 32px;
// // // //           font-weight: 800;
// // // //           font-size: 14px;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s cubic-bezier(0.25,1,0.5,1);
// // // //           box-shadow: 0 8px 25px rgba(201,168,76,0.35);
// // // //           text-decoration: none;
// // // //           display: inline-flex;
// // // //           align-items: center;
// // // //           gap: 8px;
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //         }
// // // //         .kids-btn-primary::before {
// // // //           content: '';
// // // //           position: absolute;
// // // //           top: 0;
// // // //           left: -100%;
// // // //           width: 50%;
// // // //           height: 100%;
// // // //           background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
// // // //           transition: left 0.5s;
// // // //         }
// // // //         .kids-btn-primary:hover::before {
// // // //           left: 150%;
// // // //         }
// // // //         .kids-btn-primary:hover {
// // // //           transform: translateY(-3px) scale(1.02);
// // // //           box-shadow: 0 12px 35px rgba(201,168,76,0.5);
// // // //         }
        
// // // //         .kids-btn-outline {
// // // //           background: transparent;
// // // //           color: ${C.gold};
// // // //           border: 2px solid ${C.gold};
// // // //           border-radius: 60px;
// // // //           padding: 12px 30px;
// // // //           font-weight: 700;
// // // //           font-size: 14px;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s;
// // // //           text-decoration: none;
// // // //           display: inline-flex;
// // // //           align-items: center;
// // // //           gap: 8px;
// // // //         }
// // // //         .kids-btn-outline:hover {
// // // //           background: ${C.gold};
// // // //           color: ${C.dark};
// // // //           transform: translateY(-2px);
// // // //           box-shadow: 0 8px 20px rgba(201,168,76,0.3);
// // // //         }
        
// // // //         /* Cards */
// // // //         .kids-card {
// // // //           background: white;
// // // //           border-radius: 24px;
// // // //           overflow: hidden;
// // // //           transition: all 0.4s cubic-bezier(0.25,1,0.5,1);
// // // //           cursor: pointer;
// // // //           box-shadow: 0 10px 30px rgba(94,14,115,0.08);
// // // //           border: 1px solid rgba(94,14,115,0.08);
// // // //         }
// // // //         .kids-card:hover {
// // // //           transform: translateY(-10px);
// // // //           box-shadow: 0 25px 50px rgba(94,14,115,0.15);
// // // //           border-color: ${C.gold}40;
// // // //         }
        
// // // //         /* Theme Card */
// // // //         .kids-theme-card {
// // // //           flex-shrink: 0;
// // // //           width: 320px;
// // // //           border-radius: 28px;
// // // //           overflow: hidden;
// // // //           background: white;
// // // //           box-shadow: 0 15px 35px rgba(0,0,0,0.15);
// // // //           transition: all 0.4s cubic-bezier(0.25,1,0.5,1);
// // // //           cursor: pointer;
// // // //           border: 2px solid transparent;
// // // //         }
// // // //         .kids-theme-card:hover {
// // // //           transform: translateY(-12px) rotate(1deg);
// // // //           border-color: ${C.gold};
// // // //           box-shadow: 0 25px 55px rgba(94,14,115,0.25);
// // // //         }
        
// // // //         /* Package Card */
// // // //         .kids-package-card {
// // // //           border-radius: 24px;
// // // //           overflow: hidden;
// // // //           transition: all 0.4s cubic-bezier(0.25,1,0.5,1);
// // // //           cursor: pointer;
// // // //           background: white;
// // // //           border: 1px solid rgba(94,14,115,0.1);
// // // //           position: relative;
// // // //         }
// // // //         .kids-package-card:hover {
// // // //           transform: translateY(-8px);
// // // //           box-shadow: 0 20px 45px rgba(94,14,115,0.2);
// // // //           border-color: ${C.gold};
// // // //         }
// // // //         .popular-ribbon {
// // // //           position: absolute;
// // // //           top: 16px;
// // // //           right: -35px;
// // // //           background: linear-gradient(135deg, ${C.gold}, ${C.goldLight});
// // // //           color: ${C.dark};
// // // //           padding: 6px 45px;
// // // //           transform: rotate(45deg);
// // // //           font-size: 11px;
// // // //           font-weight: 800;
// // // //           letter-spacing: 1px;
// // // //           z-index: 2;
// // // //           box-shadow: 0 2px 10px rgba(0,0,0,0.1);
// // // //         }
        
// // // //         /* Testimonial Card */
// // // //         .kids-testi-card {
// // // //           background: white;
// // // //           border-radius: 24px;
// // // //           padding: 24px;
// // // //           box-shadow: 0 10px 30px rgba(94,14,115,0.08);
// // // //           transition: all 0.3s;
// // // //           border: 1px solid rgba(94,14,115,0.08);
// // // //         }
// // // //         .kids-testi-card:hover {
// // // //           transform: translateY(-5px);
// // // //           box-shadow: 0 20px 40px rgba(94,14,115,0.15);
// // // //           border-color: ${C.gold}60;
// // // //         }
        
// // // //         /* Activity Card */
// // // //         .kids-activity-card {
// // // //           border-radius: 20px;
// // // //           overflow: hidden;
// // // //           transition: all 0.4s;
// // // //           cursor: pointer;
// // // //           background: white;
// // // //           box-shadow: 0 8px 20px rgba(94,14,115,0.08);
// // // //         }
// // // //         .kids-activity-card:hover {
// // // //           transform: scale(1.03) translateY(-5px);
// // // //           box-shadow: 0 15px 35px rgba(94,14,115,0.2);
// // // //         }
        
// // // //         /* Form Inputs */
// // // //         .kids-form-input {
// // // //           width: 100%;
// // // //           padding: 14px 18px;
// // // //           border: 2px solid ${C.beige};
// // // //           border-radius: 16px;
// // // //           font-size: 14px;
// // // //           transition: all 0.3s;
// // // //           background: ${C.cream};
// // // //           font-family: 'DM Sans', sans-serif;
// // // //         }
// // // //         .kids-form-input:focus {
// // // //           outline: none;
// // // //           border-color: ${C.gold};
// // // //           box-shadow: 0 0 0 3px ${C.gold}20;
// // // //           background: white;
// // // //         }
        
// // // //         /* Section Titles */
// // // //         .kids-section-tag {
// // // //           display: inline-block;
// // // //           background: ${C.primaryPale};
// // // //           color: ${C.primary};
// // // //           padding: 6px 18px;
// // // //           border-radius: 60px;
// // // //           font-size: 11px;
// // // //           font-weight: 700;
// // // //           letter-spacing: 2px;
// // // //           text-transform: uppercase;
// // // //           margin-bottom: 16px;
// // // //         }
// // // //         .kids-section-title {
// // // //           font-family: 'Playfair Display', serif;
// // // //           font-size: clamp(28px, 5vw, 48px);
// // // //           font-weight: 700;
// // // //           color: ${C.dark};
// // // //           margin-bottom: 16px;
// // // //         }
// // // //         .kids-section-title span {
// // // //           color: ${C.primary};
// // // //         }
// // // //         .kids-section-title .gold {
// // // //           color: ${C.gold};
// // // //         }
        
// // // //         /* Gallery Items */
// // // //         .kids-gallery-item {
// // // //           border-radius: 20px;
// // // //           overflow: hidden;
// // // //           cursor: pointer;
// // // //           position: relative;
// // // //           aspect-ratio: 1;
// // // //         }
// // // //         .kids-gallery-item img {
// // // //           width: 100%;
// // // //           height: 100%;
// // // //           object-fit: cover;
// // // //           transition: transform 0.5s;
// // // //         }
// // // //         .kids-gallery-item:hover img {
// // // //           transform: scale(1.08);
// // // //         }
// // // //         .kids-gallery-overlay {
// // // //           position: absolute;
// // // //           inset: 0;
// // // //           background: ${C.primary}80;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           opacity: 0;
// // // //           transition: opacity 0.3s;
// // // //         }
// // // //         .kids-gallery-item:hover .kids-gallery-overlay {
// // // //           opacity: 1;
// // // //         }
        
// // // //         /* FAQ Accordion */
// // // //         .kids-faq-item {
// // // //           background: white;
// // // //           border-radius: 20px;
// // // //           padding: 20px 24px;
// // // //           margin-bottom: 16px;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s;
// // // //           border: 1px solid ${C.beige};
// // // //         }
// // // //         .kids-faq-item:hover {
// // // //           border-color: ${C.gold};
// // // //           box-shadow: 0 8px 20px rgba(94,14,115,0.1);
// // // //         }
        
// // // //         /* Responsive */
// // // //         @media (max-width: 768px) {
// // // //           .kids-theme-card { width: 280px; }
// // // //           .kids-btn-primary, .kids-btn-outline { padding: 12px 24px; font-size: 13px; }
// // // //           .kids-section-title { font-size: 28px; }
// // // //         }
// // // //         @media (max-width: 480px) {
// // // //           .kids-theme-card { width: 260px; }
// // // //           .kids-card { margin: 0 12px; }
// // // //         }
// // // //       `}</style>

// // // //       <div className="kids-page">
// // // //         <Header />

// // // //         {/* ══ HERO SECTION ═══════════════════════════════════════════════ */}
// // // //         <section className="kids-hero" style={{ padding: "100px 0 80px", position: "relative" }}>
// // // //           {/* Floating Bubbles */}
// // // //           {[...Array(8)].map((_, i) => (
// // // //             <div key={i} className="kids-bubble" style={{
// // // //               width: Math.random() * 60 + 20,
// // // //               height: Math.random() * 60 + 20,
// // // //               left: `${Math.random() * 100}%`,
// // // //               top: `${Math.random() * 100}%`,
// // // //               animationDelay: `${Math.random() * 5}s`,
// // // //               animationDuration: `${Math.random() * 8 + 4}s`,
// // // //             }} />
// // // //           ))}
          
// // // //           <div className="container">
// // // //             <div className="row align-items-center">
// // // //               <div className="col-lg-6" style={{ animation: "fadeInUp 0.8s ease-out" }}>
// // // //                 <div style={{ display: "inline-block", background: `${C.gold}20`, backdropFilter: "blur(10px)", borderRadius: "60px", padding: "8px 20px", marginBottom: 20, border: `1px solid ${C.gold}40` }}>
// // // //                   <span style={{ fontSize: 13, fontWeight: 600, color: C.goldLight }}>🎉 Let's Celebrate! 🎉</span>
// // // //                 </div>
// // // //                 <h1 className="kids-pf" style={{ fontSize: "clamp(36px, 6vw, 64px)", color: "#fff", lineHeight: 1.2, marginBottom: 20, textShadow: "2px 2px 0 rgba(0,0,0,0.1)" }}>
// // // //                   Magical <span style={{ color: C.gold }}>Birthday Parties</span> for Your Little One
// // // //                 </h1>
// // // //                 <p style={{ fontSize: 18, color: `${C.cream}CC`, marginBottom: 30, lineHeight: 1.6 }}>
// // // //                   From princess castles to dinosaur adventures — create unforgettable memories with our themed party packages.
// // // //                 </p>
// // // //                 <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
// // // //                   <button onClick={() => document.getElementById("packages")?.scrollIntoView({ behavior: "smooth" })} className="kids-btn-primary">
// // // //                     🎈 Explore Packages
// // // //                   </button>
// // // //                   <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" })} className="kids-btn-outline">
// // // //                     📞 Book a Callback
// // // //                   </button>
// // // //                 </div>
// // // //               </div>
// // // //               <div className="col-lg-6 text-center" style={{ animation: "fadeInUp 0.8s ease-out 0.2s both" }}>
// // // //                 <div style={{ position: "relative", display: "inline-block" }}>
// // // //                   <img src="https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=500&q=80" alt="Kids Party" style={{ borderRadius: "40px", width: "100%", maxWidth: 400, boxShadow: `0 30px 50px rgba(0,0,0,0.2)`, border: `4px solid ${C.gold}60` }} />
// // // //                   <div style={{ position: "absolute", bottom: -20, right: -20, background: C.gold, borderRadius: "50%", padding: 15, boxShadow: "0 10px 20px rgba(0,0,0,0.2)", animation: "kidsFloat 3s ease-in-out infinite" }}>
// // // //                     <span style={{ fontSize: 40 }}>🎂</span>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ WHY CHOOSE KIDS ════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: C.cream }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">✨ Why Parents Love Us ✨</span>
// // // //               <h2 className="kids-section-title">Making Kids' Parties <span className="gold">Magical & Stress-Free</span></h2>
// // // //               <p style={{ color: "#666", maxWidth: 600, margin: "0 auto" }}>We handle everything so you can focus on making memories with your child</p>
// // // //             </div>
// // // //             <div className="row g-4">
// // // //               {WHY_KIDS_CHOOSE.map((item, i) => (
// // // //                 <div key={i} className="col-md-3 col-sm-6" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }}>
// // // //                   <div className="kids-card" style={{ padding: "30px 20px", textAlign: "center" }}>
// // // //                     <div style={{ fontSize: 48, marginBottom: 16 }}>{item.icon}</div>
// // // //                     <h3 style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 8 }}>{item.title}</h3>
// // // //                     <p style={{ fontSize: 13, color: "#888", margin: 0 }}>{item.desc}</p>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ POPULAR THEMES ════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: `linear-gradient(135deg, ${C.primaryPale} 0%, ${C.cream} 100%)` }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">🎨 Popular Themes 🎨</span>
// // // //               <h2 className="kids-section-title">Choose Your Child's <span>Dream Theme</span></h2>
// // // //               <p style={{ color: "#666", maxWidth: 600, margin: "0 auto" }}>From superheroes to unicorns — we bring imagination to life</p>
// // // //             </div>
            
// // // //             <div style={{ overflow: "hidden", position: "relative" }}>
// // // //               <div className="theme-track" style={{ display: "flex", gap: 24, transition: "transform 0.6s cubic-bezier(0.25,1,0.5,1)", transform: themeTx }}>
// // // //                 {[...KID_THEMES, ...KID_THEMES].map((theme, i) => (
// // // //                   <div key={i} className="kids-theme-card" onClick={() => navigate("/locations")}>
// // // //                     <img src={theme.img} alt={theme.name} style={{ width: "100%", height: 280, objectFit: "cover" }} />
// // // //                     <div style={{ padding: 20 }}>
// // // //                       <h3 className="kids-pf" style={{ fontSize: 20, fontWeight: 700, marginBottom: 8, color: C.dark }}>{theme.name}</h3>
// // // //                       <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
// // // //                         {theme.tags.map((tag, j) => <span key={j} style={{ background: C.primaryPale, color: C.primary, padding: "4px 12px", borderRadius: "50px", fontSize: 11, fontWeight: 600 }}>{tag}</span>)}
// // // //                       </div>
// // // //                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
// // // //                         <span style={{ color: "#888", fontSize: 12 }}>🔥 {theme.bookings}</span>
// // // //                         <button className="kids-btn-primary" style={{ padding: "8px 20px", fontSize: 12 }}>Book Theme →</button>
// // // //                       </div>
// // // //                     </div>
// // // //                   </div>
// // // //                 ))}
// // // //               </div>
// // // //             </div>
            
// // // //             <div style={{ display: "flex", justifyContent: "center", gap: 12, marginTop: 32 }}>
// // // //               <button onClick={() => setThemeOff(o => Math.max(0, o - 1))} style={{ width: 48, height: 48, borderRadius: "50%", background: "white", border: `2px solid ${C.primary}`, color: C.primary, fontSize: 20, cursor: "pointer", transition: "all 0.3s" }}>‹</button>
// // // //               <button onClick={() => setThemeOff(o => (o + 1) % KID_THEMES.length)} style={{ width: 48, height: 48, borderRadius: "50%", background: C.primary, border: "none", color: "white", fontSize: 20, cursor: "pointer", transition: "all 0.3s" }}>›</button>
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ KIDS SERVICES ═══════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: "white" }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">🎪 Party Services 🎪</span>
// // // //               <h2 className="kids-section-title">Everything You Need for the <span>Perfect Party</span></h2>
// // // //             </div>
// // // //             <div className="row g-4">
// // // //               {KID_SERVICES.map((service, i) => (
// // // //                 <div key={i} className="col-lg-4 col-md-6" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.05}s both` }}>
// // // //                   <div className="kids-card" style={{ display: "flex", padding: 20, gap: 16, alignItems: "center" }}>
// // // //                     <img src={service.img} alt={service.label} style={{ width: 80, height: 80, borderRadius: 20, objectFit: "cover" }} />
// // // //                     <div style={{ flex: 1 }}>
// // // //                       <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4, color: C.dark }}>{service.label}</h3>
// // // //                       <p style={{ fontSize: 12, color: "#888", marginBottom: 8 }}>{service.desc}</p>
// // // //                       {service.href && <a href={service.href} style={{ color: C.primary, fontSize: 12, fontWeight: 600, textDecoration: "none" }}>Learn more →</a>}
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ FUN ACTIVITIES ══════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: C.cream }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">🎮 Fun Activities 🎮</span>
// // // //               <h2 className="kids-section-title">Keep the Kids <span>Entertained All Day</span></h2>
// // // //             </div>
// // // //             <div className="row g-4">
// // // //               {KID_ACTIVITIES.map((activity, i) => (
// // // //                 <div key={i} className="col-md-3 col-sm-6">
// // // //                   <div className="kids-activity-card">
// // // //                     <img src={activity.img} alt={activity.name} style={{ width: "100%", height: 200, objectFit: "cover" }} />
// // // //                     <div style={{ padding: 16 }}>
// // // //                       <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{activity.name}</h3>
// // // //                       <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#888" }}>
// // // //                         <span>⏱️ {activity.duration}</span>
// // // //                         <span>👶 {activity.age}</span>
// // // //                       </div>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ PARTY PACKAGES ══════════════════════════════════════════════ */}
// // // //         <section id="packages" style={{ padding: "80px 0", background: "white" }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">🎁 Party Packages 🎁</span>
// // // //               <h2 className="kids-section-title">Choose the Perfect <span>Celebration Package</span></h2>
// // // //             </div>
// // // //             <div className="row g-4">
// // // //               {KID_PACKAGES.map((pkg, i) => (
// // // //                 <div key={i} className="col-md-4" style={{ animation: `fadeInUp 0.6s ease-out ${i * 0.1}s both` }}>
// // // //                   <div className="kids-package-card">
// // // //                     {pkg.popular && <div className="popular-ribbon">🔥 Most Popular</div>}
// // // //                     <img src={pkg.img} alt={pkg.name} style={{ width: "100%", height: 220, objectFit: "cover" }} />
// // // //                     <div style={{ padding: 24 }}>
// // // //                       <h3 className="kids-pf" style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>{pkg.name}</h3>
// // // //                       <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
// // // //                         <span style={{ fontSize: 12, color: "#888" }}>⏱️ {pkg.duration}</span>
// // // //                         <span style={{ fontSize: 12, color: "#888" }}>👥 {pkg.guests}</span>
// // // //                       </div>
// // // //                       <ul style={{ paddingLeft: 20, marginBottom: 20, fontSize: 13, color: "#555", lineHeight: 1.8 }}>
// // // //                         {pkg.features.map((f, j) => <li key={j}>{f}</li>)}
// // // //                       </ul>
// // // //                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
// // // //                         <span style={{ fontSize: 28, fontWeight: 700, color: C.primary }}>{pkg.price}</span>
// // // //                         <button className="kids-btn-primary" style={{ padding: "10px 24px", fontSize: 13 }}>Book Now →</button>
// // // //                       </div>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ GALLERY ═════════════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: C.cream }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">📸 Happy Moments 📸</span>
// // // //               <h2 className="kids-section-title">Memories from Our <span>Little Guests</span></h2>
// // // //             </div>
// // // //             <div className="row g-3">
// // // //               {KID_GALLERY.map((img, i) => (
// // // //                 <div key={i} className="col-md-4 col-sm-6">
// // // //                   <div className="kids-gallery-item" onClick={() => { setActiveGal(i); galleria.current?.show(); }}>
// // // //                     <img src={img} alt="Gallery" />
// // // //                     <div className="kids-gallery-overlay">
// // // //                       <span style={{ fontSize: 32, color: "white" }}>🔍</span>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //             <Galleria ref={galleria} value={KID_GALLERY} numVisible={5} activeIndex={activeGal} onItemChange={e => setActiveGal(e.index)} circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb} style={{ maxWidth: 900 }} />
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ TESTIMONIALS ════════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: "white" }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">💬 Happy Parents 💬</span>
// // // //               <h2 className="kids-section-title">What <span>Parents Say</span> About Us</h2>
// // // //             </div>
// // // //             <div className="row g-4">
// // // //               {KID_TESTIMONIALS.map((testi, i) => (
// // // //                 <div key={i} className="col-md-4">
// // // //                   <div className="kids-testi-card">
// // // //                     <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
// // // //                       <img src={testi.image} alt={testi.name} style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover", border: `2px solid ${C.gold}` }} />
// // // //                       <div>
// // // //                         <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 2 }}>{testi.name}</h4>
// // // //                         <span style={{ fontSize: 12, color: "#888" }}>Parent of {testi.childAge} old</span>
// // // //                       </div>
// // // //                     </div>
// // // //                     <div style={{ color: C.gold, fontSize: 16, marginBottom: 12 }}>{"★".repeat(testi.rating)}{"☆".repeat(5 - testi.rating)}</div>
// // // //                     <p style={{ fontSize: 14, color: "#555", lineHeight: 1.6, margin: 0 }}>"{testi.text}"</p>
// // // //                   </div>
// // // //                 </div>
// // // //               ))}
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ ENQUIRY FORM ════════════════════════════════════════════════ */}
// // // //         <section id="enquiry" style={{ padding: "80px 0", background: C.dark }}>
// // // //           <div className="container">
// // // //             <div className="row justify-content-center">
// // // //               <div className="col-lg-8">
// // // //                 <div style={{ background: "white", borderRadius: 40, padding: "clamp(30px, 5vw, 50px)", boxShadow: `0 30px 60px rgba(0,0,0,0.3)` }}>
// // // //                   <div className="text-center" style={{ marginBottom: 32 }}>
// // // //                     <span style={{ fontSize: 48 }}>🎈</span>
// // // //                     <h2 className="kids-pf" style={{ fontSize: "clamp(28px, 4vw, 36px)", color: C.dark, marginTop: 8 }}>Let's Plan the Perfect Party!</h2>
// // // //                     <p style={{ color: "#888" }}>Fill in the details and we'll get back to you within 2 hours</p>
// // // //                   </div>
// // // //                   <form onSubmit={handleSubmit}>
// // // //                     <div className="row g-3">
// // // //                       <div className="col-md-6">
// // // //                         <input type="text" name="name" className="kids-form-input" placeholder="Your Name *" value={form.name} onChange={handleChange} required />
// // // //                       </div>
// // // //                       <div className="col-md-6">
// // // //                         <input type="email" name="email" className="kids-form-input" placeholder="Email Address *" value={form.email} onChange={handleChange} required />
// // // //                       </div>
// // // //                       <div className="col-md-6">
// // // //                         <input type="tel" name="mobileNumber" className="kids-form-input" placeholder="Phone Number *" value={form.mobileNumber} onChange={handleChange} required />
// // // //                       </div>
// // // //                       <div className="col-md-6">
// // // //                         <input type="text" name="childAge" className="kids-form-input" placeholder="Child's Age *" value={form.childAge} onChange={handleChange} required />
// // // //                       </div>
// // // //                       <div className="col-md-6">
// // // //                         <select name="theme" className="kids-form-input" value={form.theme} onChange={handleChange} required>
// // // //                           <option value="">Select Theme *</option>
// // // //                           {KID_THEMES.map((t, i) => <option key={i} value={t.name}>{t.name}</option>)}
// // // //                         </select>
// // // //                       </div>
// // // //                       <div className="col-md-6">
// // // //                         <input type="date" name="date" className="kids-form-input" value={form.date} onChange={handleChange} required />
// // // //                       </div>
// // // //                       <div className="col-md-12">
// // // //                         <select name="guests" className="kids-form-input" value={form.guests} onChange={handleChange} required>
// // // //                           <option value="">Number of Kids (approx) *</option>
// // // //                           <option>5-10 kids</option>
// // // //                           <option>11-20 kids</option>
// // // //                           <option>21-30 kids</option>
// // // //                           <option>30+ kids</option>
// // // //                         </select>
// // // //                       </div>
// // // //                       <div className="col-12">
// // // //                         <button type="submit" className="kids-btn-primary" style={{ width: "100%", padding: "16px", fontSize: 16, justifyContent: "center" }}>🎉 Request a Callback 🎉</button>
// // // //                       </div>
// // // //                     </div>
// // // //                   </form>
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ FAQ ═════════════════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "80px 0", background: C.cream }}>
// // // //           <div className="container">
// // // //             <div className="text-center" style={{ marginBottom: 56 }}>
// // // //               <span className="kids-section-tag">❓ FAQ ❓</span>
// // // //               <h2 className="kids-section-title">Got <span>Questions?</span> We've Got Answers</h2>
// // // //             </div>
// // // //             <div className="row justify-content-center">
// // // //               <div className="col-lg-8">
// // // //                 {KID_FAQ.map((faq, i) => (
// // // //                   <div key={i} className="kids-faq-item">
// // // //                     <h3 className="kids-pf" style={{ fontSize: 16, fontWeight: 700, color: C.dark, marginBottom: 8 }}>🎈 {faq.q}</h3>
// // // //                     <p style={{ fontSize: 14, color: "#666", margin: 0 }}>{faq.a}</p>
// // // //                   </div>
// // // //                 ))}
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </section>

// // // //         {/* ══ CTA BANNER ══════════════════════════════════════════════════ */}
// // // //         <section style={{ padding: "60px 0", background: C.dark2 }}>
// // // //           <div className="container text-center">
// // // //             <h2 className="kids-pf" style={{ fontSize: "clamp(24px, 4vw, 36px)", color: C.gold, marginBottom: 16 }}>Ready to Create Magical Memories?</h2>
// // // //             <p style={{ color: `${C.cream}CC`, fontSize: 16, marginBottom: 24 }}>Book your child's dream birthday party today!</p>
// // // //             <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" })} className="kids-btn-primary" style={{ background: C.gold, color: C.dark, fontSize: 16, padding: "16px 40px" }}>
// // // //               🎂 Book Your Party Now 🎂
// // // //             </button>
// // // //           </div>
// // // //         </section>

// // // //         <CouponSection />
// // // //         <Footer />
// // // //         <ToastContainer position="top-center" autoClose={3000} />
// // // //         <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />
// // // //       </div>
// // // //     </>
// // // //   );
// // // // }

// // // // export default KidsPage;
// // // import React, { useState, useEffect, useRef, useMemo } from "react";
// // // import { ToastContainer, toast } from "react-toastify";
// // // import "react-toastify/dist/ReactToastify.css";
// // // import { Helmet } from "react-helmet";
// // // import { Galleria } from "primereact/galleria";
// // // import { useNavigate } from "react-router-dom";
// // // import axios from "axios";
// // // import Footer from "../components/Footer";
// // // import Header from "../components/Header";
// // // import { URLS } from "../Url";
// // // import CouponSection from "../components/Coupons";
// // // import PopupModal from "../components/PopUpModal";

// // // /* ─── EXACT Brand Palette — matches Home.jsx ────────────────────────────── */
// // // const C = {
// // //   primary:      "#5E0E73",
// // //   primaryLight: "#6E1A85",
// // //   primaryDeep:  "#3A0847",
// // //   primaryPale:  "#F3E5F7",
// // //   cream:        "#E8E1D6",
// // //   beige:        "#D6CFC4",
// // //   gold:         "#C9A84C",
// // //   goldLight:    "#E8D5A0",
// // //   goldBright:   "#F5D87A",
// // //   dark:         "#1A0030",
// // //   dark2:        "#120020",
// // // };

// // // /* ─── Static Kids Data ──────────────────────────────────────────────────── */
// // // const KID_THEMES = [
// // //   { name:"Dinosaur Adventure", bookings:"487", tags:["Dinos","Jungle"],    img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80", emoji:"🦕", color:"#22C55E" },
// // //   { name:"Princess Royal",     bookings:"562", tags:["Princess","Castle"], img:"https://plus.unsplash.com/premium_photo-1664205766214-9e3f453ef4cc?q=80", emoji:"👑", color:"#EC4899" },
// // //   { name:"Space Explorer",     bookings:"398", tags:["Space","Galaxy"],    img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80", emoji:"🚀", color:"#6366F1" },
// // //   { name:"Underwater World",   bookings:"312", tags:["Ocean","Fish"],      img:"https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&q=80", emoji:"🐠", color:"#06B6D4" },
// // //   { name:"Superhero Academy",  bookings:"445", tags:["Hero","Action"],     img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80", emoji:"⚡", color:"#F59E0B" },
// // //   { name:"Candyland",          bookings:"534", tags:["Sweet","Candy"],     img:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80", emoji:"🍭", color:"#A855F7" },
// // // ];

// // // const KID_PACKAGES = [
// // //   { name:"Mini Munchkin",     price:"₹4,999",  dur:"2 Hours", guests:"Up to 10 kids", features:["Themed Decor Setup","Snacks & Juice Bar","Party Hat Set","1 Fun Activity"],                                      popular:false, emoji:"🎈", color:C.primary,  img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=500&q=80" },
// // //   { name:"Super Star",        price:"₹9,999",  dur:"3 Hours", guests:"Up to 20 kids", features:["Premium Themed Decor","Birthday Cake 🎂","Return Gifts Bag","2 Live Activities","Face Painting Artist"],        popular:true,  emoji:"⭐", color:C.gold,     img:"https://plus.unsplash.com/premium_photo-1661764559771-8f78623b352c?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
// // //   { name:"Royal Celebration", price:"₹15,999", dur:"4 Hours", guests:"Up to 30 kids", features:["Luxury Theme Decor","Full Catering Meal","3-Tier Custom Cake","Magic Show Live","Goodie Bags","Pro Photographer"], popular:false, emoji:"👑", color:"#EC4899", img:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=500&q=80" },
// // // ];

// // // const WHY_US = [
// // //   { icon:"🛡️", title:"100% Child Safe",   desc:"Soft corners, non-toxic materials, trained staff throughout the event." },
// // //   { icon:"🎨", title:"20+ Dream Themes",  desc:"Every child's imagination brought to vivid, magical life." },
// // //   { icon:"📸", title:"Memory Captured",   desc:"Professional photography included in every package." },
// // //   { icon:"⚡", title:"2hr Response",      desc:"We call you back within 2 hours — guaranteed." },
// // // ];

// // // const KID_ACTIVITIES = [
// // //   { name:"Bouncy Castle",    dur:"30 mins", age:"3–12",    img:"https://images.unsplash.com/photo-1632765471084-9f2ab98365bf?q=80" },
// // //   { name:"Balloon Twisting", dur:"45 mins", age:"All ages",img:"https://images.unsplash.com/photo-1727695034153-ff948d488bb1?q=80" },
// // //   { name:"Face Painting",    dur:"1 hour",  age:"3–12",    img:"https://images.unsplash.com/photo-1661708733650-58062da7eecf?q=80" },
// // //   { name:"Magic Show",       dur:"30 mins", age:"All ages",img:"https://images.unsplash.com/photo-1641478859026-c2728062c1e1?q=80" },
// // // ];

// // // const SERVICE_CARDS = [
// // //   { label:"Themed Decor",  img:"https://images.unsplash.com/photo-1765947382841-24c48f1c987e?q=80", desc:"Complete themed decor — balloons, backdrops, props & more." },
// // //   { label:"Custom Cakes",  img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", desc:"3D themed cakes crafted by our in-house bakers." },
// // //   { label:"Food & Snacks", img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80", desc:"Kid-friendly menus with vegetarian & non-veg options." },
// // //   { label:"Photography",   img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80", desc:"Professional candid photography — memories forever." },
// // // ];

// // // const KID_FAQ = [
// // //   { q:"What age group are these parties for?",  a:"Our kids' parties are designed for children aged 2–12 years. Every theme and activity is age-appropriate and fully customizable." },
// // //   { q:"Can we bring our own cake?",             a:"Absolutely! You're welcome to bring your own cake. We'll display it beautifully as part of the celebration decor." },
// // //   { q:"Do you provide return gifts?",           a:"Yes! Personalized goodie bags, toys, stationery — tailored to your budget and chosen theme." },
// // //   { q:"How far in advance should we book?",     a:"We recommend 2–3 weeks for weekdays, 4–6 weeks for popular weekend themes like Princess & Superhero." },
// // //   { q:"Is parental supervision required?",      a:"Our trained staff supervises all activities, but we recommend 2–3 guardians stay present throughout the party." },
// // // ];

// // // const KID_GALLERY = [
// // //   // Add your party/event images here
// // //   // Path format: "/assets/img/your-image-name.jpg"
// // //   // Example: "/assets/img/party1.jpg"
  
// // //   "/assets/img/m1.jpg",
// // //   "/assets/img/m2.jpg",
// // //   "/assets/img/m3.jpg",
// // //   "/assets/img/m4.jpg",
// // //   "/assets/img/m5.jpg",
// // //   "/assets/img/m6.jpg",
  
// // //   // TO ADD MORE IMAGES:
// // //   // 1. Upload your image to: public/assets/img/
// // //   // 2. Add the path below: "/assets/img/your-image-name.jpg"
// // // ];

// // // /* ── "See the Magic Happen" Event Reels ── */
// // // const MAGIC_REELS = [
// // //   { id:1, name:"Kids Special Car Entry", event:"Priya's Princess Birthday", theme:"Princess Royal", img:"/assets/videos/a1.png", video:"/assets/videos/Car_Entry.mp4" },
// // //   { id:2, name:"Private theatre show", event:"Sanvika's Princess Birthday", theme:"Royal Theme", img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80", video:"/assets/videos/Private_Theatres.mp4" },
// // //   { id:3, name:"Kids Birthday Party", event:"Pranav's Birthday Party", theme:"Superhero Academy", img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=800&q=80", video:"/assets/videos/Kids_Birthday.mp4" },
// // //   { id:4, name:"Little_bundle_of_joy", event:"Svojass's Birthday", theme:"Royal Theme", img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80", video:"/assets/videos/Little_bundle_of_joy_Svojass.mp4" },
// // //   { id:5, name:"Ayansh Tej’s 2nd Birthday", event:"Birthday Bash", theme:"Car Special Entry", img:"https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=800&q=80", video:"/assets/videos/Ayansh_Birthday.mp4" },
// // //   { id:6, name:"Little angel Dhanvika", event:"Second Birthday", theme:"Royal Theme", img:"/assets/videos/a2.png", video:"/assets/videos/Angel_Dhanvika.mp4" },
// // // ];
// // // // UPDATE VIDEO PATHS ABOVE:
// // // // Replace "/assets/videos/video1.mp4" with your actual video file path
// // // // Example: "/assets/videos/birthday-party.mp4" or "/assets/img/party.mp4"

// // // /* Fallback when API returns nothing */
// // // const FALLBACK_VIDEOS = [
// // //   { videoId:"dQw4w9WgXcQ", name:"Riya's Princess Party",   role:"Princess Royal Theme", profileImage:"" },
// // //   { videoId:"dQw4w9WgXcQ", name:"Arjun's Superhero Bash",  role:"Superhero Academy",    profileImage:"" },
// // //   { videoId:"dQw4w9WgXcQ", name:"Ananya's Candyland Day",  role:"Candyland Theme",      profileImage:"" },
// // // ];

// // // const FALLBACK_TEXT = [
// // //   { name:"Riya Sharma",  role:"Parent of 6 yr old", rating:5, description:"My daughter's princess party was absolutely magical! The decor left every parent speechless. She still talks about it every single day.", avatar:"RS", image:"https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=500&q=80", occasion:"Princess Royal Theme" },
// // //   { name:"Amit Patel",   role:"Parent of 8 yr old", rating:5, description:"The superhero theme was an absolute hit! Professional setup, amazing activities, and the team handled everything perfectly. 10/10!", avatar:"AP", image:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=500&q=80", occasion:"Superhero Academy" },
// // //   { name:"Neha Gupta",   role:"Parent of 4 yr old", rating:5, description:"Dinosaur theme exceeded all expectations. The kids were completely amazed. Worth every rupee — best birthday ever!", avatar:"NG", image:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=500&q=80", occasion:"Dinosaur Adventure" },
// // //   { name:"Priya Reddy",  role:"Parent of 7 yr old", rating:5, description:"Booked Candyland for my daughter. The place was transformed beyond imagination. Every detail was perfect!", avatar:"PR", image:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=500&q=80", occasion:"Candyland Theme" },
// // //   { name:"Suresh Kumar", role:"Parent of 5 yr old", rating:5, description:"Space Explorer theme for my son's birthday was out of this world! The team was so professional and the kids loved every minute.", avatar:"SK", image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80", occasion:"Space Explorer" },
// // //   { name:"Divya Rao",    role:"Parent of 9 yr old", rating:5, description:"The Royal Celebration package was worth every penny. The photographer captured the most beautiful memories we'll treasure forever.", avatar:"DR", image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=500&q=80", occasion:"Royal Celebration" },
// // // ];

// // // /* ══════════════════════════════════════════════════════════════════════════ */
// // // export default function KidsPage() {
// // //   const [isLoading,  setIsLoading]  = useState(true);
// // //   const [themeIdx,   setThemeIdx]   = useState(0);
// // //   const [activeFaq,  setActiveFaq]  = useState(null);
// // //   const [showPopup,  setShowPopup]  = useState(false);
// // //   const [popupImage, setPopupImage] = useState("");
// // //   const [activeGal,  setActiveGal]  = useState(0);
// // //   const [reelIdx,    setReelIdx]    = useState(0);
// // //   const [reelHover,  setReelHover]  = useState(false);
// // //   const [playingReel, setPlayingReel] = useState(null);
// // //   const [videoPage,  setVideoPage]  = useState(0);
// // //   const [reviewPage, setReviewPage] = useState(0);
// // //   const [videoTesti, setVideoTesti] = useState([]);
// // //   const [textTesti,  setTextTesti]  = useState([]);
// // //   const galleria = useRef(null);
// // //   const videoRef = useRef(null);
// // //   const navigate = useNavigate();
// // //   const [form, setForm] = useState({ name:"", email:"", mobileNumber:"", childAge:"", theme:"", date:"", guests:"" });

// // //   useEffect(() => {
// // //     axios.post("https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle")
// // //       .then(r => {
// // //         if (r.data?.success && Array.isArray(r.data.testimoni)) {
// // //           const active = r.data.testimoni.filter(t => t.status === "active");
// // //           const videos = active.filter(t => t.videoId?.trim());
// // //           setVideoTesti(videos.length ? videos : FALLBACK_VIDEOS);
// // //           const reviews = active.map(t => ({
// // //             name:t.name, role:t.role||"Parent", rating:Number(t.rating)||5,
// // //             description:t.description||"",
// // //             image:`https://api.carnivalcastle.com/${t.image}`,
// // //             avatar:`https://api.carnivalcastle.com/${t.profileImage}`,
// // //             occasion:t.type==="Yes"?"Special Celebration":"",
// // //           }));
// // //           setTextTesti(reviews.length ? reviews : FALLBACK_TEXT);
// // //         } else { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); }
// // //       })
// // //       .catch(() => { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); });

// // //     const t = setTimeout(() => setIsLoading(false), 700);
// // //     return () => clearTimeout(t);
// // //   }, []);

// // //   useEffect(() => {
// // //     const t = setInterval(() => setThemeIdx(i => (i + 1) % KID_THEMES.length), 3500);
// // //     return () => clearInterval(t);
// // //   }, []);

// // //   useEffect(() => {
// // //     const t = setInterval(() => {
// // //       if (!reelHover) {
// // //         setReelIdx(i => (i + 1) % MAGIC_REELS.length);
// // //       }
// // //     }, 4000);
// // //     return () => clearInterval(t);
// // //   }, [reelHover]);

// // //   // Extended reels array for infinite loop (prevents empty cards) — MEMOIZED for performance
// // //   const extendedReels = useMemo(() => [...MAGIC_REELS, ...MAGIC_REELS.slice(0, 3)], []);

// // //   const W = typeof window !== "undefined" ? window.innerWidth : 1200;
// // //   const VIDS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
// // //   const REVS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
// // //   const totalVP  = Math.max(1, Math.ceil(videoTesti.length / VIDS_PER));
// // //   const totalRP  = Math.max(1, Math.ceil(textTesti.length  / REVS_PER));
// // //   const visVids  = videoTesti.slice(videoPage  * VIDS_PER, (videoPage  + 1) * VIDS_PER);
// // //   const visRevs  = textTesti.slice( reviewPage * REVS_PER, (reviewPage + 1) * REVS_PER);

// // //   const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
// // //   const handleSubmit = e => {
// // //     e.preventDefault();
// // //     toast.success("🎉 Amazing! We'll call you within 2 hours to plan the perfect party!");
// // //     setForm({ name:"", email:"", mobileNumber:"", childAge:"", theme:"", date:"", guests:"" });
// // //   };

// // //   const galItem  = src => <img src={src} alt="" style={{ width:"100%", display:"block", borderRadius:14 }} />;
// // //   const galThumb = src => <img src={src} alt="" style={{ width:58, height:58, objectFit:"cover", display:"block", borderRadius:8 }} />;

// // //   if (isLoading) return (
// // //     <div style={{ background:C.dark, height:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:18 }}>
// // //       <div style={{ width:68, height:68, border:`4px solid ${C.primaryPale}`, borderTop:`4px solid ${C.gold}`, borderRadius:"50%", animation:"_spin 1s linear infinite" }} />
// // //       <p style={{ color:C.gold, fontWeight:600, letterSpacing:2, fontSize:14 }}>Loading Magic…</p>
// // //       <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
// // //     </div>
// // //   );

// // //   return (
// // //     <>
// // //       <Helmet>
// // //         <title>Carnival Castle Kids | Magical Birthday Parties in Hyderabad</title>
// // //         <meta name="description" content="Themed birthday parties for kids — Princess, Superhero, Dino & 20+ themes. Premium packages from ₹4,999." />
// // //       </Helmet>

// // //       {/* ════════════ GLOBAL STYLES — mirrors Home.jsx exactly ════════ */}
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// // //         :root{
// // //           --p:${C.primary};--pl:${C.primaryLight};--pd:${C.primaryDeep};
// // //           --pp:${C.primaryPale};--cream:${C.cream};--beige:${C.beige};
// // //           --gold:${C.gold};--gl:${C.goldLight};--gb:${C.goldBright};
// // //           --dark:${C.dark};--dark2:${C.dark2};
// // //         }
// // //         *,*::before,*::after{box-sizing:border-box;}
// // //         .kp-root,  .kp-root *{font-family:'DM Sans',sans-serif;}
// // //         .pf{font-family:'Playfair Display',serif!important;}

// // //         /* ── Keyframes ── */
// // //         @keyframes _fadeUp  {from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
// // //         @keyframes _float   {0%,100%{transform:translateY(0) rotate(0)}50%{transform:translateY(-14px) rotate(3deg)}}
// // //         @keyframes _shine   {0%{left:-100%}25%{left:130%}100%{left:130%}}
// // //         @keyframes _goldBg  {0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
// // //         @keyframes _ticker  {from{transform:translateX(0)}to{transform:translateX(-50%)}}
// // //         @keyframes _pulse   {0%,100%{transform:scale(1)}50%{transform:scale(1.03)}}
// // //         @keyframes _confetti{0%{transform:translateY(-10px) rotate(0);opacity:1}100%{transform:translateY(90px) rotate(720deg);opacity:0}}

// // //         /* ── Scroll Reveal (same as Home) ── */
// // //         .rv{opacity:0;transform:translateY(32px);transition:opacity .7s ease,transform .7s cubic-bezier(.16,1,.3,1);}
// // //         .rv.in{opacity:1;transform:translateY(0);}
// // //         .rv.d1{transition-delay:.1s}.rv.d2{transition-delay:.2s}.rv.d3{transition-delay:.3s}.rv.d4{transition-delay:.4s}

// // //         /* ── Section spacing ── */
// // //         .kp-sec{padding:72px 0;}
// // //         .kp-sec-sm{padding:44px 0;}

// // //         /* ── Typography — identical class names as Home ── */
// // //         .cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
// // //         .cc-tag-light{color:var(--gl)!important;}
// // //         .cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
// // //         .cc-h-white{color:#fff!important;}
// // //         .cc-h span{color:var(--p);}
// // //         .cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
// // //         .cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
// // //         .cc-sub-light{color:rgba(255,255,255,.55)!important;}

// // //         /* ── Buttons — same as Home ── */
// // //         .cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;box-shadow:0 6px 20px rgba(94,14,115,.35);text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// // //         .cc-btn:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(94,14,115,.45);color:#fff;}
// // //         .cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// // //         .cc-btn-outline:hover{background:var(--p);color:#fff;}
// // //         .cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,var(--gold),var(--gb),var(--gold),#9A6E10);background-size:200% 200%;animation:_goldBg 3s ease infinite;color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;box-shadow:0 6px 20px rgba(201,168,76,.45);text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .3s,box-shadow .3s;}
// // //         .cc-btn-gold::before{content:'';position:absolute;top:0;left:-100%;width:55%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.4),transparent);animation:_shine 3s ease infinite;}
// // //         .cc-btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(201,168,76,.55);color:var(--dark);}
// // //         .wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .3s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;box-shadow:0 6px 20px rgba(37,211,102,.3);font-family:'DM Sans',sans-serif;}
// // //         .wa-btn:hover{background:#1ebe5d;transform:translateY(-2px);color:#fff;}

// // //         /* ── Ticker — same as Home ── */
// // //         .kp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
// // //         .kp-ticker-track{display:flex;width:max-content;animation:_ticker 22s linear infinite;}
// // //         .kp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

// // //         /* ── Hero — mirrors Home hero ── */
// // //         .kp-hero{position:relative;min-height:88vh;overflow:hidden;background:linear-gradient(135deg,rgba(26,0,48,.7) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.8) 100%),url('https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=1200&q=80') center/cover no-repeat;background-attachment:fixed;display:flex;align-items:center;}
// // //         .kp-hero-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
// // //         .kp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
// // //         .kp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.1);border:1px solid rgba(201,168,76,.32);backdrop-filter:blur(12px);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
// // //         .kp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 4px 24px rgba(0,0,0,.3);}
// // //         .kp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
// // //         .kp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
// // //         .kp-hero-img{width:100%;border-radius:32px;border:3px solid rgba(201,168,76,.35);box-shadow:0 40px 80px rgba(0,0,0,.45);display:block;object-fit:cover;aspect-ratio:4/5;}
// // //         .kp-hero-float{position:absolute;background:#fff;border-radius:16px;padding:12px 16px;box-shadow:0 14px 36px rgba(0,0,0,.2);animation:_float 4s ease-in-out infinite;white-space:nowrap;}
// // //         .kp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
// // //         .kp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
// // //         .kp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}
// // //         @media(max-width:768px){
// // //           .kp-hero{min-height:auto;padding:50px 16px 30px!important;}
// // //           .kp-hero-cnt{padding:40px 0 30px;display:flex;flex-direction:column;}
// // //           .kp-hero-title{font-size:clamp(24px,5vw,36px)!important;}
// // //           .kp-hero-sub{font-size:clamp(13px,3vw,15px)!important;margin-bottom:20px;}
// // //           .kp-hero-img{max-width:100%;border-radius:20px;border:2px solid rgba(201,168,76,.35);}
// // //           .kp-trust-row{gap:14px;margin-top:20px;}
// // //           .kp-trust-item .num{font-size:20px;}
// // //           .kp-trust-item .lbl{font-size:9px;}
// // //           /* Cards and sections */
// // //           .kids-section-title{font-size:clamp(20px,4vw,28px)!important;margin-bottom:20px;}
// // //           .theme-carousel{gap:10px;padding:10px 0;}
// // //           .theme-card{width:160px;}
// // //           .theme-card img{height:120px;}
// // //           .kids-card{margin-bottom:16px;}
// // //           .pkg-grid{gap:12px;flex-wrap:wrap;}
// // //           .pkg-card{flex:0 1 calc(50% - 6px) !important;}
// // //           .popular-ribbon{padding:4px 35px;font-size:10px;}
// // //           .gallery-grid{grid-template-columns:repeat(2,1fr);gap:10px;}
// // //           .testimonial-card{padding:16px;}
// // //           .testimonial-avatar{width:40px;height:40px;}
// // //           .faq-item{padding:12px;margin-bottom:8px;}
// // //           .form-group input,.form-group textarea{padding:10px 12px;font-size:13px;}
// // //           .submit-btn{padding:12px 24px;font-size:13px;}
// // //           .why-card-lt{padding:18px 14px;}
// // //           .activity-grid{grid-template-columns:repeat(2,1fr);gap:10px;}
// // //         }
// // //         @media(max-width:640px){
// // //           .kp-hero{padding:40px 12px 24px!important;}
// // //           .kp-hero-cnt{padding:30px 0 20px;}
// // //           .kp-hero-title{font-size:clamp(20px,5vw,28px)!important;}
// // //           .kp-hero-sub{font-size:12px;margin-bottom:16px;}
// // //           .container{padding:0 12px;}
// // //           .kids-section-title{font-size:clamp(18px,4vw,22px)!important;margin-bottom:14px;}
// // //           .kids-section-tag{font-size:10px;padding:4px 10px;}
// // //           .theme-carousel{gap:8px;padding:6px 0;}
// // //           .theme-card{width:130px;}
// // //           .theme-card img{height:110px;}
// // //           .kids-package-card{padding:16px;}
// // //           .pkg-card{flex:0 1 100% !important;padding:14px;}
// // //           .popular-ribbon{padding:4px 30px;font-size:9px;right:-25px;}
// // //           .gallery-grid{grid-template-columns:1fr;gap:8px;}
// // //           .gallery-item{aspect-ratio:1;}
// // //           .testimonial-card{padding:12px;border-radius:12px;}
// // //           .testimonial-avatar{width:36px;height:36px;}
// // //           .testimonial-header{gap:10px;}
// // //           .testimonial-name{font-size:12px;}
// // //           .testimonial-text{font-size:11px;}
// // //           .faq-item{padding:10px;margin-bottom:6px;}
// // //           .kp-faq-q{padding:12px 14px;font-size:13px;}
// // //           .kp-faq-a{padding:0 14px 12px;font-size:12px;}
// // //           .form-group label{font-size:12px;}
// // //           .form-group input,.form-group textarea{padding:9px 10px;font-size:12px;}
// // //           .submit-btn{padding:11px 20px;font-size:12px;}
// // //           .why-card-lt{padding:14px 10px;border-radius:16px;}
// // //           .why-icon{font-size:36px;margin-bottom:10px;}
// // //           .why-title{font-size:14px;}
// // //           .why-desc{font-size:11px;}
// // //           .activity-grid{grid-template-columns:1fr;gap:8px;}
// // //           .magic-reel-card{width:100px;height:180px;}
// // //           .magic-reel-name{font-size:10px;}
// // //           .magic-reel-event{font-size:7px;}
// // //           .magic-video-container{width:95%;height:60vh;border-radius:14px;}
// // //           .magic-video-player{aspect-ratio:9/16;}
// // //           .magic-video-title{font-size:14px;}
// // //           .magic-video-event{font-size:11px;}
// // //           .process-step{text-align:center;margin-bottom:12px;}
// // //           .process-icon{width:48px;height:48px;font-size:22px;}
// // //           .process-title{font-size:13px;}
// // //           .process-desc{font-size:11px;}
// // //           .addon-grid{grid-template-columns:1fr;gap:8px;}
// // //           .addon-icon{font-size:24px;}
// // //           .addon-name{font-size:10px;}
// // //           .addon-price{font-size:12px;}
// // //           /* Touch-friendly buttons */
// // //           button, .pkg-btn, .submit-btn, .magic-arrow-btn {
// // //             min-height:44px !important;
// // //             min-width:44px !important;
// // //             padding:12px 16px !important;
// // //           }
// // //           /* Improved touch spacing */
// // //           a[href], button { margin: 4px; }
// // //           .enq-label { margin-bottom: 6px; }
// // //           .form-group { margin-bottom: 14px; }
// // //           .pkg-card { margin-bottom: 8px; }
// // //           .testimonial-card { margin-bottom: 12px; }
// // //         }

// // //         /* ── Why cards ── */
// // //         .why-card-lt{background:#fff;border-radius:24px;padding:28px 20px;text-align:center;border:1px solid rgba(94,14,115,.07);box-shadow:0 6px 24px rgba(94,14,115,.08);transition:all .4s cubic-bezier(.25,1,.5,1);}
// // //         .why-card-lt:hover{transform:translateY(-10px);box-shadow:0 22px 52px rgba(94,14,115,.14);border-color:rgba(201,168,76,.32);}
// // //         .why-icon-wrap{width:74px;height:74px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:32px;margin:0 auto 16px;background:linear-gradient(135deg,rgba(94,14,115,.1),rgba(94,14,115,.03));border:2px solid rgba(94,14,115,.09);animation:_float 5s ease-in-out infinite;}

// // //         /* ── Theme carousel (same .theme-card as Home) ── */
// // //         .theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
// // //         .theme-card:hover{transform:translateY(-6px);}
// // //         .theme-img{width:100%;height:320px;object-fit:cover;transition:transform .5s;display:block;}
// // //         .theme-card:hover .theme-img{transform:scale(1.06);}
// // //         .theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.92) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
// // //         .theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
// // //         .theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
// // //         .theme-tag{background:rgba(255,255,255,.12);backdrop-filter:blur(4px);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
// // //         .kp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);backdrop-filter:blur(8px);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

// // //         /* ── Services (same .svc-card as Home) ── */
// // //         .svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
// // //         @media(max-width:1024px){.svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
// // //         @media(max-width:540px) {.svc-grid{grid-template-columns:1fr 1fr;gap:12px;}}
// // //         .svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);box-shadow:0 4px 22px rgba(94,14,115,.07);transition:transform .4s cubic-bezier(.25,1,.5,1),box-shadow .4s;cursor:pointer;position:relative;}
// // //         .svc-card:hover{transform:translateY(-12px);box-shadow:0 26px 62px rgba(94,14,115,.18);}
// // //         .svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .4s cubic-bezier(.25,1,.5,1),left .4s cubic-bezier(.25,1,.5,1);}
// // //         .svc-card:hover::after{width:100%;left:0;}
// // //         .svc-img-wrap{position:relative;height:200px;overflow:hidden;}
// // //         .svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .55s;}
// // //         .svc-card:hover .svc-img{transform:scale(1.09);}
// // //         .svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.5) 0%,transparent 60%);opacity:0;transition:opacity .35s;}
// // //         .svc-card:hover .svc-glow{opacity:1;}
// // //         .svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);backdrop-filter:blur(8px);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
// // //         .svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .35s,opacity .35s;}
// // //         .svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
// // //         .svc-body{padding:22px 14px 18px;position:relative;}
// // //         .svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;box-shadow:0 5px 14px rgba(94,14,115,.35);transition:transform .3s;}
// // //         .svc-card:hover .svc-float-icon{transform:rotate(-8deg) scale(1.1);}
// // //         .svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .25s;}
// // //         .svc-card:hover .svc-title{color:var(--p);}
// // //         .svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .4s cubic-bezier(.25,1,.5,1);}
// // //         .svc-card:hover .svc-line{width:42px;}
// // //         .svc-desc{font-size:12px;color:#888;line-height:1.6;}

// // //         /* ── Packages ── */
// // //         .pkg-card{border-radius:26px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);transition:all .4s cubic-bezier(.25,1,.5,1);cursor:pointer;position:relative;}
// // //         .pkg-card:hover{transform:translateY(-12px);box-shadow:0 30px 70px rgba(0,0,0,.4);}
// // //         .pkg-card.featured{border-color:rgba(201,168,76,.5);box-shadow:0 0 40px rgba(201,168,76,.12);}
// // //         .pkg-pop-chip{position:absolute;top:16px;right:16px;z-index:3;background:linear-gradient(135deg,var(--gold),var(--gb));color:var(--dark);padding:5px 13px;border-radius:60px;font-size:10px;font-weight:800;letter-spacing:1px;text-transform:uppercase;}
// // //         .pkg-feat{display:flex;align-items:center;gap:10px;font-size:13px;color:rgba(255,255,255,.75);padding:5px 0;}
// // //         .pkg-feat-dot{width:18px;height:18px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:9px;}

// // //         /* ── Activities ── */
// // //         .act-card{border-radius:18px;overflow:hidden;background:#fff;box-shadow:0 5px 18px rgba(94,14,115,.08);transition:all .4s;cursor:pointer;border:1px solid rgba(94,14,115,.07);}
// // //         .act-card:hover{transform:translateY(-8px) scale(1.02);box-shadow:0 20px 44px rgba(94,14,115,.17);}

// // //         /* ══ TESTIMONIALS — same structure as Home ══ */
// // //         .testi-sec{padding:80px 0;background:linear-gradient(160deg,var(--dark) 0%,#2A0040 40%,var(--dark) 100%);position:relative;overflow:hidden;}
// // //         .testi-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 50% at 50% 50%,rgba(94,14,115,.2) 0%,transparent 70%);pointer-events:none;}

// // //         /* Video grid */
// // //         .vtesti-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-bottom:26px;}
// // //         @media(max-width:1024px){.vtesti-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
// // //         @media(max-width:640px) {.vtesti-grid{grid-template-columns:1fr;gap:14px;}}
// // //         .vtesti-card{border-radius:20px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.2);transition:transform .35s,box-shadow .35s,border-color .35s;}
// // //         .vtesti-card:hover{transform:translateY(-8px);box-shadow:0 24px 60px rgba(0,0,0,.4);border-color:rgba(201,168,76,.4);}
// // //         .vtesti-iframe-wrap{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;}
// // //         .vtesti-iframe-wrap iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;display:block;}
// // //         .vtesti-footer{padding:14px 16px;display:flex;align-items:center;gap:10px;}
// // //         .vtesti-name{font-weight:700;font-size:14px;color:var(--gl);margin-bottom:2px;}
// // //         .vtesti-role{font-size:11px;color:rgba(255,255,255,.4);}

// // //         /* Photo review grid */
// // //         .rtesti-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;}
// // //         @media(max-width:1024px){.rtesti-grid{grid-template-columns:repeat(2,1fr);gap:16px;}}
// // //         @media(max-width:640px) {.rtesti-grid{grid-template-columns:1fr;gap:14px;}}
// // //         .rtesti-card{border-radius:20px;overflow:hidden;background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.15);transition:transform .35s,box-shadow .35s,border-color .35s;}
// // //         .rtesti-card:hover{transform:translateY(-6px);box-shadow:0 20px 50px rgba(0,0,0,.3);border-color:rgba(201,168,76,.35);}
// // //         .rtesti-photo{position:relative;height:150px;overflow:hidden;}
// // //         .rtesti-photo img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .4s;}
// // //         .rtesti-card:hover .rtesti-photo img{transform:scale(1.05);}
// // //         .rtesti-photo-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
// // //         .rtesti-body{padding:18px;}
// // //         .rtesti-header{display:flex;align-items:center;gap:12px;margin-bottom:12px;}
// // //         .rtesti-av-img{width:48px;height:48px;border-radius:50%;object-fit:cover;border:2px solid var(--gold);flex-shrink:0;}
// // //         .rtesti-av-fb{width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:17px;font-weight:800;color:#fff;flex-shrink:0;border:2px solid var(--gold);}
// // //         .rtesti-name{font-weight:700;font-size:15px;color:#fff;margin-bottom:2px;}
// // //         .rtesti-role{font-size:11px;color:rgba(255,255,255,.4);}
// // //         .rtesti-stars{color:var(--gold);font-size:14px;letter-spacing:2px;margin-bottom:10px;}
// // //         .rtesti-text{font-size:13px;color:rgba(255,255,255,.68);line-height:1.75;font-style:italic;}
// // //         .rtesti-occ{font-size:11px;color:var(--gold);font-weight:600;margin-top:10px;}

// // //         /* Pagination — same as Home */
// // //         .testi-page-dots{display:flex;justify-content:center;gap:8px;margin-top:22px;}
// // //         .testi-pd{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .3s;}
// // //         .testi-pd.on{width:28px;border-radius:4px;background:linear-gradient(90deg,var(--gold),var(--gl));}
// // //         .testi-nav{display:flex;gap:10px;justify-content:flex-end;align-items:center;margin-bottom:18px;}
// // //         .testi-nav-btn{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.18);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;}
// // //         .testi-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}

// // //         /* ── Gallery bento — same as Home ── */
// // //         .gal-bento{display:grid;grid-template-columns:repeat(12,1fr);gap:14px;margin-bottom:8px;}
// // //         .gbi-1{grid-column:span 5;grid-row:span 2;min-height:370px;}
// // //         .gbi-2{grid-column:span 4;min-height:178px;}
// // //         .gbi-3{grid-column:span 3;min-height:178px;}
// // //         .gbi-4{grid-column:span 4;min-height:178px;}
// // //         .gbi-5{grid-column:span 3;min-height:178px;}
// // //         .gbi-6{grid-column:span 7;min-height:215px;}
// // //         .gal-bento-item{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;background:var(--dark);opacity:0;transform:translateY(28px) scale(.97);transition:opacity .6s ease,transform .6s cubic-bezier(.25,1,.5,1),box-shadow .35s;}
// // //         .gal-bento-item.in{opacity:1;transform:translateY(0) scale(1);}
// // //         .gal-bento-item:hover{box-shadow:0 22px 60px rgba(94,14,115,.26);z-index:2;}
// // //         .gal-bento-item img{width:100%;height:100%;object-fit:cover;display:block;position:absolute;inset:0;transition:transform .6s cubic-bezier(.25,1,.5,1);}
// // //         .gal-bento-item:hover img{transform:scale(1.05);}
// // //         .gal-bento-ovl{position:absolute;inset:0;background:rgba(94,14,115,.35);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;font-size:28px;color:#fff;}
// // //         .gal-bento-item:hover .gal-bento-ovl{opacity:1;}
// // //         @media(max-width:1024px){
// // //           .gal-bento{grid-template-columns:repeat(6,1fr);gap:12px;}
// // //           .gbi-1{grid-column:span 3;grid-row:span 2;min-height:290px;}
// // //           .gbi-2{grid-column:span 3;min-height:140px;}
// // //           .gbi-3{grid-column:span 3;min-height:140px;}
// // //           .gbi-4,.gbi-5{grid-column:span 2;min-height:155px;}
// // //           .gbi-6{grid-column:span 2;min-height:155px;}
// // //         }
// // //         @media(max-width:640px){
// // //           .gal-bento{grid-template-columns:1fr 1fr;gap:10px;}
// // //           .gbi-1{grid-column:span 2;min-height:195px;grid-row:span 1;}
// // //           .gbi-2,.gbi-3,.gbi-4,.gbi-5{grid-column:span 1;min-height:145px;}
// // //           .gbi-6{grid-column:span 2;min-height:155px;}
// // //         }

// // //         /* ── Magic Reels Carousel — Instagram Reel Size ── */
// // //         .magic-reels-wrap{position:relative;overflow:hidden;width:100%;max-width:682px;margin:0 auto;scroll-snap-type:x mandatory;}
// // //         .magic-reel-track{display:flex;gap:14px;transition:transform 0.6s cubic-bezier(.25,1,.5,1);width:fit-content;scroll-snap-type:x mandatory;will-change:transform;transform:translateZ(0);backface-visibility:hidden;}
// // //         .magic-reel-card{flex-shrink:0;width:160px;height:305px;border-radius:20px;overflow:hidden;position:relative;cursor:pointer;background:#000;transition:transform .35s,box-shadow .35s;aspect-ratio:9/16;scroll-snap-align:center;scroll-snap-stop:always;will-change:transform;transform:translateZ(0);}
// // //         .magic-reel-card:hover{transform:translateY(-8px) scale(1.03);box-shadow:0 20px 50px rgba(94,14,115,.3);}
// // //         .magic-reel-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
// // //         .magic-reel-card:hover .magic-reel-img{transform:scale(1.08);}
// // //         .magic-reel-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.95) 0%,rgba(26,0,48,.4) 50%,transparent 100%);display:flex;flex-direction:column;justify-content:flex-end;padding:14px;transition:opacity .3s;}
// // //         .magic-reel-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:50px;height:50px;border-radius:50%;background:rgba(201,168,76,.92);display:flex;align-items:center;justify-content:center;font-size:20px;transition:all .3s;box-shadow:0 8px 25px rgba(201,168,76,.5);z-index:2;cursor:pointer;will-change:transform;}
// // //         .magic-reel-card:hover .magic-reel-play{background:var(--gold);transform:translate(-50%,-50%) scale(1.12);}
// // //         .magic-reel-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:2px;line-height:1.2;}
// // //         .magic-reel-event{font-size:8px;color:rgba(255,255,255,.65);margin-bottom:4px;}
// // //         .magic-reel-theme{display:inline-block;background:rgba(201,168,76,.25);color:var(--gold);font-size:8px;font-weight:700;padding:2px 8px;border-radius:50px;border:1px solid rgba(201,168,76,.5);}
// // //         .magic-nav-arrows{display:flex;gap:12px;justify-content:center;margin-top:20px;}
// // //         .magic-arrow-btn{width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.1);border:1.5px solid rgba(255,255,255,.2);color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;font-weight:bold;will-change:transform;}
// // //         .magic-arrow-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.05);}
        
// // //         /* Video Modal */
// // //         .magic-video-modal{position:fixed;inset:0;background:rgba(0,0,0,.92);backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;z-index:9999;animation:_fadeUp .3s ease-out;}
// // //         .magic-video-close{position:absolute;top:20px;right:20px;width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:#fff;font-size:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .2s;z-index:10000;}
// // //         .magic-video-close:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}
// // //         .magic-video-container{width:90%;max-width:1100px;height:85vh;background:#000;border-radius:20px;overflow:hidden;box-shadow:0 40px 80px rgba(0,0,0,.8);display:flex;flex-direction:column;}
// // //         .magic-video-player{width:100%;height:100%;display:block;object-fit:contain;}
// // //         .magic-video-info{padding:20px 24px;background:var(--dark);color:#fff;}
// // //         .magic-video-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;margin-bottom:6px;}
// // //         .magic-video-event{font-size:14px;color:rgba(255,255,255,.6);margin-bottom:8px;}
// // //         .magic-video-theme{display:inline-block;background:rgba(201,168,76,.2);color:var(--gold);font-size:11px;font-weight:700;padding:5px 12px;border-radius:50px;border:1px solid rgba(201,168,76,.4);}
// // //         @media(max-width:768px){.magic-video-container{width:95%;height:70vh;}.magic-video-player{aspect-ratio:9/16;}}
// // //         @media(max-width:640px){.magic-video-container{width:95%;height:60vh;border-radius:14px;}.magic-video-player{aspect-ratio:9/16;}}

// // //         /* ── FAQ ── */
// // //         .kp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:all .3s;margin-bottom:12px;}
// // //         .kp-faq-item:hover{border-color:rgba(201,168,76,.4);box-shadow:0 7px 18px rgba(94,14,115,.09);}
// // //         .kp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
// // //         .kp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
// // //         .kp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .3s,background .3s;font-size:15px;color:var(--p);}
// // //         .kp-faq-item.open .kp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

// // //         /* ── Enquiry Form — same enq-* as Home ── */
// // //         .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;box-shadow:0 22px 56px rgba(94,14,115,.4);}
// // //         .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
// // //         .enq-right{background:#fff;padding:40px 36px;}
// // //         .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
// // //         .enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s;color:var(--dark);}
// // //         .enq-input:focus{border-color:var(--p);box-shadow:0 0 0 3px rgba(94,14,115,.08);}
// // //         .enq-input option{background:var(--dark);color:#fff;}
// // //         .enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
// // //         .enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
// // //         .enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
// // //         .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}
// // //         @media(max-width:991px){.enq-left{padding:28px 20px;}.enq-right{padding:24px 18px;}}

// // //         /* ── Nav arrows ── */
// // //         .cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .25s;}
// // //         .cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);}

// // //         /* ── CTA Banner ── */
// // //         .kp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);background-size:300% 300%;animation:_goldBg 6s ease infinite;}
// // //         .kp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.08) 0%,transparent 70%);pointer-events:none;}

// // //         /* ── Ornament divider ── */
// // //         .kp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
// // //         .kp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
// // //         .kp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

// // //         /* ── Global responsive ── */
// // //         @media(max-width:576px){
// // //           .kp-sec{padding:48px 0;}
// // //           .kp-sec-sm{padding:30px 0;}
// // //           .container{padding-left:16px;padding-right:16px;}
// // //           .cc-h{font-size:clamp(23px,7vw,32px);}
// // //         }
// // //       `}</style>

// // //       <ScrollRevealWatcher />

// // //       <div className="kp-root">
// // //         <Header />

// // //         {/* ══ TICKER ══════════════════════════════════════════════════ */}
// // //         <div className="kp-ticker">
// // //           <div className="kp-ticker-track">
// // //             {[...Array(4)].map((_, k) =>
// // //               ["🎈 20+ Magical Themes","⭐ 2000+ Happy Parties","🛡️ 100% Child Safe","📸 Photography Included","⚡ Book in 2 Minutes","🎂 Custom Cakes Available"].map((item, i) => (
// // //                 <span key={`${k}-${i}`} className="kp-ticker-item">{item}</span>
// // //               ))
// // //             )}
// // //           </div>
// // //         </div>

// // //         {/* ══ HERO ════════════════════════════════════════════════════ */}
// // //         <section className="kp-hero">
// // //           <div className="kp-hero-orb" style={{ width:500, height:500, background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`, top:-100, right:-80 }} />
// // //           <div className="kp-hero-orb" style={{ width:300, height:300, background:`radial-gradient(circle,rgba(236,72,153,.16) 0%,transparent 70%)`, bottom:80, left:-60 }} />

// // //           <div className="container kp-hero-cnt">
// // //             <div className="row align-items-center g-5">
// // //               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both" }}>
// // //                 <div className="kp-hero-badge">🎉 Hyderabad's #1 Kids Party Venue</div>
// // //                 <h1 className="kp-hero-title pf">
// // //                   Create <span>Magical</span><br />Birthday Memories
// // //                 </h1>
// // //                 <p className="kp-hero-sub">
// // //                   From princess castles to dino adventures — 20+ incredible themes, professional setups, and memories your child will cherish forever.
// // //                 </p>
// // //                 <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
// // //                   <button onClick={() => document.getElementById("packages")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎈 Explore Packages</button>
// // //                   <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-outline" style={{ borderColor:"rgba(255,255,255,.4)", color:"#fff" }}>📞 Get a Callback</button>
// // //                 </div>
// // //                 <div className="kp-trust-row">
// // //                   {[["2000+","Parties"],["4.9★","Rating"],["20+","Themes"]].map(([n, l]) => (
// // //                     <div key={l} className="kp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
// // //                   ))}
// // //                 </div>
// // //               </div>
// // //               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both" }}>
// // //                 <div style={{ position:"relative" }}>
// // //                   <img src="https://i.pinimg.com/736x/cf/c1/9c/cfc19c5f5a553b3cb0a6e3184b95cb89.jpg" alt="Kids Party" className="kp-hero-img" style={{ height:500 }} />
// // //                   <div className="kp-hero-float d-none d-md-block" style={{ bottom:32, left:-28, animationDelay:"0s" }}>
// // //                     <div style={{ fontSize:10, color:"#888", marginBottom:4, textTransform:"uppercase", letterSpacing:1 }}>Just Booked!</div>
// // //                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
// // //                       <span style={{ fontSize:18 }}>👑</span>
// // //                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>Princess Royal</div><div style={{ fontSize:11, color:C.primary }}>Priya's 5th Birthday</div></div>
// // //                     </div>
// // //                   </div>
// // //                   <div className="kp-hero-float d-none d-md-block" style={{ top:32, right:-28, animationDelay:"1.5s" }}>
// // //                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
// // //                       <span style={{ fontSize:18 }}>⭐</span>
// // //                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>4.9 / 5.0</div><div style={{ fontSize:11, color:"#888" }}>2000+ Happy Parties</div></div>
// // //                     </div>
// // //                   </div>
// // //                   <div style={{ position:"absolute", inset:-14, borderRadius:40, border:`2px solid rgba(201,168,76,.17)`, pointerEvents:"none", animation:"_pulse 3s ease-in-out infinite" }} />
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ WHY US ══════════════════════════════════════════════════ */}
// // //         {/* <section className="kp-sec" style={{ background:C.cream }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:52 }}>
// // //               <span className="cc-tag">✦ Why Parents Trust Us ✦</span>
// // //               <h2 className="cc-h">Parties That Are Safe, <span>Stunning</span> & Stress-Free</h2>
// // //               <p className="cc-sub">We handle every detail so you're fully present in your child's most magical moments.</p>
// // //             </div>
// // //             <div className="row g-4">
// // //               {WHY_US.map((item, i) => (
// // //                 <div key={i} className={`col-md-3 col-6 rv d${i + 1}`}>
// // //                   <div className="why-card-lt">
// // //                     <div className="why-icon-wrap" style={{ animationDelay:`${i * 0.5}s` }}>{item.icon}</div>
// // //                     <h3 className="pf" style={{ fontSize:16, fontWeight:700, color:C.dark, marginBottom:7 }}>{item.title}</h3>
// // //                     <p style={{ fontSize:12, color:"#888", lineHeight:1.6, margin:0 }}>{item.desc}</p>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section> */}

// // //         {/* ══ THEMES CAROUSEL ═════════════════════════════════════════ */}
// // //         <section className="kp-sec" style={{ background:C.dark, overflow:"hidden" }}>
// // //           <div className="container">
// // //             <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:44, flexWrap:"wrap", gap:20 }}>
// // //               <div>
// // //                 <span className="cc-tag cc-tag-light">✦ 20+ Dream Themes ✦</span>
// // //                 <h2 className="cc-h cc-h-white">Your Child's <span className="gold">Fantasy</span> Brought to Life</h2>
// // //               </div>
// // //               <div style={{ display:"flex", gap:10 }}>
// // //                 <button className="cc-nav-btn" onClick={() => setThemeIdx(i => (i - 1 + KID_THEMES.length) % KID_THEMES.length)}>‹</button>
// // //                 <button className="cc-nav-btn" onClick={() => setThemeIdx(i => (i + 1) % KID_THEMES.length)}>›</button>
// // //               </div>
// // //             </div>
// // //             <div style={{ overflow:"hidden" }}>
// // //               <div style={{ display:"flex", gap:18, transition:"transform .7s cubic-bezier(.25,1,.5,1)", transform:`translateX(calc(-${themeIdx * (280 + 18)}px))` }}>
// // //                 {[...KID_THEMES, ...KID_THEMES].map((t, i) => (
// // //                   <div key={i} className="theme-card" onClick={() => navigate("/locations")}>
// // //                     <div className="kp-emoji-badge">{t.emoji}</div>
// // //                     <img src={t.img} alt={t.name} className="theme-img" />
// // //                     <div className="theme-ovl">
// // //                       <div className="theme-name">{t.name}</div>
// // //                       <div className="theme-booked">🔥 {t.bookings} booked</div>
// // //                       <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginTop:8 }}>
// // //                         {t.tags.map((tg, j) => <span key={j} className="theme-tag">{tg}</span>)}
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </div>
// // //             <div style={{ display:"flex", gap:8, justifyContent:"center", marginTop:26 }}>
// // //               {KID_THEMES.map((_, i) => (
// // //                 <button key={i} onClick={() => setThemeIdx(i)} style={{ width:i === themeIdx ? 26 : 8, height:8, borderRadius:8, background:i === themeIdx ? C.gold : "rgba(255,255,255,.2)", border:"none", cursor:"pointer", transition:"all .4s" }} />
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ SERVICES ════════════════════════════════════════════════ */}
// // //         <section className="kp-sec" style={{ background:"#fff", overflow:"hidden" }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:44 }}>
// // //               <span className="cc-tag">✦ Party Services ✦</span>
// // //               <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Party</h2>
// // //               <p className="cc-sub">Decor, cakes, food, photography — curated to make your child's day perfect.</p>
// // //             </div>
// // //             <div className="kp-divider"><div className="kp-dl" /><div className="kp-dg" /><div className="kp-dl" /></div>
// // //             <div className="svc-grid rv">
// // //               {SERVICE_CARDS.map((s, i) => (
// // //                 <div key={i} className="svc-card">
// // //                   <div className="svc-img-wrap">
// // //                     <img src={s.img} alt={s.label} className="svc-img" />
// // //                     <div className="svc-glow" />
// // //                     <div className="svc-num">0{i + 1}</div>
// // //                     <div className="svc-pill">{["✨ Trending","🎂 Custom","🍽️ Fresh","📸 Pro"][i]}</div>
// // //                   </div>
// // //                   <div className="svc-body">
// // //                     <div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div>
// // //                     <div className="svc-title pf">{s.label}</div>
// // //                     <span className="svc-line" />
// // //                     <p className="svc-desc">{s.desc}</p>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ ACTIVITIES ══════════════════════════════════════════════ */}
// // //         <section className="kp-sec" style={{ background:C.cream }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:44 }}>
// // //               <span className="cc-tag">✦ Fun Activities ✦</span>
// // //               <h2 className="cc-h">Keep the Kids <span>Entertained All Day</span></h2>
// // //             </div>
// // //             <div className="row g-4">
// // //               {KID_ACTIVITIES.map((act, i) => (
// // //                 <div key={i} className={`col-md-3 col-6 rv d${i + 1}`}>
// // //                   <div className="act-card">
// // //                     <div style={{ overflow:"hidden", height:185 }}>
// // //                       <img src={act.img} alt={act.name} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block", transition:"transform .45s" }}
// // //                         onMouseOver={e => e.target.style.transform = "scale(1.07)"}
// // //                         onMouseOut={e => e.target.style.transform = "scale(1)"} />
// // //                     </div>
// // //                     <div style={{ padding:"14px" }}>
// // //                       <h3 style={{ fontSize:15, fontWeight:700, marginBottom:5, color:C.dark }}>{act.name}</h3>
// // //                       <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"#888" }}>
// // //                         <span>⏱️ {act.dur}</span><span>👶 {act.age}</span>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </section>

       

// // //         {/* ══ SEE THE MAGIC HAPPEN — Event Reels Carousel ══════════════ */}
// // //         <section className="kp-sec" style={{ background:C.dark, overflow:"hidden", padding:"48px 0" }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:32 }}>
// // //               <span className="cc-tag cc-tag-light">✦ Our Reels ✦</span>
// // //               <h2 className="cc-h cc-h-white">See the <span className="gold">Magic</span> Happen</h2>
// // //               <p className="cc-sub cc-sub-light">Watch real events — the energy, the joy, the unforgettable moments of our little guests.</p>
// // //             </div>

// // //             <div className="magic-reels-wrap" 
// // //               onMouseEnter={() => setReelHover(true)}
// // //               onMouseLeave={() => setReelHover(false)}>
// // //               <div className="magic-reel-track" style={{ transform:`translateX(calc(-${reelIdx * (160 + 14)}px))` }}>
// // //                 {extendedReels.map((reel, i) => (
// // //                   <div key={i} className="magic-reel-card" onClick={() => setPlayingReel(reel)}>
// // //                     <img src={reel.img} alt={reel.name} className="magic-reel-img" />
// // //                     <div className="magic-reel-play" onClick={e => { e.stopPropagation(); setPlayingReel(reel); }}>▶</div>
// // //                     <div className="magic-reel-ovl">
// // //                       <div className="magic-reel-name">{reel.name}</div>
// // //                       <div className="magic-reel-event">{reel.event}</div>
// // //                       <span className="magic-reel-theme">{reel.theme}</span>
// // //                     </div>
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </div>

// // //             <div className="magic-nav-arrows">
// // //               <button className="magic-arrow-btn" onClick={() => setReelIdx(i => i === 0 ? MAGIC_REELS.length - 1 : i - 1)}>‹</button>
// // //               <button className="magic-arrow-btn" onClick={() => setReelIdx(i => (i + 1) % MAGIC_REELS.length)}>›</button>
// // //             </div>

// // //             <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:24, flexWrap:"wrap" }}>
// // //               <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎉 Plan Your Event</button>
// // //               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn">
// // //                 <i className="bi bi-whatsapp" /> Message Us
// // //               </a>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ VIDEO MODAL ═════════════════════════════════════════════ */}
// // //         {playingReel && (
// // //           <div className="magic-video-modal" onClick={() => setPlayingReel(null)}>
// // //             <button className="magic-video-close" onClick={() => setPlayingReel(null)}>✕</button>
// // //             <div className="magic-video-container" onClick={e => e.stopPropagation()}>
// // //               <video ref={videoRef} className="magic-video-player" controls autoPlay>
// // //                 <source src={playingReel.video} type="video/mp4" />
// // //                 Your browser does not support the video tag.
// // //               </video>
// // //               <div className="magic-video-info">
// // //                 <div className="magic-video-title">{playingReel.name}</div>
// // //                 <div className="magic-video-event">{playingReel.event}</div>
// // //                 <span className="magic-video-theme">{playingReel.theme}</span>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         )}

// // //         {/* ══ GALLERY ═════════════════════════════════════════════════ */}
// // //         <section className="kp-sec" style={{ background:C.cream, overflow:"hidden" }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:50 }}>
// // //               <span className="cc-tag">✦ Happy Moments ✦</span>
// // //               <h2 className="cc-h">Real Memories from <span>Real Parties</span></h2>
// // //               <p className="cc-sub">Captured moments from our little guests' most magical days.</p>
// // //             </div>
// // //             <div className="gal-bento rv">
// // //               {KID_GALLERY.map((img, i) => (
// // //                 <div key={i} className={`gal-bento-item gbi-${i + 1}`} style={{ animationDelay:`${i * 0.08}s` }}
// // //                   onClick={() => { setActiveGal(i); galleria.current?.show(); }}>
// // //                   <img src={img} alt={`Party ${i + 1}`} />
// // //                   <div className="gal-bento-ovl">🔍</div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //             <Galleria ref={galleria} value={KID_GALLERY} numVisible={5} activeIndex={activeGal}
// // //               onItemChange={e => setActiveGal(e.index)} circular fullScreen showItemNavigators showThumbnails={false}
// // //               item={galItem} thumbnail={galThumb} />
// // //             <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:34, flexWrap:"wrap" }}>
// // //               <a href="/locations" className="cc-btn">Book Your Party →</a>
// // //               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn">
// // //                 <i className="bi bi-whatsapp" /> Chat With Us
// // //               </a>
// // //             </div>
// // //           </div>
// // //           <GalleryEntranceObserver />
// // //         </section>

// // //         {/* ══ TESTIMONIALS — same structure as Home ════════════════════ */}
// // //         <section className="testi-sec">
// // //           <div className="container" style={{ position:"relative", zIndex:1 }}>

// // //             {/* VIDEO TESTIMONIALS */}
// // //             <div style={{ marginBottom:64 }}>
// // //               <div className="text-center rv" style={{ marginBottom:38 }}>
// // //                 <span className="cc-tag cc-tag-light">✦ Video Reviews ✦</span>
// // //                 <h2 className="cc-h cc-h-white">Real Stories, <span className="gold">Real Magic</span></h2>
// // //                 <p className="cc-sub cc-sub-light">Watch what parents and kids experienced at our private theatre parties — in their own words.</p>
// // //               </div>

// // //               {videoTesti.length > VIDS_PER && (
// // //                 <div className="testi-nav">
// // //                   <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{videoPage + 1} / {totalVP}</span>
// // //                   <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.max(0, p - 1))}>‹</button>
// // //                   <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.min(totalVP - 1, p + 1))}>›</button>
// // //                 </div>
// // //               )}

// // //               <div className="vtesti-grid rv">
// // //                 {visVids.map((item, idx) => (
// // //                   <div key={idx} className="vtesti-card">
// // //                     <div className="vtesti-iframe-wrap">
// // //                       <iframe src={`https://www.youtube.com/embed/${item.videoId}?rel=0&modestbranding=1`}
// // //                         title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
// // //                     </div>
// // //                     <div className="vtesti-footer">
// // //                       {item.profileImage
// // //                         ? <img src={`https://api.carnivalcastle.com/${item.profileImage?.replace(/\\/g, "/")}`} alt={item.name}
// // //                             style={{ width:34, height:34, borderRadius:"50%", objectFit:"cover", border:`2px solid ${C.gold}`, flexShrink:0 }}
// // //                             onError={e => { e.target.style.display = "none"; }} />
// // //                         : <div style={{ width:34, height:34, borderRadius:"50%", background:`linear-gradient(135deg,${C.primary},${C.primaryLight})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:800, color:"#fff", border:`2px solid ${C.gold}`, flexShrink:0 }}>{item.name?.charAt(0) || "G"}</div>
// // //                       }
// // //                       <div>
// // //                         <div className="vtesti-name">{item.name}</div>
// // //                         <div className="vtesti-role">{item.role || "Parent"}</div>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 ))}
// // //               </div>

// // //               {videoTesti.length > VIDS_PER && (
// // //                 <div className="testi-page-dots">
// // //                   {Array.from({ length:totalVP }).map((_, i) => (
// // //                     <button key={i} className={`testi-pd${i === videoPage ? " on" : ""}`} onClick={() => setVideoPage(i)} />
// // //                   ))}
// // //                 </div>
// // //               )}
// // //             </div>

// // //             {/* DIVIDER */}
// // //             <div style={{ display:"flex", alignItems:"center", gap:20, marginBottom:52 }}>
// // //               <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(201,168,76,.3))" }} />
// // //               <span style={{ color:C.gold, fontSize:20 }}>✦</span>
// // //               <div style={{ flex:1, height:1, background:"linear-gradient(90deg,rgba(201,168,76,.3),transparent)" }} />
// // //             </div>

// // //             {/* PHOTO / TEXT REVIEWS */}
// // //             <div>
// // //               <div className="text-center rv" style={{ marginBottom:38 }}>
// // //                 <span className="cc-tag cc-tag-light">✦ Parent Reviews ✦</span>
// // //                 <h2 className="cc-h cc-h-white">What <span className="gold">Happy Parents</span> Say</h2>
// // //                 <p className="cc-sub cc-sub-light">Hundreds of 5-star reviews from real celebrations across Hyderabad.</p>
// // //               </div>

// // //               {textTesti.length > REVS_PER && (
// // //                 <div className="testi-nav">
// // //                   <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{reviewPage + 1} / {totalRP}</span>
// // //                   <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.max(0, p - 1))}>‹</button>
// // //                   <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.min(totalRP - 1, p + 1))}>›</button>
// // //                 </div>
// // //               )}

// // //               <div className="rtesti-grid rv">
// // //                 {visRevs.map((rv, i) => (
// // //                   <div key={i} className="rtesti-card">
// // //                     <div className="rtesti-photo">
// // //                       <img src={rv.image} alt={rv.name} onError={e => { e.target.parentElement.style.display = "none"; }} />
// // //                       <div className="rtesti-photo-ovl" />
// // //                     </div>
// // //                     <div className="rtesti-body">
// // //                       <div className="rtesti-header">
// // //                         {rv.avatar && !rv.avatar.endsWith("undefined")
// // //                           ? <img src={rv.avatar} alt={rv.name} className="rtesti-av-img" onError={e => { e.target.style.display="none"; }} />
// // //                           : <div className="rtesti-av-fb">{rv.name?.charAt(0) || "P"}</div>
// // //                         }
// // //                         <div>
// // //                           <div className="rtesti-name">{rv.name}</div>
// // //                           <div className="rtesti-role">{rv.role}</div>
// // //                         </div>
// // //                       </div>
// // //                       <div className="rtesti-stars">{"★".repeat(rv.rating)}{"☆".repeat(5 - rv.rating)}</div>
// // //                       <p className="rtesti-text">"{rv.description}"</p>
// // //                       {rv.occasion && <div className="rtesti-occ">🎉 {rv.occasion}</div>}
// // //                     </div>
// // //                   </div>
// // //                 ))}
// // //               </div>

// // //               {textTesti.length > REVS_PER && (
// // //                 <div className="testi-page-dots">
// // //                   {Array.from({ length:totalRP }).map((_, i) => (
// // //                     <button key={i} className={`testi-pd${i === reviewPage ? " on" : ""}`} onClick={() => setReviewPage(i)} />
// // //                   ))}
// // //                 </div>
// // //               )}

// // //               {/* Rating Summary — same as Home */}
// // //               <div style={{ background:"rgba(255,255,255,.04)", border:"1px solid rgba(201,168,76,.2)", borderRadius:20, padding:"26px 24px", marginTop:40, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:18 }} className="rv">
// // //                 <div>
// // //                   <div className="pf" style={{ fontSize:"clamp(42px,7vw,62px)", fontWeight:900, color:C.gold, lineHeight:1 }}>4.9</div>
// // //                   <div style={{ color:C.gold, fontSize:18, letterSpacing:3, marginTop:4 }}>★★★★★</div>
// // //                   <div style={{ color:"rgba(255,255,255,.4)", fontSize:12, marginTop:4 }}>Average from {textTesti.length}+ reviews</div>
// // //                 </div>
// // //                 <div style={{ display:"flex", gap:22, flexWrap:"wrap" }}>
// // //                   {[["🎂","Decor","98%"],["🎈","Fun","97%"],["💰","Value","95%"],["📞","Support","99%"]].map(([icon, label, pct]) => (
// // //                     <div key={label} style={{ textAlign:"center" }}>
// // //                       <div style={{ fontSize:22 }}>{icon}</div>
// // //                       <div style={{ color:"#fff", fontWeight:700, fontSize:14, margin:"3px 0 2px" }}>{pct}</div>
// // //                       <div style={{ color:"rgba(255,255,255,.4)", fontSize:11 }}>{label}</div>
// // //                     </div>
// // //                   ))}
// // //                 </div>
// // //                 <button className="cc-btn-gold" style={{ padding:"13px 28px", fontSize:14 }}
// // //                   onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
// // //                   🎉 Book & Experience
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         <CouponSection />

// // //         {/* ══ ENQUIRY FORM ═════════════════════════════════════════════ */}
// // //         <section id="enquiry" className="kp-sec" style={{ background:C.beige }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:44 }}>
// // //               <span className="cc-tag">✦ Book Your Party ✦</span>
// // //               <h2 className="cc-h">Plan the Party <span>of Their Dreams</span></h2>
// // //               <p className="cc-sub">Fill in the details and our party specialist will call you within 2 hours.</p>
// // //             </div>
// // //             <div className="enq-wrap rv" style={{ maxWidth:980, margin:"0 auto" }}>
// // //               <div className="row g-0">
// // //                 <div className="col-lg-4">
// // //                   <div className="enq-left h-100">
// // //                     <div>
// // //                       <h3 className="pf" style={{ color:"#fff", fontSize:23, fontWeight:700, marginBottom:8 }}>Let's Create <span style={{ color:C.goldLight }}>Magic</span> Together</h3>
// // //                       <p style={{ color:"rgba(255,255,255,.58)", fontSize:13, lineHeight:1.7, marginBottom:24 }}>Share your event details and we'll craft an unforgettable kids' party experience.</p>
// // //                     </div>
// // //                     <div>
// // //                       {[
// // //                         { icon:"⚡", label:"2-Hour Callback",    val:"We call within 2 hours" },
// // //                         { icon:"🎨", label:"Free Theme Consult", val:"Expert advice included" },
// // //                         { icon:"💰", label:"Price Match",        val:"Best price guaranteed" },
// // //                         { icon:"💬", label:"WhatsApp Us",        val:"+91 8374777834", href:"https://wa.me/918374777834" },
// // //                       ].map((it, i) => (
// // //                         <div key={i} className="enq-contact-info">
// // //                           <div className="enq-ci-icon">{it.icon}</div>
// // //                           <div>
// // //                             <div className="enq-ci-label">{it.label}</div>
// // //                             {it.href
// // //                               ? <a href={it.href} style={{ color:"#fff", fontWeight:500, fontSize:13, textDecoration:"none" }}>{it.val}</a>
// // //                               : <span style={{ color:"#fff", fontWeight:500, fontSize:13 }}>{it.val}</span>
// // //                             }
// // //                           </div>
// // //                         </div>
// // //                       ))}
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //                 <div className="col-lg-8">
// // //                   <div className="enq-right">
// // //                     <h3 className="pf" style={{ fontSize:21, fontWeight:700, color:C.dark, marginBottom:4 }}>Book Your <span style={{ color:C.primary }}>Kid's Party!</span></h3>
// // //                     <p style={{ color:"#aaa", fontSize:13, marginBottom:22 }}>Free callback within 2 hours • No obligation</p>
// // //                     <form onSubmit={handleSubmit}>
// // //                       <div className="row g-3">
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Your Name *</label>
// // //                           <input type="text" name="name" className="enq-input" placeholder="e.g. Priya Sharma" value={form.name} onChange={handleChange} required />
// // //                         </div>
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Phone Number *</label>
// // //                           <input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={handleChange} required />
// // //                         </div>
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Email Address</label>
// // //                           <input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={handleChange} />
// // //                         </div>
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Child's Age *</label>
// // //                           <input type="text" name="childAge" className="enq-input" placeholder="e.g. 6 years" value={form.childAge} onChange={handleChange} required />
// // //                         </div>
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Preferred Theme *</label>
// // //                           <select name="theme" className="enq-input" value={form.theme} onChange={handleChange} required>
// // //                             <option value="">Choose a theme…</option>
// // //                             {KID_THEMES.map((t, i) => <option key={i} value={t.name}>{t.emoji} {t.name}</option>)}
// // //                           </select>
// // //                         </div>
// // //                         <div className="col-md-6">
// // //                           <label className="enq-label">Party Date *</label>
// // //                           <input type="date" name="date" className="enq-input" value={form.date} onChange={handleChange} required />
// // //                         </div>
// // //                         <div className="col-12">
// // //                           <label className="enq-label">Number of Kids *</label>
// // //                           <select name="guests" className="enq-input" value={form.guests} onChange={handleChange} required>
// // //                             <option value="">How many kids are coming?</option>
// // //                             <option>5–10 kids</option><option>11–20 kids</option><option>21–30 kids</option><option>30+ kids</option>
// // //                           </select>
// // //                         </div>
// // //                         <div className="col-12" style={{ marginTop:4 }}>
// // //                           <button type="submit" className="cc-btn-gold" style={{ width:"100%", justifyContent:"center", padding:"15px", fontSize:15 }}>
// // //                             🎉 Request a Free Callback 🎉
// // //                           </button>
// // //                           <p style={{ textAlign:"center", fontSize:11, color:"#aaa", marginTop:10 }}>No spam. We'll call to discuss your party and that's it.</p>
// // //                         </div>
// // //                       </div>
// // //                     </form>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ FAQ ══════════════════════════════════════════════════════ */}
// // //         <section className="kp-sec" style={{ background:"#fff" }}>
// // //           <div className="container">
// // //             <div className="text-center rv" style={{ marginBottom:44 }}>
// // //               <span className="cc-tag">✦ FAQ ✦</span>
// // //               <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
// // //             </div>
// // //             <div className="row justify-content-center">
// // //               <div className="col-lg-8">
// // //                 {KID_FAQ.map((faq, i) => (
// // //                   <div key={i} className={`kp-faq-item${activeFaq === i ? " open" : ""}`}
// // //                     onClick={() => setActiveFaq(activeFaq === i ? null : i)}>
// // //                     <div className="kp-faq-q">
// // //                       <span>{faq.q}</span>
// // //                       <div className="kp-faq-arrow">▾</div>
// // //                     </div>
// // //                     {activeFaq === i && <div className="kp-faq-a">{faq.a}</div>}
// // //                   </div>
// // //                 ))}
// // //               </div>
// // //             </div>
// // //           </div>
// // //         </section>

// // //         {/* ══ CTA BANNER ═══════════════════════════════════════════════ */}
// // //         <section className="kp-cta-sec kp-sec-sm">
// // //           <div className="container text-center" style={{ position:"relative", zIndex:1 }}>
// // //             <span style={{ fontSize:50 }}>🎂</span>
// // //             <h2 className="pf" style={{ fontSize:"clamp(24px,4vw,42px)", color:"#fff", fontWeight:900, marginTop:12, marginBottom:12 }}>
// // //               Ready to Create <span style={{ background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Pure Magic?</span>
// // //             </h2>
// // //             <p style={{ color:"rgba(255,255,255,.63)", fontSize:15, marginBottom:26, maxWidth:460, margin:"0 auto 26px" }}>
// // //               Book your child's dream party today. We handle everything so you just celebrate.
// // //             </p>
// // //             <button className="cc-btn-gold" style={{ fontSize:15, padding:"15px 40px", animation:"_pulse 2.5s ease-in-out infinite" }}
// // //               onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
// // //               🎈 Book Your Party Now
// // //             </button>
// // //             <p style={{ color:"rgba(255,255,255,.32)", fontSize:12, marginTop:12 }}>Join 2000+ happy families who celebrated with us</p>
// // //           </div>
// // //         </section>

// // //         <Footer />
// // //         <ToastContainer position="top-center" autoClose={4000} theme="dark" />
// // //         <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />
// // //       </div>
// // //     </>
// // //   );
// // // }

// // // /* ─── Helpers ────────────────────────────────────────────────────────────── */
// // // function ScrollRevealWatcher() {
// // //   useEffect(() => {
// // //     const obs = new IntersectionObserver(
// // //       entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
// // //       { threshold:0.08 }
// // //     );
// // //     document.querySelectorAll(".rv").forEach(el => obs.observe(el));
// // //     return () => obs.disconnect();
// // //   }, []);
// // //   return null;
// // // }

// // // function GalleryEntranceObserver() {
// // //   useEffect(() => {
// // //     const items = document.querySelectorAll(".gal-bento-item");
// // //     const obs = new IntersectionObserver(entries => {
// // //       entries.forEach(e => {
// // //         if (e.isIntersecting) {
// // //           const idx = Array.from(items).indexOf(e.target);
// // //           e.target.style.transitionDelay = `${idx * 0.08}s`;
// // //           e.target.classList.add("in");
// // //           obs.unobserve(e.target);
// // //         }
// // //       });
// // //     }, { threshold:0.1 });
// // //     items.forEach(el => obs.observe(el));
// // //     return () => obs.disconnect();
// // //   }, []);
// // //   return null;
// // // }

// // import React, { useState, useEffect, useRef, useMemo, useCallback, memo } from "react";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { Helmet } from "react-helmet";
// // import { Galleria } from "primereact/galleria";
// // import { useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import Footer from "../components/Footer";
// // import Header from "../components/Header";
// // import CouponSection from "../components/Coupons";
// // import PopupModal from "../components/PopUpModal";
// // import '../styles/kidspage.css';

// // const C = {
// //   primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
// //   primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
// //   gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
// //   dark:"#1A0030", dark2:"#120020",
// // };

// // /* ── Static data defined OUTSIDE component ── */
// // const KID_THEMES = [
// //   { name:"Dinosaur Adventure", bookings:"487", tags:["Dinos","Jungle"],    img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80",  emoji:"🦕" },
// //   { name:"Princess Royal",     bookings:"562", tags:["Princess","Castle"], img:"https://plus.unsplash.com/premium_photo-1664205766214-9e3f453ef4cc?q=80",   emoji:"👑" },
// //   { name:"Space Explorer",     bookings:"398", tags:["Space","Galaxy"],    img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80",  emoji:"🚀" },
// //   { name:"Underwater World",   bookings:"312", tags:["Ocean","Fish"],      img:"https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&q=80",      emoji:"🐠" },
// //   { name:"Superhero Academy",  bookings:"445", tags:["Hero","Action"],     img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80",  emoji:"⚡" },
// //   { name:"Candyland",          bookings:"534", tags:["Sweet","Candy"],     img:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80",  emoji:"🍭" },
// // ];

// // const KID_ACTIVITIES = [
// //   { name:"Bouncy Castle",    dur:"30 mins", age:"3–12",    img:"https://images.unsplash.com/photo-1632765471084-9f2ab98365bf?q=80" },
// //   { name:"Balloon Twisting", dur:"45 mins", age:"All ages",img:"https://images.unsplash.com/photo-1727695034153-ff948d488bb1?q=80" },
// //   { name:"Face Painting",    dur:"1 hour",  age:"3–12",    img:"https://images.unsplash.com/photo-1661708733650-58062da7eecf?q=80" },
// //   { name:"Magic Show",       dur:"30 mins", age:"All ages",img:"https://images.unsplash.com/photo-1641478859026-c2728062c1e1?q=80" },
// // ];

// // const SERVICE_CARDS = [
// //   { label:"Themed Decor",  img:"https://images.unsplash.com/photo-1765947382841-24c48f1c987e?q=80",              desc:"Complete themed decor — balloons, backdrops, props & more." },
// //   { label:"Custom Cakes",  img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",       desc:"3D themed cakes crafted by our in-house bakers." },
// //   { label:"Food & Snacks", img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80",          desc:"Kid-friendly menus with vegetarian & non-veg options." },
// //   { label:"Photography",   img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80",       desc:"Professional candid photography — memories forever." },
// // ];

// // const MAGIC_REELS = [
// //   { id:1, name:"Kids Special Car Entry",    event:"Priya's Princess Birthday",  theme:"Princess Royal",    img:"/assets/videos/a1.png",       video:"/assets/videos/Car_Entry.mp4" },
// //   { id:2, name:"Private Theatre Show",      event:"Sanvika's Princess Birthday", theme:"Royal Theme",       img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80", video:"/assets/videos/Private_Theatres.mp4" },
// //   { id:3, name:"Kids Birthday Party",       event:"Pranav's Birthday Party",     theme:"Superhero Academy", img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=800&q=80", video:"/assets/videos/Kids_Birthday.mp4" },
// //   { id:4, name:"Little Bundle of Joy",      event:"Svojass's Birthday",          theme:"Royal Theme",       img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80", video:"/assets/videos/Little_bundle_of_joy_Svojass.mp4" },
// //   { id:5, name:"Ayansh Tej's 2nd Birthday", event:"Birthday Bash",               theme:"Car Special Entry", img:"https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=800&q=80", video:"/assets/videos/Ayansh_Birthday.mp4" },
// //   { id:6, name:"Little Angel Dhanvika",     event:"Second Birthday",             theme:"Royal Theme",       img:"/assets/videos/a2.png",       video:"/assets/videos/Angel_Dhanvika.mp4" },
// // ];

// // const KID_GALLERY = ["https://res.cloudinary.com/dt3jzl980/image/upload/v1779303429/m3_wyriyt.jpg","https://res.cloudinary.com/dt3jzl980/image/upload/v1779303440/m1_zvgm9h.jpg","https://res.cloudinary.com/dt3jzl980/image/upload/v1779303429/m4_t0gyny.jpg","https://res.cloudinary.com/dt3jzl980/image/upload/v1779303999/DSC_8840.JPG_bsrbye.jpg","https://res.cloudinary.com/dt3jzl980/image/upload/v1779303999/DSC_8830.JPG_aksck6.jpg","https://res.cloudinary.com/dt3jzl980/image/upload/v1779303995/DSC_8751.JPG_vuso98.jpg"];

// // const KID_FAQ = [
// //   { q:"What age group are these parties for?",  a:"Our kids' parties are designed for children aged 2–12 years. Every theme and activity is age-appropriate and fully customizable." },
// //   { q:"Can we bring our own cake?",             a:"Absolutely! You're welcome to bring your own cake. We'll display it beautifully as part of the celebration decor." },
// //   { q:"Do you provide return gifts?",           a:"Yes! Personalized goodie bags, toys, stationery — tailored to your budget and chosen theme." },
// //   { q:"How far in advance should we book?",     a:"We recommend 2–3 weeks for weekdays, 4–6 weeks for popular weekend themes like Princess & Superhero." },
// //   { q:"Is parental supervision required?",      a:"Our trained staff supervises all activities, but we recommend 2–3 guardians stay present throughout the party." },
// // ];

// // const FALLBACK_VIDEOS = [
// //   { videoId:"dQw4w9WgXcQ", name:"Riya's Princess Party",  role:"Princess Royal Theme", profileImage:"" },
// //   { videoId:"dQw4w9WgXcQ", name:"Arjun's Superhero Bash", role:"Superhero Academy",    profileImage:"" },
// //   { videoId:"dQw4w9WgXcQ", name:"Ananya's Candyland Day", role:"Candyland Theme",      profileImage:"" },
// // ];
// // const FALLBACK_TEXT = [
// //   { name:"Riya Sharma",  role:"Parent of 6 yr old", rating:5, description:"My daughter's princess party was absolutely magical! The decor left every parent speechless.", avatar:"RS", image:"https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=500&q=80", occasion:"Princess Royal Theme" },
// //   { name:"Amit Patel",   role:"Parent of 8 yr old", rating:5, description:"The superhero theme was an absolute hit! Professional setup, amazing activities. 10/10!",         avatar:"AP", image:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=500&q=80", occasion:"Superhero Academy" },
// //   { name:"Neha Gupta",   role:"Parent of 4 yr old", rating:5, description:"Dinosaur theme exceeded all expectations. The kids were completely amazed. Worth every rupee!",   avatar:"NG", image:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=500&q=80", occasion:"Dinosaur Adventure" },
// //   { name:"Priya Reddy",  role:"Parent of 7 yr old", rating:5, description:"Booked Candyland for my daughter. The place was transformed beyond imagination.",                 avatar:"PR", image:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=500&q=80", occasion:"Candyland Theme" },
// //   { name:"Suresh Kumar", role:"Parent of 5 yr old", rating:5, description:"Space Explorer theme was out of this world! The team was so professional.",                        avatar:"SK", image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=500&q=80", occasion:"Space Explorer" },
// //   { name:"Divya Rao",    role:"Parent of 9 yr old", rating:5, description:"The Royal Celebration package was worth every penny. Beautiful memories we'll treasure forever.",  avatar:"DR", image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=500&q=80", occasion:"Royal Celebration" },
// // ];

// // /* ═══════════════════════════════════════════════════
// //    ISOLATED TIMER COMPONENTS
// //    ═══════════════════════════════════════════════════ */

// // /* Hero video — isolated, autoplays silently */
// // const HeroVideo = memo(() => {
// //   const videoRef = useRef(null);
// //   useEffect(() => {
// //     const vid = videoRef.current;
// //     if (!vid) return;
// //     vid.muted = true;
// //     vid.play().catch(() => {});
// //   }, []);
// //   return (
// //     <div className="kp-hero-vid-wrap">
// //       <video
// //         ref={videoRef}
// //         className="kp-hero-vid-video"
// //         style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}
// //         src="/assets/videos/Kids_Birthday.mp4"
// //         muted
// //         autoPlay
// //         loop
// //         playsInline
// //         preload="none"
// //       />
// //       <div className="kp-hero-vid-ovl" />
// //       <div className="kp-hero-vid-badge">
// //         <div className="kp-hero-vid-pulse" />
// //         <span className="kp-hero-vid-label">🎉 LIVE — Real Birthday Celebrations</span>
// //       </div>
// //     </div>
// //   );
// // });

// // /* Theme carousel — timer isolated */
// // const ThemeCarousel = memo(({ navigate }) => {
// //   const [idx, setIdx] = useState(0);
// //   useEffect(() => {
// //     const t = setInterval(() => setIdx(i => (i + 1) % KID_THEMES.length), 3500);
// //     return () => clearInterval(t);
// //   }, []);

// //   return (
// //     <section className="kp-sec" style={{ background:C.dark, overflow:"hidden" }}>
// //       <div className="container">
// //         <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:44, flexWrap:"wrap", gap:20 }}>
// //           <div>
// //             <span className="cc-tag cc-tag-light">✦ 20+ Dream Themes ✦</span>
// //             <h2 className="cc-h cc-h-white">Your Child's <span className="gold">Fantasy</span> Brought to Life</h2>
// //           </div>
// //           <div style={{ display:"flex", gap:10 }}>
// //             <button className="cc-nav-btn" onClick={() => setIdx(i => (i - 1 + KID_THEMES.length) % KID_THEMES.length)}>‹</button>
// //             <button className="cc-nav-btn" onClick={() => setIdx(i => (i + 1) % KID_THEMES.length)}>›</button>
// //           </div>
// //         </div>
// //         <div style={{ overflow:"hidden" }}>
// //           <div style={{ display:"flex", gap:18, transition:"transform .7s cubic-bezier(.25,1,.5,1)", transform:`translateX(calc(-${idx * (280 + 18)}px))` }}>
// //             {[...KID_THEMES, ...KID_THEMES].map((t, i) => (
// //               <div key={i} className="theme-card" onClick={() => navigate("/locations")}>
// //                 <div className="kp-emoji-badge">{t.emoji}</div>
// //                 <img src={t.img} alt={t.name} className="theme-img" loading="lazy" />
// //                 <div className="theme-ovl">
// //                   <div className="theme-name">{t.name}</div>
// //                   <div className="theme-booked">🔥 {t.bookings} booked</div>
// //                   <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginTop:8 }}>
// //                     {t.tags.map((tg, j) => <span key={j} className="theme-tag">{tg}</span>)}
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //         <div style={{ display:"flex", gap:8, justifyContent:"center", marginTop:26 }}>
// //           {KID_THEMES.map((_, i) => (
// //             <button key={i} onClick={() => setIdx(i)}
// //               style={{ width:i === idx ? 26 : 8, height:8, borderRadius:8, background:i === idx ? C.gold : "rgba(255,255,255,.2)", border:"none", cursor:"pointer", transition:"all .4s" }} />
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // });

// // /* Magic reels carousel — timer isolated */
// // const MagicReels = memo(() => {
// //   const [reelIdx,    setReelIdx]    = useState(0);
// //   const [hovered,    setHovered]    = useState(false);
// //   const [playingReel,setPlayingReel]= useState(null);
// //   const videoRef = useRef(null);
// //   const autoRef  = useRef(null);

// //   const extendedReels = useMemo(() => [...MAGIC_REELS, ...MAGIC_REELS.slice(0, 3)], []);

// //   const startAuto = useCallback(() => {
// //     clearInterval(autoRef.current);
// //     autoRef.current = setInterval(() => {
// //       if (!hovered) setReelIdx(i => (i + 1) % MAGIC_REELS.length);
// //     }, 4000);
// //   }, [hovered]);

// //   useEffect(() => { startAuto(); return () => clearInterval(autoRef.current); }, [startAuto, hovered]);

// //   return (
// //     <section className="kp-sec" style={{ background:C.dark, overflow:"hidden", padding:"48px 0" }}>
// //       <div className="container">
// //         <div className="text-center rv" style={{ marginBottom:32 }}>
// //           <span className="cc-tag cc-tag-light">✦ Our Reels ✦</span>
// //           <h2 className="cc-h cc-h-white">See the <span className="gold">Magic</span> Happen</h2>
// //           <p className="cc-sub cc-sub-light">Watch real events — the energy, the joy, the unforgettable moments.</p>
// //         </div>
// //         <div className="magic-reels-wrap"
// //           onMouseEnter={() => setHovered(true)}
// //           onMouseLeave={() => setHovered(false)}>
// //           <div className="magic-reel-track" style={{ transform:`translateX(calc(-${reelIdx * (160 + 14)}px))` }}>
// //             {extendedReels.map((reel, i) => (
// //               <div key={i} className="magic-reel-card" onClick={() => setPlayingReel(reel)}>
// //                 <img src={reel.img} alt={reel.name} className="magic-reel-img" loading="lazy" />
// //                 <div className="magic-reel-play">▶</div>
// //                 <div className="magic-reel-ovl">
// //                   <div className="magic-reel-name">{reel.name}</div>
// //                   <div className="magic-reel-event">{reel.event}</div>
// //                   <span className="magic-reel-theme">{reel.theme}</span>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //         <div className="magic-nav-arrows">
// //           <button className="magic-arrow-btn" onClick={() => { setReelIdx(i => (i - 1 + MAGIC_REELS.length) % MAGIC_REELS.length); startAuto(); }}>‹</button>
// //           <button className="magic-arrow-btn" onClick={() => { setReelIdx(i => (i + 1) % MAGIC_REELS.length); startAuto(); }}>›</button>
// //         </div>
// //         <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:24, flexWrap:"wrap" }}>
// //           <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎉 Plan Your Event</button>
// //           <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp" /> Message Us</a>
// //         </div>
// //       </div>
// //       {/* Video Modal */}
// //       {playingReel && (
// //         <div className="magic-video-modal" onClick={() => setPlayingReel(null)}>
// //           <button className="magic-video-close" onClick={() => setPlayingReel(null)}>✕</button>
// //           <div className="magic-video-container" onClick={e => e.stopPropagation()}>
// //             <video ref={videoRef} className="magic-video-player" controls autoPlay>
// //               <source src={playingReel.video} type="video/mp4" />
// //             </video>
// //             <div className="magic-video-info">
// //               <div className="magic-video-title">{playingReel.name}</div>
// //               <div className="magic-video-event">{playingReel.event}</div>
// //               <span className="magic-video-theme">{playingReel.theme}</span>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </section>
// //   );
// // });

// // /* Testimonials — isolated, no timers just pagination state */
// // const Testimonials = memo(({ videoTesti, textTesti }) => {
// //   const [videoPage,  setVideoPage]  = useState(0);
// //   const [reviewPage, setReviewPage] = useState(0);

// //   const W = typeof window !== "undefined" ? window.innerWidth : 1200;
// //   const VIDS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
// //   const REVS_PER = W < 640 ? 1 : W < 1024 ? 2 : 3;
// //   const totalVP  = Math.max(1, Math.ceil(videoTesti.length / VIDS_PER));
// //   const totalRP  = Math.max(1, Math.ceil(textTesti.length  / REVS_PER));
// //   const visVids  = videoTesti.slice(videoPage  * VIDS_PER, (videoPage  + 1) * VIDS_PER);
// //   const visRevs  = textTesti.slice( reviewPage * REVS_PER, (reviewPage + 1) * REVS_PER);

// //   return (
// //     <section className="testi-sec">
// //       <div className="container" style={{ position:"relative", zIndex:1 }}>

// //         {/* Video testimonials */}
// //         <div style={{ marginBottom:60 }}>
// //           <div className="text-center rv" style={{ marginBottom:38 }}>
// //             <span className="cc-tag cc-tag-light">✦ Video Reviews ✦</span>
// //             <h2 className="cc-h cc-h-white">Real Stories, <span className="gold">Real Magic</span></h2>
// //             <p className="cc-sub cc-sub-light">Watch what parents experienced — in their own words.</p>
// //           </div>
// //           {videoTesti.length > VIDS_PER && (
// //             <div className="testi-nav">
// //               <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{videoPage + 1} / {totalVP}</span>
// //               <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.max(0, p - 1))}>‹</button>
// //               <button className="testi-nav-btn" onClick={() => setVideoPage(p => Math.min(totalVP - 1, p + 1))}>›</button>
// //             </div>
// //           )}
// //           <div className="vtesti-grid rv">
// //             {visVids.map((item, idx) => (
// //               <div key={idx} className="vtesti-card">
// //                 <div className="vtesti-iframe-wrap">
// //                   <iframe src={`https://www.youtube.com/embed/${item.videoId}?rel=0&modestbranding=1`}
// //                     title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
// //                 </div>
// //                 <div className="vtesti-footer">
// //                   <div style={{ width:34, height:34, borderRadius:"50%", background:`linear-gradient(135deg,${C.primary},${C.primaryLight})`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:800, color:"#fff", border:`2px solid ${C.gold}`, flexShrink:0 }}>
// //                     {item.name?.charAt(0) || "G"}
// //                   </div>
// //                   <div>
// //                     <div className="vtesti-name">{item.name}</div>
// //                     <div className="vtesti-role">{item.role || "Parent"}</div>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //           {videoTesti.length > VIDS_PER && (
// //             <div className="testi-page-dots">
// //               {Array.from({ length:totalVP }).map((_, i) => (
// //                 <button key={i} className={`testi-pd${i === videoPage ? " on" : ""}`} onClick={() => setVideoPage(i)} />
// //               ))}
// //             </div>
// //           )}
// //         </div>

// //         {/* Divider */}
// //         <div style={{ display:"flex", alignItems:"center", gap:20, marginBottom:52 }}>
// //           <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(201,168,76,.3))" }} />
// //           <span style={{ color:C.gold, fontSize:20 }}>✦</span>
// //           <div style={{ flex:1, height:1, background:"linear-gradient(90deg,rgba(201,168,76,.3),transparent)" }} />
// //         </div>

// //         {/* Photo/text reviews */}
// //         <div>
// //           <div className="text-center rv" style={{ marginBottom:38 }}>
// //             <span className="cc-tag cc-tag-light">✦ Parent Reviews ✦</span>
// //             <h2 className="cc-h cc-h-white">What <span className="gold">Happy Parents</span> Say</h2>
// //             <p className="cc-sub cc-sub-light">Hundreds of 5-star reviews from real celebrations across Hyderabad.</p>
// //           </div>
// //           {textTesti.length > REVS_PER && (
// //             <div className="testi-nav">
// //               <span style={{ color:"rgba(255,255,255,.4)", fontSize:12, fontWeight:600, letterSpacing:1, textTransform:"uppercase", marginRight:"auto" }}>{reviewPage + 1} / {totalRP}</span>
// //               <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.max(0, p - 1))}>‹</button>
// //               <button className="testi-nav-btn" onClick={() => setReviewPage(p => Math.min(totalRP - 1, p + 1))}>›</button>
// //             </div>
// //           )}
// //           <div className="rtesti-grid rv">
// //             {visRevs.map((rv, i) => (
// //               <div key={i} className="rtesti-card">
// //                 <div className="rtesti-photo">
// //                   <img src={rv.image} alt={rv.name} loading="lazy" onError={e => { e.target.parentElement.style.display = "none"; }} />
// //                   <div className="rtesti-photo-ovl" />
// //                 </div>
// //                 <div className="rtesti-body">
// //                   <div className="rtesti-header">
// //                     <div className="rtesti-av-fb">{rv.avatar || rv.name?.charAt(0) || "P"}</div>
// //                     <div>
// //                       <div className="rtesti-name">{rv.name}</div>
// //                       <div className="rtesti-role">{rv.role}</div>
// //                     </div>
// //                   </div>
// //                   <div className="rtesti-stars">{"★".repeat(rv.rating)}{"☆".repeat(5 - rv.rating)}</div>
// //                   <p className="rtesti-text">"{rv.description}"</p>
// //                   {rv.occasion && <div className="rtesti-occ">🎉 {rv.occasion}</div>}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //           {textTesti.length > REVS_PER && (
// //             <div className="testi-page-dots">
// //               {Array.from({ length:totalRP }).map((_, i) => (
// //                 <button key={i} className={`testi-pd${i === reviewPage ? " on" : ""}`} onClick={() => setReviewPage(i)} />
// //               ))}
// //             </div>
// //           )}

// //           {/* Rating summary */}
// //           <div style={{ background:"rgba(255,255,255,.04)", border:"1px solid rgba(201,168,76,.2)", borderRadius:20, padding:"26px 24px", marginTop:40, display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:18 }} className="rv">
// //             <div>
// //               <div className="pf" style={{ fontSize:"clamp(42px,7vw,62px)", fontWeight:900, color:C.gold, lineHeight:1 }}>4.9</div>
// //               <div style={{ color:C.gold, fontSize:18, letterSpacing:3, marginTop:4 }}>★★★★★</div>
// //               <div style={{ color:"rgba(255,255,255,.4)", fontSize:12, marginTop:4 }}>Average from {textTesti.length}+ reviews</div>
// //             </div>
// //             <div style={{ display:"flex", gap:22, flexWrap:"wrap" }}>
// //               {[["🎂","Decor","98%"],["🎈","Fun","97%"],["💰","Value","95%"],["📞","Support","99%"]].map(([icon, label, pct]) => (
// //                 <div key={label} style={{ textAlign:"center" }}>
// //                   <div style={{ fontSize:22 }}>{icon}</div>
// //                   <div style={{ color:"#fff", fontWeight:700, fontSize:14, margin:"3px 0 2px" }}>{pct}</div>
// //                   <div style={{ color:"rgba(255,255,255,.4)", fontSize:11 }}>{label}</div>
// //                 </div>
// //               ))}
// //             </div>
// //             <button className="cc-btn-gold" style={{ padding:"13px 28px", fontSize:14 }}
// //               onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
// //               🎉 Book & Experience
// //             </button>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // });

// // /* Scroll reveal — singleton */
// // const ScrollRevealWatcher = memo(() => {
// //   useEffect(() => {
// //     const obs = new IntersectionObserver(
// //       entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
// //       { threshold:0.08 }
// //     );
// //     const observe = () => document.querySelectorAll(".rv:not(.in)").forEach(el => obs.observe(el));
// //     observe();
// //     const t = setTimeout(observe, 600);
// //     return () => { obs.disconnect(); clearTimeout(t); };
// //   }, []);
// //   return null;
// // });

// // /* Gallery observer — used once */
// // function GalleryEntranceObserver() {
// //   useEffect(() => {
// //     const items = document.querySelectorAll(".gal-bento-item");
// //     const obs = new IntersectionObserver(entries => {
// //       entries.forEach(e => {
// //         if (e.isIntersecting) {
// //           const idx = Array.from(items).indexOf(e.target);
// //           e.target.style.transitionDelay = `${idx * 0.08}s`;
// //           e.target.classList.add("in");
// //           obs.unobserve(e.target);
// //         }
// //       });
// //     }, { threshold:0.1 });
// //     items.forEach(el => obs.observe(el));
// //     return () => obs.disconnect();
// //   }, []);
// //   return null;
// // }

// // /* ═══════════════════════════════════════════════════
// //    MAIN COMPONENT — minimal state
// //    ═══════════════════════════════════════════════════ */
// // export default function KidsPage() {
// //   const [isLoading,  setIsLoading]  = useState(true);
// //   const [activeFaq,  setActiveFaq]  = useState(null);
// //   const [showPopup,  setShowPopup]  = useState(false);
// //   const [popupImage, setPopupImage] = useState("");
// //   const [activeGal,  setActiveGal]  = useState(0);
// //   const [videoTesti, setVideoTesti] = useState([]);
// //   const [textTesti,  setTextTesti]  = useState([]);
// //   const [form, setForm] = useState({ name:"", email:"", mobileNumber:"", childAge:"", theme:"", date:"", guests:"" });

// //   const galleria = useRef(null);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     axios.post("https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle")
// //       .then(r => {
// //         if (r.data?.success && Array.isArray(r.data.testimoni)) {
// //           const active = r.data.testimoni.filter(t => t.status === "active");
// //           const videos = active.filter(t => t.videoId?.trim());
// //           setVideoTesti(videos.length ? videos : FALLBACK_VIDEOS);
// //           const reviews = active.map(t => ({
// //             name:t.name, role:t.role||"Parent", rating:Number(t.rating)||5,
// //             description:t.description||"",
// //             image:`https://api.carnivalcastle.com/${t.image}`,
// //             avatar:t.name?.charAt(0) || "P",
// //             occasion:t.type==="Yes"?"Special Celebration":"",
// //           }));
// //           setTextTesti(reviews.length ? reviews : FALLBACK_TEXT);
// //         } else { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); }
// //       })
// //       .catch(() => { setVideoTesti(FALLBACK_VIDEOS); setTextTesti(FALLBACK_TEXT); });

// //     setTimeout(() => setIsLoading(false), 500);
// //   }, []);

// //   const handleChange = useCallback(e => setForm(f => ({ ...f, [e.target.name]: e.target.value })), []);
// //   const handleSubmit = useCallback(e => {
// //     e.preventDefault();
// //     toast.success("🎉 Amazing! We'll call you within 2 hours to plan the perfect party!");
// //     setForm({ name:"", email:"", mobileNumber:"", childAge:"", theme:"", date:"", guests:"" });
// //   }, []);

// //   const galItem  = useCallback(src => <img src={src} alt="" style={{ width:"100%", display:"block", borderRadius:14 }} />, []);
// //   const galThumb = useCallback(src => <img src={src} alt="" style={{ width:58, height:58, objectFit:"cover", display:"block", borderRadius:8 }} />, []);

// //   if (isLoading) return (
// //     <div style={{ background:C.dark, height:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:18 }}>
// //       <div style={{ width:68, height:68, border:`4px solid ${C.primaryPale}`, borderTop:`4px solid ${C.gold}`, borderRadius:"50%", animation:"_spin 1s linear infinite" }} />
// //       <p style={{ color:C.gold, fontWeight:600, letterSpacing:2, fontSize:14 }}>Loading Magic…</p>
// //       <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
// //     </div>
// //   );

// //   return (
// //     <>
// //       <Helmet>
// //         <title>Carnival Castle Kids | Magical Birthday Parties in Hyderabad</title>
// //         <meta name="description" content="Themed birthday parties for kids — Princess, Superhero, Dino & 20+ themes. Premium packages from ₹4,999." />
// //       </Helmet>

// //       <ScrollRevealWatcher />

// //       <div className="kp-root">
// //         <Header />

// //         {/* Ticker */}
// //         <div className="kp-ticker">
// //           <div className="kp-ticker-track">
// //             {[...Array(4)].map((_, k) =>
// //               ["🎈 20+ Magical Themes","⭐ 2000+ Happy Parties","🛡️ 100% Child Safe","📸 Photography Included","⚡ Book in 2 Minutes","🎂 Custom Cakes Available"].map((item, i) => (
// //                 <span key={`${k}-${i}`} className="kp-ticker-item">{item}</span>
// //               ))
// //             )}
// //           </div>
// //         </div>

// //         {/* ══ HERO ══ */}
// //         <section className="kp-hero">
// //           <div className="kp-hero-orb" style={{ width:500, height:500, background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`, top:-100, right:-80 }} />
// //           <div className="kp-hero-orb" style={{ width:300, height:300, background:"radial-gradient(circle,rgba(236,72,153,.16) 0%,transparent 70%)", bottom:80, left:-60 }} />
// //           <div className="container kp-hero-cnt">
// //             <div className="row align-items-center g-5">
// //               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both" }}>
// //                 <div className="kp-hero-badge">🎉 Hyderabad's #1 Kids Party Venue</div>
// //                 <h1 className="kp-hero-title pf">
// //                   Create <span>Magical</span><br />Birthday Memories
// //                 </h1>
// //                 <p className="kp-hero-sub">
// //                   From princess castles to dino adventures — 20+ incredible themes, professional setups, and memories your child will cherish forever.
// //                 </p>
// //                 <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
// //                   <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-gold">🎈 Explore Packages</button>
// //                   <button onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })} className="cc-btn-outline" style={{ borderColor:"rgba(255,255,255,.4)", color:"#fff" }}>📞 Get a Callback</button>
// //                 </div>
// //                 <div className="kp-trust-row">
// //                   {[["2000+","Parties"],["4.9★","Rating"],["20+","Themes"]].map(([n, l]) => (
// //                     <div key={l} className="kp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* ── Hero Video (isolated, autoplays) ── */}
// //               <div className="col-lg-6" style={{ animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both" }}>
// //                 <div style={{ position:"relative" }}>
// //                   <HeroVideo />
// //                   <div className="kp-hero-float d-none d-md-block" style={{ bottom:80, left:-28, animationDelay:"0s" }}>
// //                     <div style={{ fontSize:10, color:"#888", marginBottom:4, textTransform:"uppercase", letterSpacing:1 }}>Just Booked!</div>
// //                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
// //                       <span style={{ fontSize:18 }}>👑</span>
// //                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>Princess Royal</div><div style={{ fontSize:11, color:C.primary }}>Priya's 5th Birthday</div></div>
// //                     </div>
// //                   </div>
// //                   <div className="kp-hero-float d-none d-md-block" style={{ top:32, right:-28, animationDelay:"1.5s" }}>
// //                     <div style={{ display:"flex", alignItems:"center", gap:8 }}>
// //                       <span style={{ fontSize:18 }}>⭐</span>
// //                       <div><div style={{ fontSize:13, fontWeight:700, color:C.dark }}>4.9 / 5.0</div><div style={{ fontSize:11, color:"#888" }}>2000+ Happy Parties</div></div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* ══ REELS — right after hero ══ */}
// //         <MagicReels />

// //         {/* ══ VIDEO TESTIMONIALS — right after reels ══ */}
// //         <Testimonials videoTesti={videoTesti} textTesti={textTesti} />

// //         {/* ══ THEMES ══ */}
// //         {/* <ThemeCarousel navigate={navigate} /> */}

// //         {/* ══ SERVICES ══ */}
// //         <section className="kp-sec" style={{ background:"#fff", overflow:"hidden" }}>
// //           <div className="container">
// //             <div className="text-center rv" style={{ marginBottom:44 }}>
// //               <span className="cc-tag">✦ Party Services ✦</span>
// //               <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Party</h2>
// //               <p className="cc-sub">Decor, cakes, food, photography — curated to make your child's day perfect.</p>
// //             </div>
// //             <div className="kp-divider"><div className="kp-dl" /><div className="kp-dg" /><div className="kp-dl" /></div>
// //             <div className="svc-grid rv">
// //               {SERVICE_CARDS.map((s, i) => (
// //                 <div key={i} className="svc-card">
// //                   <div className="svc-img-wrap">
// //                     <img src={s.img} alt={s.label} className="svc-img" loading="lazy" />
// //                     <div className="svc-glow" /><div className="svc-num">0{i + 1}</div>
// //                     <div className="svc-pill">{["✨ Trending","🎂 Custom","🍽️ Fresh","📸 Pro"][i]}</div>
// //                   </div>
// //                   <div className="svc-body">
// //                     <div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div>
// //                     <div className="svc-title pf">{s.label}</div>
// //                     <span className="svc-line" />
// //                     <p className="svc-desc">{s.desc}</p>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </section>

// //         {/* ══ ACTIVITIES ══ */}
// //         {/* <section className="kp-sec" style={{ background:C.cream }}>
// //           <div className="container">
// //             <div className="text-center rv" style={{ marginBottom:44 }}>
// //               <span className="cc-tag">✦ Fun Activities ✦</span>
// //               <h2 className="cc-h">Keep the Kids <span>Entertained All Day</span></h2>
// //             </div>
// //             <div className="row g-4">
// //               {KID_ACTIVITIES.map((act, i) => (
// //                 <div key={i} className={`col-md-3 col-6 rv d${i + 1}`}>
// //                   <div className="act-card">
// //                     <div style={{ overflow:"hidden", height:185 }}>
// //                       <img src={act.img} alt={act.name} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} loading="lazy" />
// //                     </div>
// //                     <div style={{ padding:"14px" }}>
// //                       <h3 style={{ fontSize:15, fontWeight:700, marginBottom:5, color:C.dark }}>{act.name}</h3>
// //                       <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:"#888" }}>
// //                         <span>⏱️ {act.dur}</span><span>👶 {act.age}</span>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         </section> */}

// //         {/* ══ GALLERY ══ */}
// //         <section className="kp-sec" style={{ background:C.cream, overflow:"hidden" }}>
// //           <div className="container">
// //             <div className="text-center rv" style={{ marginBottom:50 }}>
// //               <span className="cc-tag">✦ Happy Moments ✦</span>
// //               <h2 className="cc-h">Real Memories from <span>Real Parties</span></h2>
// //               <p className="cc-sub">Captured moments from our little guests' most magical days.</p>
// //             </div>
// //             <div className="gal-bento rv">
// //               {KID_GALLERY.map((img, i) => (
// //                 <div key={i} className={`gal-bento-item gbi-${i + 1}`}
// //                   onClick={() => { setActiveGal(i); galleria.current?.show(); }}>
// //                   <img src={img} alt={`Party ${i + 1}`} loading="lazy" />
// //                   <div className="gal-bento-ovl">🔍</div>
// //                 </div>
// //               ))}
// //             </div>
// //             <Galleria ref={galleria} value={KID_GALLERY} numVisible={5} activeIndex={activeGal}
// //               onItemChange={e => setActiveGal(e.index)} circular fullScreen showItemNavigators showThumbnails={false}
// //               item={galItem} thumbnail={galThumb} />
// //             <div style={{ display:"flex", gap:14, justifyContent:"center", marginTop:34, flexWrap:"wrap" }}>
// //               <a href="/locations" className="cc-btn">Book Your Party →</a>
// //               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp" /> Chat With Us</a>
// //             </div>
// //           </div>
// //           <GalleryEntranceObserver />
// //         </section>

// //         <CouponSection />

// //         {/* ══ ENQUIRY ══ */}
// //         <section id="enquiry" className="kp-sec" style={{ background:C.beige }}>
// //           <div className="container">
// //             <div className="text-center rv" style={{ marginBottom:44 }}>
// //               <span className="cc-tag">✦ Book Your Party ✦</span>
// //               <h2 className="cc-h">Plan the Party <span>of Their Dreams</span></h2>
// //               <p className="cc-sub">Fill in the details and our party specialist will call you within 2 hours.</p>
// //             </div>
// //             <div className="enq-wrap rv" style={{ maxWidth:980, margin:"0 auto" }}>
// //               <div className="row g-0">
// //                 <div className="col-lg-4">
// //                   <div className="enq-left h-100">
// //                     <div>
// //                       <h3 className="pf" style={{ color:"#fff", fontSize:23, fontWeight:700, marginBottom:8 }}>
// //                         Let's Create <span style={{ color:C.goldLight }}>Magic</span> Together
// //                       </h3>
// //                       <p style={{ color:"rgba(255,255,255,.58)", fontSize:13, lineHeight:1.7, marginBottom:24 }}>
// //                         Share your event details and we'll craft an unforgettable kids' party experience.
// //                       </p>
// //                     </div>
// //                     <div>
// //                       {[
// //                         { icon:"⚡", label:"2-Hour Callback",    val:"We call within 2 hours" },
// //                         { icon:"🎨", label:"Free Theme Consult", val:"Expert advice included" },
// //                         { icon:"💰", label:"Price Match",        val:"Best price guaranteed" },
// //                         { icon:"💬", label:"WhatsApp Us",        val:"+91 8374777834", href:"https://wa.me/918374777834" },
// //                       ].map((it, i) => (
// //                         <div key={i} className="enq-contact-info">
// //                           <div className="enq-ci-icon">{it.icon}</div>
// //                           <div>
// //                             <div className="enq-ci-label">{it.label}</div>
// //                             {it.href
// //                               ? <a href={it.href} style={{ color:"#fff", fontWeight:500, fontSize:13, textDecoration:"none" }}>{it.val}</a>
// //                               : <span style={{ color:"#fff", fontWeight:500, fontSize:13 }}>{it.val}</span>}
// //                           </div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-8">
// //                   <div className="enq-right">
// //                     <h3 className="pf" style={{ fontSize:21, fontWeight:700, color:C.dark, marginBottom:4 }}>
// //                       Book Your <span style={{ color:C.primary }}>Kid's Party!</span>
// //                     </h3>
// //                     <p style={{ color:"#aaa", fontSize:13, marginBottom:22 }}>Free callback within 2 hours • No obligation</p>
// //                     <form onSubmit={handleSubmit}>
// //                       <div className="row g-3">
// //                         <div className="col-md-6"><label className="enq-label">Your Name *</label><input type="text" name="name" className="enq-input" placeholder="e.g. Priya Sharma" value={form.name} onChange={handleChange} required /></div>
// //                         <div className="col-md-6"><label className="enq-label">Phone Number *</label><input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={handleChange} required /></div>
// //                         <div className="col-md-6"><label className="enq-label">Email Address</label><input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={handleChange} /></div>
// //                         <div className="col-md-6"><label className="enq-label">Child's Age *</label><input type="text" name="childAge" className="enq-input" placeholder="e.g. 6 years" value={form.childAge} onChange={handleChange} required /></div>
// //                         <div className="col-md-6">
// //                           <label className="enq-label">Preferred Theme *</label>
// //                           <select name="theme" className="enq-input" value={form.theme} onChange={handleChange} required>
// //                             <option value="">Choose a theme…</option>
// //                             {KID_THEMES.map((t, i) => <option key={i} value={t.name}>{t.emoji} {t.name}</option>)}
// //                           </select>
// //                         </div>
// //                         <div className="col-md-6"><label className="enq-label">Party Date *</label><input type="date" name="date" className="enq-input" value={form.date} onChange={handleChange} required /></div>
// //                         <div className="col-12">
// //                           <label className="enq-label">Number of Kids *</label>
// //                           <select name="guests" className="enq-input" value={form.guests} onChange={handleChange} required>
// //                             <option value="">How many kids are coming?</option>
// //                             <option>5–10 kids</option><option>11–20 kids</option><option>21–30 kids</option><option>30+ kids</option>
// //                           </select>
// //                         </div>
// //                         <div className="col-12" style={{ marginTop:4 }}>
// //                           <button type="submit" className="cc-btn-gold" style={{ width:"100%", justifyContent:"center", padding:"15px", fontSize:15 }}>
// //                             🎉 Request a Free Callback 🎉
// //                           </button>
// //                           <p style={{ textAlign:"center", fontSize:11, color:"#aaa", marginTop:10 }}>No spam. We'll call to discuss your party and that's it.</p>
// //                         </div>
// //                       </div>
// //                     </form>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* ══ FAQ ══ */}
// //         <section className="kp-sec" style={{ background:"#fff" }}>
// //           <div className="container">
// //             <div className="text-center rv" style={{ marginBottom:44 }}>
// //               <span className="cc-tag">✦ FAQ ✦</span>
// //               <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
// //             </div>
// //             <div className="row justify-content-center">
// //               <div className="col-lg-8">
// //                 {KID_FAQ.map((faq, i) => (
// //                   <div key={i} className={`kp-faq-item${activeFaq === i ? " open" : ""}`}
// //                     onClick={() => setActiveFaq(activeFaq === i ? null : i)}>
// //                     <div className="kp-faq-q"><span>{faq.q}</span><div className="kp-faq-arrow">▾</div></div>
// //                     {activeFaq === i && <div className="kp-faq-a">{faq.a}</div>}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* ══ CTA ══ */}
// //         <section className="kp-cta-sec kp-sec-sm">
// //           <div className="container text-center" style={{ position:"relative", zIndex:1 }}>
// //             <span style={{ fontSize:50 }}>🎂</span>
// //             <h2 className="pf" style={{ fontSize:"clamp(24px,4vw,42px)", color:"#fff", fontWeight:900, marginTop:12, marginBottom:12 }}>
// //               Ready to Create <span style={{ background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Pure Magic?</span>
// //             </h2>
// //             <p style={{ color:"rgba(255,255,255,.63)", fontSize:15, marginBottom:26, maxWidth:460, margin:"0 auto 26px" }}>
// //               Book your child's dream party today. We handle everything so you just celebrate.
// //             </p>
// //             <button className="cc-btn-gold" style={{ fontSize:15, padding:"15px 40px" }}
// //               onClick={() => document.getElementById("enquiry")?.scrollIntoView({ behavior:"smooth" })}>
// //               🎈 Book Your Party Now
// //             </button>
// //             <p style={{ color:"rgba(255,255,255,.32)", fontSize:12, marginTop:12 }}>Join 2000+ happy families who celebrated with us</p>
// //           </div>
// //         </section>

// //         <Footer />
// //         <ToastContainer position="top-center" autoClose={4000} theme="dark" />
// //         <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />
// //       </div>
// //     </>
// //   );
// // }


// import React, { useState, useEffect, useRef, useCallback, memo } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { Helmet } from "react-helmet";
// import { Galleria } from "primereact/galleria";
// import { useNavigate } from "react-router-dom";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import CouponSection from "../components/Coupons";
// import PopupModal from "../components/PopUpModal";

// /* ─── Brand palette ─────────────────────────────────────────────── */
// const C = {
//   primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
//   primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
//   gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
//   dark:"#1A0030", dark2:"#120020",
// };

// /* ─── ALL CSS ────────────────────────────────────────────────────── */
// const GLOBAL_CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
// :root{--p:#5E0E73;--pl:#6E1A85;--pd:#3A0847;--pp:#F3E5F7;--cream:#E8E1D6;--beige:#D6CFC4;--gold:#C9A84C;--gl:#E8D5A0;--gb:#F5D87A;--dark:#1A0030;--dark2:#120020;}
// *,*::before,*::after{box-sizing:border-box;}
// .kp-root,.kp-root *{font-family:'DM Sans',sans-serif;}
// .pf{font-family:'Playfair Display',serif!important;}

// @keyframes _fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
// @keyframes _ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
// @keyframes _spin{to{transform:rotate(360deg)}}
// @keyframes _float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
// @keyframes _pulse{0%,100%{opacity:.7}50%{opacity:1}}
// @keyframes _shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
// @keyframes kr-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
// @keyframes kr-fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-pulse{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.2);opacity:.85}}
// @keyframes kvt-quoteIn{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:translateX(0)}}
// @keyframes kvt-nameIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-ctrlIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
// @keyframes kvt-eqBar{0%,100%{height:5px}50%{height:18px}}
// @keyframes kvt-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}

// .rv{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s cubic-bezier(.16,1,.3,1);}
// .rv.in{opacity:1;transform:translateY(0);}
// .rv.d1{transition-delay:.08s}.rv.d2{transition-delay:.16s}.rv.d3{transition-delay:.24s}.rv.d4{transition-delay:.32s}

// .kp-sec{padding:72px 0;}.kp-sec-sm{padding:44px 0;}

// .cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
// .cc-tag-light{color:var(--gl)!important;}
// .cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
// .cc-h-white{color:#fff!important;}
// .cc-h span{color:var(--p);}
// .cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
// .cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
// .cc-sub-light{color:rgba(255,255,255,.55)!important;}

// .cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;position:relative;}
// .cc-btn:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
// .cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,background .25s,color .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// .cc-btn-outline:hover{background:var(--p);color:#fff;transform:translateY(-2px);}
// .cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B 0%,var(--gold) 50%,#9A6E10 100%);color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .25s,opacity .25s;box-shadow:0 4px 18px rgba(201,168,76,.35);}
// .cc-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:_shine 3.5s ease infinite;pointer-events:none;}
// .cc-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:var(--dark);}
// .wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
// .wa-btn:hover{transform:translateY(-2px);opacity:.88;color:#fff;}
// .cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;}
// .cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.08);}

// .kp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
// .kp-ticker-track{display:flex;width:max-content;animation:_ticker 26s linear infinite;will-change:transform;}
// .kp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

// .kp-hero{position:relative;min-height:88vh;overflow:hidden;background:linear-gradient(135deg,rgba(26,0,48,.75) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.82) 100%),url('https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=1200&q=80') center/cover no-repeat;display:flex;align-items:center;}
// .kp-hero-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none;}
// .kp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
// .kp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.38);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
// .kp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 2px 12px rgba(0,0,0,.3);}
// .kp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
// .kp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
// .kp-hero-vid-wrap{position:relative;border-radius:28px;border:2px solid rgba(201,168,76,.3);overflow:hidden;aspect-ratio:9/16;max-height:500px;background:#000;}
// .kp-hero-vid-wrap video{width:100%;height:100%;object-fit:cover;display:block;}
// .kp-hero-vid-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.55) 0%,transparent 55%);pointer-events:none;}
// .kp-hero-vid-badge{position:absolute;bottom:14px;left:14px;right:14px;display:flex;align-items:center;gap:10px;background:rgba(0,0,0,.55);border-radius:10px;padding:9px 12px;border:1px solid rgba(201,168,76,.2);}
// .kp-hero-vid-pulse{width:8px;height:8px;border-radius:50%;background:#EF4444;flex-shrink:0;animation:_pulse 1.8s ease-in-out infinite;}
// .kp-hero-vid-label{font-size:11px;color:rgba(255,255,255,.8);font-weight:600;letter-spacing:.5px;}
// .kp-hero-float{position:absolute;background:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 8px 24px rgba(0,0,0,.18);animation:_float 5s ease-in-out infinite;white-space:nowrap;will-change:transform;}
// .kp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
// .kp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
// .kp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}

// .theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
// .theme-card:hover{transform:translateY(-6px);}
// .theme-img{width:100%;height:320px;object-fit:cover;transition:transform .45s;display:block;}
// .theme-card:hover .theme-img{transform:scale(1.05);}
// .theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.9) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
// .theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
// .theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
// .theme-tag{background:rgba(255,255,255,.12);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
// .kp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

// .svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
// .svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);transition:transform .35s;cursor:pointer;position:relative;}
// .svc-card:hover{transform:translateY(-10px);}
// .svc-card::before{content:'';position:absolute;inset:0;border-radius:22px;box-shadow:0 24px 56px rgba(94,14,115,.18);opacity:0;transition:opacity .35s;z-index:-1;}
// .svc-card:hover::before{opacity:1;}
// .svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .35s,left .35s;}
// .svc-card:hover::after{width:100%;left:0;}
// .svc-img-wrap{position:relative;height:200px;overflow:hidden;}
// .svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .45s;}
// .svc-card:hover .svc-img{transform:scale(1.07);}
// .svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.45) 0%,transparent 60%);opacity:0;transition:opacity .3s;}
// .svc-card:hover .svc-glow{opacity:1;}
// .svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
// .svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .3s,opacity .3s;}
// .svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
// .svc-body{padding:22px 14px 18px;position:relative;}
// .svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;transition:transform .3s;}
// .svc-card:hover .svc-float-icon{transform:rotate(-6deg) scale(1.1);}
// .svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .2s;}
// .svc-card:hover .svc-title{color:var(--p);}
// .svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .35s;}
// .svc-card:hover .svc-line{width:42px;}
// .svc-desc{font-size:12px;color:#888;line-height:1.6;}

// .act-card{border-radius:18px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.07);transition:transform .3s;cursor:pointer;position:relative;}
// .act-card::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 16px 40px rgba(94,14,115,.15);opacity:0;transition:opacity .3s;z-index:-1;}
// .act-card:hover{transform:translateY(-6px) scale(1.01);}
// .act-card:hover::before{opacity:1;}

// .gal-bento{display:grid;grid-template-columns:repeat(12,1fr);gap:14px;margin-bottom:8px;}
// .gbi-1{grid-column:span 5;grid-row:span 2;min-height:370px;}.gbi-2{grid-column:span 4;min-height:178px;}.gbi-3{grid-column:span 3;min-height:178px;}.gbi-4{grid-column:span 4;min-height:178px;}.gbi-5{grid-column:span 3;min-height:178px;}.gbi-6{grid-column:span 7;min-height:215px;}
// .gal-bento-item{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;background:var(--dark);opacity:0;transform:translateY(24px) scale(.98);transition:opacity .55s ease,transform .55s cubic-bezier(.25,1,.5,1);}
// .gal-bento-item.in{opacity:1;transform:translateY(0) scale(1);}
// .gal-bento-item::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 20px 56px rgba(94,14,115,.25);opacity:0;transition:opacity .3s;z-index:1;pointer-events:none;}
// .gal-bento-item:hover::before{opacity:1;}
// .gal-bento-item img{width:100%;height:100%;object-fit:cover;display:block;position:absolute;inset:0;transition:transform .5s;}
// .gal-bento-item:hover img{transform:scale(1.05);}
// .gal-bento-ovl{position:absolute;inset:0;background:rgba(94,14,115,.32);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;font-size:28px;color:#fff;z-index:2;}
// .gal-bento-item:hover .gal-bento-ovl{opacity:1;}

// .kp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:border-color .25s;margin-bottom:12px;}
// .kp-faq-item:hover{border-color:rgba(201,168,76,.4);}
// .kp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
// .kp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
// .kp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .25s,background .25s;font-size:15px;color:var(--p);}
// .kp-faq-item.open .kp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

// .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;}
// .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
// .enq-right{background:#fff;padding:40px 36px;}
// .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
// .enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s;color:var(--dark);}
// .enq-input:focus{border-color:var(--p);}
// .enq-input option{background:var(--dark);color:#fff;}
// .enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
// .enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
// .enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
// .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}

// .kp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);}
// .kp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.07) 0%,transparent 70%);pointer-events:none;}
// .kp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
// .kp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
// .kp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

// /* ── Reels ── */
// .kr-sec{padding:100px 0 110px;background:#120020;overflow:hidden;position:relative;font-family:'DM Sans',sans-serif;}
// .kr-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
// .kr-container{width:min(1320px,92%);margin:auto;position:relative;z-index:2;}
// .kr-header{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:52px;flex-wrap:wrap;gap:20px;animation:kr-fadeUp .8s cubic-bezier(.16,1,.3,1) both;}
// .kr-eyebrow{display:inline-flex;align-items:center;gap:8px;color:#E8D5A0;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin-bottom:14px;}
// .kr-eyebrow-line{width:32px;height:1px;background:#C9A84C;opacity:.6;}
// .kr-title{font-family:'Playfair Display',serif;font-size:clamp(32px,5vw,54px);font-weight:900;color:#fff;line-height:1.08;margin:0 0 10px;letter-spacing:-.5px;}
// .kr-title em{font-style:italic;color:#C9A84C;}
// .kr-sub{color:rgba(255,255,255,.5);font-size:15px;line-height:1.6;max-width:400px;}
// .kr-nav{display:flex;gap:12px;align-items:center;}
// .kr-nav-btn{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1.5px solid rgba(255,255,255,.14);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;font-weight:700;flex-shrink:0;}
// .kr-nav-btn:hover{background:#C9A84C;color:#120020;border-color:#C9A84C;transform:scale(1.08);}
// .kr-wrap{overflow:hidden;width:100%;}
// .kr-track{display:flex;gap:20px;transition:transform .65s cubic-bezier(.25,1,.5,1);will-change:transform;}
// .kr-card{position:relative;width:260px;min-width:260px;height:470px;border-radius:26px;overflow:hidden;background:#000;border:1px solid rgba(255,255,255,.07);transition:transform .4s cubic-bezier(.25,1,.5,1);flex-shrink:0;cursor:pointer;}
// .kr-card:hover{transform:translateY(-10px) scale(1.02);border-color:rgba(201,168,76,.5);}
// .kr-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
// .kr-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.95) 0%,rgba(13,0,24,.4) 45%,rgba(13,0,24,.08) 100%);pointer-events:none;}
// .kr-views{position:absolute;top:14px;left:14px;z-index:5;padding:5px 11px;border-radius:999px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.12);color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;gap:5px;}
// .kr-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.85);z-index:5;width:52px;height:52px;border-radius:50%;background:rgba(201,168,76,.9);display:flex;align-items:center;justify-content:center;font-size:18px;opacity:0;transition:opacity .3s,transform .3s;}
// .kr-card:hover .kr-play{opacity:1;transform:translate(-50%,-50%) scale(1);}
// .kr-info{position:absolute;left:0;right:0;bottom:0;z-index:5;padding:20px 18px 22px;}
// .kr-tag-pill{display:inline-block;background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.45);color:#C9A84C;font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:3px 10px;border-radius:50px;margin-bottom:8px;}
// .kr-info h3{margin:0;color:#fff;font-family:'Playfair Display',serif;font-size:17px;font-weight:700;line-height:1.3;}
// .kr-dots{display:flex;gap:8px;justify-content:center;margin-top:36px;}
// .kr-dot{height:8px;border-radius:4px;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .4s;}
// .kr-dot.active{width:28px!important;background:linear-gradient(90deg,#C9A84C,#E8D5A0);}
// .kr-cta{margin-top:52px;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;}
// .kr-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#120020;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
// .kr-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kr-shine 3.5s ease infinite;pointer-events:none;}
// .kr-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#120020;}
// .kr-btn-ig{display:inline-flex;align-items:center;gap:9px;border:1.5px solid rgba(255,255,255,.2);background:rgba(255,255,255,.05);color:#fff;border-radius:50px;padding:12px 28px;font-weight:700;font-size:14px;cursor:pointer;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
// .kr-btn-ig:hover{border-color:rgba(201,168,76,.5);color:#C9A84C;transform:translateY(-2px);}

// /* ── Video Testimonials ── */
// .kvt-sec{background:#120020;font-family:'DM Sans',sans-serif;position:relative;overflow:hidden;}
// .kvt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 65% 50% at 20% 10%,rgba(94,14,115,.28) 0%,transparent 65%),radial-gradient(ellipse 50% 40% at 80% 90%,rgba(201,168,76,.08) 0%,transparent 65%);pointer-events:none;z-index:0;}
// .kvt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:180px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kvt-header{padding:72px 60px 52px;display:flex;align-items:flex-end;justify-content:space-between;flex-wrap:wrap;gap:20px;position:relative;z-index:2;}
// .kvt-header::after{content:'';position:absolute;bottom:0;left:60px;right:60px;height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.25),transparent);}
// .kvt-eyebrow{display:flex;align-items:center;gap:10px;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:14px;}
// .kvt-eyebrow-line{width:26px;height:1px;background:#C9A84C;opacity:.55;}
// .kvt-h{font-family:'Playfair Display',serif;font-size:clamp(28px,4vw,46px);font-weight:700;color:#fff;line-height:1.1;margin:0;}
// .kvt-h em{font-style:italic;color:#C9A84C;}
// .kvt-counter{font-family:'Playfair Display',serif;font-size:14px;color:rgba(255,255,255,.3);flex-shrink:0;align-self:flex-end;}
// .kvt-counter span{color:#fff;font-size:18px;font-weight:700;}
// .kvt-stage{display:grid;grid-template-columns:1fr 340px;min-height:580px;position:relative;z-index:1;}
// .kvt-pane{position:relative;display:flex;align-items:center;justify-content:center;padding:40px 0 40px 60px;overflow:hidden;}
// .kvt-glow{position:absolute;width:420px;height:420px;border-radius:50%;background:radial-gradient(circle,rgba(94,14,115,.22) 0%,transparent 70%);top:50%;left:45%;transform:translate(-50%,-50%);pointer-events:none;z-index:0;transition:background .5s;}
// .kvt-glow.active{background:radial-gradient(circle,rgba(201,168,76,.1) 0%,rgba(94,14,115,.15) 50%,transparent 70%);}
// .kvt-reel{position:relative;width:min(300px,82%);aspect-ratio:9/16;border-radius:32px;overflow:hidden;background:#000;border:2px solid rgba(255,255,255,.1);box-shadow:0 40px 100px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.08);cursor:pointer;transition:border-color .35s;z-index:1;flex-shrink:0;-webkit-tap-highlight-color:transparent;user-select:none;}
// .kvt-reel:hover,.kvt-reel.playing{border-color:rgba(201,168,76,.5);}
// .kvt-notch{position:absolute;top:14px;left:50%;transform:translateX(-50%);width:80px;height:5px;background:rgba(255,255,255,.1);border-radius:3px;z-index:8;pointer-events:none;}
// .kvt-prog{position:absolute;top:0;left:0;right:0;height:3px;background:rgba(255,255,255,.08);z-index:6;}
// .kvt-prog-fill{height:100%;background:linear-gradient(90deg,#5E0E73,#C9A84C);border-radius:0 2px 2px 0;transition:width .1s linear;}
// .kvt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
// .kvt-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.96) 0%,rgba(13,0,24,.22) 45%,transparent 100%),linear-gradient(to bottom,rgba(13,0,24,.5) 0%,transparent 25%);pointer-events:none;z-index:2;}
// .kvt-pulse-ring{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:68px;height:68px;border-radius:50%;border:1.5px solid rgba(201,168,76,.5);z-index:4;pointer-events:none;animation:kvt-pulse 2.4s ease-in-out infinite;}
// .kvt-reel.playing .kvt-pulse-ring{display:none;}
// .kvt-play-area{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5;pointer-events:none;}
// .kvt-play-btn{width:68px;height:68px;border-radius:50%;background:rgba(255,255,255,.12);border:2px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;transition:all .3s cubic-bezier(.25,1,.5,1);opacity:0;transform:scale(.8);pointer-events:all;cursor:pointer;}
// .kvt-play-btn.show{opacity:1;transform:scale(1);animation:kvt-ctrlIn .22s ease-out;}
// .kvt-play-btn:hover{background:#C9A84C;border-color:#C9A84C;transform:scale(1.08);}
// .kvt-play-btn:hover svg{fill:#1A0030;}
// .kvt-play-btn svg{fill:#fff;transition:fill .2s;}
// .kvt-top-ctrl{position:absolute;top:24px;right:14px;z-index:7;display:flex;flex-direction:column;align-items:center;gap:8px;opacity:0;pointer-events:none;transition:opacity .22s;}
// .kvt-top-ctrl.show{opacity:1;pointer-events:all;}
// .kvt-ctrl-btn{width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,.55);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:13px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
// .kvt-ctrl-btn:hover{background:rgba(201,168,76,.35);border-color:#C9A84C;}
// .kvt-hint{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:.5px;text-transform:uppercase;background:rgba(0,0,0,.45);padding:3px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.08);white-space:nowrap;}
// .kvt-info{position:absolute;bottom:0;left:0;right:0;padding:18px 16px 22px;z-index:4;}
// .kvt-stars{display:flex;gap:3px;margin-bottom:9px;}
// .kvt-quote{font-family:'Playfair Display',serif;font-size:13px;font-style:italic;font-weight:600;color:#fff;line-height:1.55;margin:0 0 14px;animation:kvt-quoteIn .4s cubic-bezier(.25,1,.5,1) both;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
// .kvt-quote::before{content:'"';font-size:1.5em;line-height:0;vertical-align:-.35em;color:#C9A84C;margin-right:3px;opacity:.8;}
// .kvt-identity{display:flex;align-items:center;gap:10px;animation:kvt-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;}
// .kvt-avatar{width:38px;height:38px;border-radius:50%;border:2px solid rgba(201,168,76,.55);background:linear-gradient(135deg,#5E0E73,#6E1A85);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:#E8D5A0;flex-shrink:0;}
// .kvt-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:3px;}
// .kvt-meta{display:flex;align-items:center;gap:5px;flex-wrap:wrap;}
// .kvt-pill{background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:8px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:2px 8px;border-radius:50px;}
// .kvt-loc{font-size:10px;color:rgba(255,255,255,.4);}
// .kvt-transition{position:absolute;inset:0;background:#120020;z-index:10;opacity:0;pointer-events:none;transition:opacity .28s;}
// .kvt-transition.show{opacity:1;pointer-events:all;}
// .kvt-queue{background:rgba(255,255,255,.025);border-left:1px solid rgba(255,255,255,.06);display:flex;flex-direction:column;overflow:hidden;}
// .kvt-queue-header{padding:24px 24px 18px;border-bottom:1px solid rgba(255,255,255,.06);flex-shrink:0;}
// .kvt-queue-title{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.3);}
// .kvt-queue-list{flex:1;overflow-y:auto;padding:12px 0;scrollbar-width:thin;scrollbar-color:rgba(201,168,76,.2) transparent;}
// .kvt-queue-list::-webkit-scrollbar{width:4px;}.kvt-queue-list::-webkit-scrollbar-thumb{background:rgba(201,168,76,.2);border-radius:2px;}
// .kvt-q-item{display:flex;align-items:center;gap:14px;padding:12px 20px;cursor:pointer;transition:background .2s;border-left:3px solid transparent;}
// .kvt-q-item:hover{background:rgba(255,255,255,.04);}
// .kvt-q-item.active{background:rgba(201,168,76,.07);border-left-color:#C9A84C;}
// .kvt-q-thumb{width:50px;height:74px;border-radius:10px;overflow:hidden;flex-shrink:0;position:relative;border:1px solid rgba(255,255,255,.07);display:flex;align-items:center;justify-content:center;transition:border-color .2s;}
// .kvt-q-item.active .kvt-q-thumb{border-color:rgba(201,168,76,.4);}
// .kvt-q-bg{position:absolute;inset:0;background:linear-gradient(155deg,#3A0847 0%,#5E0E73 60%,rgba(201,168,76,.25) 100%);}
// .kvt-q-init{position:relative;z-index:1;font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:rgba(255,255,255,.75);}
// .kvt-q-item.active .kvt-q-init{color:#E8D5A0;}
// .kvt-q-eq-wrap{position:absolute;inset:0;background:rgba(13,0,24,.65);display:flex;align-items:center;justify-content:center;border-radius:9px;z-index:2;}
// .kvt-q-eq{display:flex;align-items:flex-end;gap:2.5px;height:18px;}
// .kvt-q-bar{width:3px;background:#C9A84C;border-radius:2px;animation:kvt-eqBar 1s ease-in-out infinite;}
// .kvt-q-bar:nth-child(2){animation-delay:.18s;}.kvt-q-bar:nth-child(3){animation-delay:.36s;}
// .kvt-q-info{flex:1;min-width:0;}
// .kvt-q-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:3px;}
// .kvt-q-item.active .kvt-q-name{color:#E8D5A0;}
// .kvt-q-event{font-size:11px;color:rgba(255,255,255,.35);}
// .kvt-q-num{font-size:11px;color:rgba(255,255,255,.2);flex-shrink:0;font-family:'Playfair Display',serif;}
// .kvt-q-item.active .kvt-q-num{color:#C9A84C;font-weight:700;}
// .kvt-queue-nav{padding:16px 20px;border-top:1px solid rgba(255,255,255,.06);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
// .kvt-nav-label{font-size:11px;color:rgba(255,255,255,.25);letter-spacing:1px;text-transform:uppercase;}
// .kvt-nav-arrows{display:flex;gap:8px;}
// .kvt-nav-btn{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.55);font-size:17px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
// .kvt-nav-btn:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
// .kvt-strip{padding:28px 60px 56px;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;border-top:1px solid rgba(255,255,255,.05);position:relative;z-index:2;}
// .kvt-ratings{display:flex;align-items:center;gap:28px;flex-wrap:wrap;}
// .kvt-r-item{text-align:center;}
// .kvt-r-num{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#C9A84C;line-height:1;}
// .kvt-r-label{font-size:10px;color:rgba(255,255,255,.28);text-transform:uppercase;letter-spacing:1px;margin-top:4px;}
// .kvt-r-sep{width:1px;height:36px;background:rgba(255,255,255,.06);}
// .kvt-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#1A0030;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;flex-shrink:0;transition:transform .25s,opacity .25s;}
// .kvt-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kvt-shine 3.5s ease infinite;pointer-events:none;}
// .kvt-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#1A0030;}

// /* ── Written Reviews ── */
// .kt-sec{padding:100px 0 88px;background:#1A0030;position:relative;overflow:hidden;font-family:'DM Sans',sans-serif;}
// .kt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 55% at 15% 5%,rgba(94,14,115,.32) 0%,transparent 65%),radial-gradient(ellipse 55% 45% at 85% 95%,rgba(201,168,76,.09) 0%,transparent 65%);pointer-events:none;}
// .kt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:200px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:10px;}
// .kt-h{font-family:'Playfair Display',serif;font-size:clamp(30px,4.5vw,52px);font-weight:700;line-height:1.15;color:#fff;margin:0;}
// .kt-h span{color:#C9A84C;}
// .kt-sub{color:rgba(255,255,255,.5);font-size:14px;line-height:1.75;margin:12px auto 0;max-width:500px;}
// .kt-stats{display:flex;align-items:center;justify-content:center;gap:40px;margin-top:40px;flex-wrap:wrap;}
// .kt-stat{text-align:center;}
// .kt-sn{font-family:'Playfair Display',serif;font-size:34px;font-weight:700;color:#C9A84C;line-height:1;}
// .kt-sl{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:1.5px;text-transform:uppercase;margin-top:5px;}
// .kt-ssep{width:1px;height:44px;background:rgba(255,255,255,.08);}
// .kt-feat{border-radius:28px;overflow:hidden;width:100%;height:100%;background:rgba(255,255,255,.04);border:1px solid rgba(201,168,76,.22);position:relative;}
// .kt-feat::before{content:'';display:block;width:100%;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-feat-in{padding:30px 28px 26px;}
// .kt-big-q{font-family:'Playfair Display',serif;font-size:130px;font-weight:900;line-height:.8;color:rgba(201,168,76,.055);position:absolute;top:20px;right:16px;user-select:none;pointer-events:none;}
// .kt-fi-wrap{position:relative;width:100%;height:240px;overflow:hidden;border-radius:18px;margin-bottom:22px;}
// .kt-fi{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
// .kt-feat:hover .kt-fi{transform:scale(1.04);}
// .kt-fi-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
// .kt-fi-badge{position:absolute;bottom:14px;left:14px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;}
// .kt-review{font-size:15px;color:rgba(255,255,255,.82);line-height:1.8;font-style:italic;margin:0 0 22px;}
// .kt-div{height:1px;margin-bottom:18px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent);}
// .kt-author{display:flex;align-items:center;gap:14px;}
// .kt-avatar{width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2.5px solid rgba(201,168,76,.45);}
// .kt-aname{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:#fff;}
// .kt-aloc{font-size:11px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:.5px;margin-top:2px;}
// .kt-v{margin-left:auto;flex-shrink:0;width:30px;height:30px;border-radius:50%;background:linear-gradient(135deg,#5E0E73,#C9A84C);display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;font-weight:700;}
// .kt-prev{background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.08);border-radius:20px;overflow:hidden;cursor:pointer;transition:transform .3s;display:flex;flex-direction:column;flex:1;}
// .kt-prev:hover{transform:translateY(-5px);background:rgba(255,255,255,.06);border-color:rgba(201,168,76,.28);}
// .kt-pi{width:100%;height:155px;object-fit:cover;display:block;transition:transform .4s;filter:brightness(.8);}
// .kt-prev:hover .kt-pi{transform:scale(1.04);filter:brightness(1);}
// .kt-pb{padding:15px 17px;flex:1;display:flex;flex-direction:column;}
// .kt-pt{font-size:12px;color:rgba(255,255,255,.55);line-height:1.65;font-style:italic;margin:8px 0 10px;flex:1;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
// .kt-pn{font-size:13px;font-weight:700;color:rgba(255,255,255,.85);font-family:'Playfair Display',serif;}
// .kt-pl{font-size:10px;color:rgba(255,255,255,.3);margin-top:2px;}
// .kt-pr{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;color:#C9A84C;letter-spacing:1px;text-transform:uppercase;padding:4px 12px;border:1px solid rgba(201,168,76,.25);border-radius:50px;background:transparent;width:fit-content;transition:background .2s;}
// .kt-prev:hover .kt-pr{background:rgba(201,168,76,.12);border-color:rgba(201,168,76,.5);}
// .kt-nav{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:36px;}
// .kt-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.15);border:none;cursor:pointer;transition:width .35s,background .35s;}
// .kt-dot.on{width:34px;border-radius:4px;background:linear-gradient(90deg,#5E0E73,#C9A84C);}
// .kt-arr{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:rgba(255,255,255,.6);font-size:20px;cursor:pointer;transition:transform .2s,background .2s;display:flex;align-items:center;justify-content:center;}
// .kt-arr:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
// .kt-plat{display:flex;justify-content:center;align-items:center;gap:32px;flex-wrap:wrap;margin-top:60px;padding:26px 44px;background:rgba(255,255,255,.025);border:1px solid rgba(255,255,255,.055);border-radius:22px;}
// .kt-plat-item{text-align:center;}
// .kt-plat-name{font-size:10px;color:rgba(255,255,255,.3);letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;}
// .kt-plat-row{display:flex;align-items:center;gap:7px;}
// .kt-plat-sc{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#fff;}
// .kt-plat-cnt{font-size:10px;color:rgba(255,255,255,.25);margin-top:3px;}
// .kt-psep{width:1px;height:40px;background:rgba(255,255,255,.07);}
// .kt-cta{text-align:center;margin-top:60px;padding:52px 40px;background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5));border:1px solid rgba(201,168,76,.1);border-radius:28px;position:relative;overflow:hidden;}
// .kt-cta::before{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:120px;height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
// .kt-cta-h{font-family:'Playfair Display',serif;font-size:clamp(22px,3vw,32px);font-weight:700;color:#fff;margin:0 0 8px;}
// .kt-cta-h span{color:#C9A84C;}
// .kt-cta-sub{font-size:14px;color:rgba(255,255,255,.4);margin-bottom:28px;}
// .kt-cta-row{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
// .kt-btn-bk{background:linear-gradient(135deg,#5E0E73,#6E1A85);color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-block;transition:transform .25s,opacity .25s;}
// .kt-btn-bk:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
// .kt-btn-wa{background:#25D366;color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;transition:transform .25s,opacity .25s;}
// .kt-btn-wa:hover{transform:translateY(-2px);opacity:.9;color:#fff;}

// /* ── Responsive ── */
// @media(max-width:1024px){
//   .kvt-stage{grid-template-columns:1fr 280px;}
//   .kvt-header,.kvt-strip{padding-left:32px;padding-right:32px;}
//   .kvt-pane{padding-left:40px;}
//   .svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}
// }
// @media(max-width:768px){
//   .kp-hero-cnt{padding:50px 0 32px;}
//   .kp-hero-float{display:none!important;}
//   .kp-hero-vid-wrap{max-height:340px;margin-top:20px;border-radius:20px;}
//   .kp-hero-title{font-size:clamp(28px,6vw,40px)!important;}
//   .kp-hero-sub{font-size:14px!important;margin-bottom:18px;}
//   .kp-trust-row{gap:16px;margin-top:18px;}
//   .kp-trust-item .num{font-size:22px;}
//   .kp-hero-cnt .cc-btn-gold,.kp-hero-cnt .cc-btn-outline{width:100%;justify-content:center;}
//   .theme-card{width:200px;}.theme-img{height:240px;}
//   .gal-bento{grid-template-columns:repeat(6,1fr);gap:10px;}
//   .gbi-1{grid-column:span 3;grid-row:span 2;min-height:250px;}
//   .gbi-2,.gbi-3{grid-column:span 3;min-height:120px;}
//   .gbi-4,.gbi-5,.gbi-6{grid-column:span 2;min-height:135px;}
//   .enq-wrap .row{flex-direction:column;}
//   .enq-left{order:2;padding:26px 22px;}
//   .enq-right{order:1;padding:26px 22px;}
//   .kr-sec{padding:70px 0 80px;}.kr-header{margin-bottom:36px;}.kr-title{font-size:clamp(28px,7vw,38px);}
//   .kvt-stage{grid-template-columns:1fr;grid-template-rows:auto auto;}
//   .kvt-pane{padding:32px 20px;min-height:480px;}
//   .kvt-reel{width:min(250px,74%);}
//   .kvt-queue{border-left:none;border-top:1px solid rgba(255,255,255,.06);max-height:190px;}
//   .kvt-queue-list{display:flex;flex-direction:row;overflow-y:hidden;overflow-x:auto;padding:10px;gap:10px;}
//   .kvt-q-item{flex-direction:column;align-items:center;text-align:center;min-width:84px;border-left:none;border-bottom:3px solid transparent;padding:8px;border-radius:12px;}
//   .kvt-q-item.active{border-bottom-color:#C9A84C;border-left-color:transparent;}
//   .kvt-q-thumb{width:50px;height:76px;}
//   .kvt-q-num{display:none;}
//   .kvt-header{padding:40px 20px 32px;}
//   .kvt-strip{padding:20px 20px 36px;flex-direction:column;align-items:flex-start;}
//   .kvt-r-sep{display:none;}
//   .kt-sec{padding:64px 0 56px;}
//   .kt-fi-wrap{height:200px;}
//   .kt-ssep{display:none;}
//   .kt-plat{gap:20px;padding:20px 24px;}
//   .kt-psep{display:none;}
// }
// @media(max-width:640px){
//   .kp-sec{padding:48px 0;}.kp-sec-sm{padding:28px 0;}
//   .container{padding-left:16px;padding-right:16px;}
//   .cc-h{font-size:clamp(22px,6.5vw,30px);}
//   .kp-hero-cnt{padding:40px 0 26px;}
//   .kp-hero-title{font-size:clamp(24px,7vw,32px)!important;line-height:1.1;}
//   .kp-hero-sub{font-size:13px!important;}
//   .kp-hero-vid-wrap{max-height:270px;border-radius:16px;}
//   .cc-btn,.cc-btn-gold,.cc-btn-outline,.wa-btn{min-height:46px;padding:12px 20px!important;font-size:13px;}
//   .theme-card{width:170px;}.theme-img{height:210px;}
//   .svc-grid{grid-template-columns:1fr 1fr;gap:10px;}
//   .svc-img-wrap{height:130px;}
//   .kr-card{height:420px;}.kr-info h3{font-size:15px;}.kr-nav-btn{width:40px;height:40px;font-size:17px;}
//   .gal-bento{grid-template-columns:1fr 1fr;gap:8px;}
//   .gbi-1{grid-column:span 2;min-height:175px;grid-row:span 1;}
//   .gbi-2,.gbi-3,.gbi-4,.gbi-5{grid-column:span 1;min-height:125px;}
//   .gbi-6{grid-column:span 2;min-height:145px;}
//   .enq-left,.enq-right{padding:20px 16px;}
//   .enq-input{padding:11px 13px;font-size:13px;}
//   .kp-faq-q{font-size:13px;padding:12px 16px;}
//   .kp-faq-a{font-size:12px;padding:0 16px 12px;}
//   .kvt-h{font-size:clamp(24px,7vw,32px);}
//   .kt-feat-in{padding:20px 18px;}
//   .kt-fi-wrap{height:170px;}
//   .kt-review{font-size:13px;}
//   .kt-cta{padding:32px 18px;}
//   .kt-plat{padding:18px 16px;gap:16px;}
// }
// @media(max-width:400px){
//   .cc-h{font-size:clamp(20px,7vw,26px);}
//   .kp-hero-title{font-size:clamp(22px,7.5vw,28px)!important;}
//   .kp-hero-vid-wrap{max-height:230px;}
//   .svc-grid{grid-template-columns:1fr;}
//   .theme-card{width:150px;}
// }
// @media(hover:none) and (pointer:coarse){
//   .theme-card:hover,.svc-card:hover,.act-card:hover,.kr-card:hover,.kt-prev:hover,.gal-bento-item:hover{transform:none!important;}
//   .svc-card:hover::before,.act-card:hover::before,.gal-bento-item:hover::before{opacity:0!important;}
//   .svc-card:hover .svc-img,.theme-card:hover .theme-img,.gal-bento-item:hover img{transform:none!important;}
//   .svc-card:hover .svc-glow,.gal-bento-item:hover .gal-bento-ovl{opacity:0!important;}
//   .kp-hero-float{animation:none!important;display:none!important;}
//   .kp-ticker-track{animation-duration:40s!important;}
// }
// `;

// /* ─── Static data ────────────────────────────────────────────────── */
// const KID_THEMES=[
//   {name:"Dinosaur Adventure",bookings:"487",tags:["Dinos","Jungle"],img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80",emoji:"🦕"},
//   {name:"Princess Royal",bookings:"562",tags:["Princess","Castle"],img:"https://plus.unsplash.com/premium_photo-1664205766214-9e3f453ef4cc?q=80",emoji:"👑"},
//   {name:"Space Explorer",bookings:"398",tags:["Space","Galaxy"],img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80",emoji:"🚀"},
//   {name:"Underwater World",bookings:"312",tags:["Ocean","Fish"],img:"https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&q=80",emoji:"🐠"},
//   {name:"Superhero Academy",bookings:"445",tags:["Hero","Action"],img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80",emoji:"⚡"},
//   {name:"Candyland",bookings:"534",tags:["Sweet","Candy"],img:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80",emoji:"🍭"},
// ];
// const KID_ACTIVITIES=[
//   {name:"Bouncy Castle",dur:"30 mins",age:"3–12",img:"https://images.unsplash.com/photo-1632765471084-9f2ab98365bf?q=80"},
//   {name:"Balloon Twisting",dur:"45 mins",age:"All ages",img:"https://images.unsplash.com/photo-1727695034153-ff948d488bb1?q=80"},
//   {name:"Face Painting",dur:"1 hour",age:"3–12",img:"https://images.unsplash.com/photo-1661708733650-58062da7eecf?q=80"},
//   {name:"Magic Show",dur:"30 mins",age:"All ages",img:"https://images.unsplash.com/photo-1641478859026-c2728062c1e1?q=80"},
// ];
// const SERVICE_CARDS=[
//   {label:"Themed Decor",img:"https://images.unsplash.com/photo-1765947382841-24c48f1c987e?q=80",desc:"Complete themed decor — balloons, backdrops, props & more."},
//   {label:"Custom Cakes",img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",desc:"3D themed cakes crafted by our in-house bakers."},
//   {label:"Food & Snacks",img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80",desc:"Kid-friendly menus with vegetarian & non-veg options."},
//   {label:"Photography",img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80",desc:"Professional candid photography — memories forever."},
// ];
// const REELS=[
//   {views:"487K",title:"Princess Royal Setup",tag:"Princess",video:"/assets/videos/Kids_Birthday.mp4"},
//   {views:"312K",title:"Dinosaur Adventure Party",tag:"Dino Theme",video:"/assets/videos/Car_Entry.mp4"},
//   {views:"534K",title:"Candyland Celebration",tag:"Candyland",video:"/assets/videos/Private_Theatres.mp4"},
//   {views:"445K",title:"Superhero Academy Bash",tag:"Superhero",video:"/assets/videos/Ayansh_Birthday.mp4"},
//   {views:"398K",title:"Space Explorer Birthday",tag:"Space",video:"/assets/videos/Little_bundle_of_joy_Svojass.mp4"},
//   {views:"562K",title:"Bouncy Castle Fun",tag:"Activities",video:"/assets/videos/Angel_Dhanvika.mp4"},
// ];
// const VID_TESTI=[
//   {src:"/assets/videos/Car_Entry.mp4",name:"Priya & Family",event:"Princess Royal",loc:"Banjara Hills",quote:"The princess setup was out of this world. Our daughter was speechless!",rating:5},
//   {src:"/assets/videos/Private_Theatres.mp4",name:"Ravi Mehta",event:"Superhero Academy",loc:"Jubilee Hills",quote:"Every child felt like a real superhero. Absolutely unforgettable party!",rating:5},
//   {src:"/assets/videos/Kids_Birthday.mp4",name:"Sunita Verma",event:"Dinosaur Adventure",loc:"Madhapur",quote:"The Dino theme was executed perfectly. Kids were amazed the whole time.",rating:5},
//   {src:"/assets/videos/Little_bundle_of_joy_Svojass.mp4",name:"Arjun & Deepa",event:"Candyland Theme",loc:"Kondapur",quote:"My daughter still talks about her Candyland party every single day!",rating:5},
//   {src:"/assets/videos/Ayansh_Birthday.mp4",name:"Kavitha Nair",event:"Space Explorer",loc:"Gachibowli",quote:"The galaxy décor and space activities were beyond our expectations!",rating:5},
// ];
// const REVIEWS=[
//   {name:"Priya & Arjun",location:"Banjara Hills",rating:5,occasion:"Princess Royal Theme",text:"My daughter's 5th birthday was absolutely magical! The princess theme was so detailed — from the crown décor to the pink fog entry. She was in tears of joy.",image:"https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=800&q=80",avatar:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80"},
//   {name:"Rahul Mehta",location:"Jubilee Hills",rating:5,occasion:"Superhero Academy",text:"Booked the Superhero theme for my son's birthday and every child was completely blown away. The costumes, the activities, the cake — all perfect.",image:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=800&q=80",avatar:"https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80"},
//   {name:"Sunita Varma",location:"Madhapur",rating:5,occasion:"Dinosaur Adventure",text:"The Dinosaur theme was beyond imagination. Kids were running around in awe, the activities were age-perfect and the photographer captured every precious moment.",image:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=800&q=80",avatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80"},
//   {name:"Vikram Desai",location:"Kondapur",rating:5,occasion:"Candyland Theme",text:"Candyland for my daughter's 7th birthday — she still talks about it every week! The attention to detail in the sweet-themed décor and the custom cake was incredible.",image:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=800&q=80",avatar:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80"},
//   {name:"Kavitha Nair",location:"Gachibowli",rating:5,occasion:"Space Explorer",text:"Space Explorer theme exceeded every expectation. The galaxy décor, the activities, the glow-in-dark props — the kids felt like real astronauts.",image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=800&q=80",avatar:"https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80"},
//   {name:"Sanjay Pillai",location:"Kukatpally",rating:5,occasion:"Royal Celebration",text:"The Royal Celebration package for my son's 8th birthday — the magic show, goodie bags, 3-tier custom cake. Every detail handled with care.",image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80",avatar:"https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80"},
// ];
// const KID_GALLERY=["/assets/img/m1.jpg","/assets/img/m2.jpg","/assets/img/m3.jpg","/assets/img/m4.jpg","/assets/img/m5.jpg","/assets/img/m6.jpg"];
// const KID_FAQ=[
//   {q:"What age group are these parties for?",a:"Our kids' parties are designed for children aged 2–12 years. Every theme and activity is age-appropriate and fully customizable."},
//   {q:"Can we bring our own cake?",a:"Absolutely! You're welcome to bring your own cake. We'll display it beautifully as part of the celebration decor."},
//   {q:"Do you provide return gifts?",a:"Yes! Personalized goodie bags, toys, stationery — tailored to your budget and chosen theme."},
//   {q:"How far in advance should we book?",a:"We recommend 2–3 weeks for weekdays, 4–6 weeks for popular weekend themes like Princess & Superhero."},
//   {q:"Is parental supervision required?",a:"Our trained staff supervises all activities, but we recommend 2–3 guardians stay present throughout the party."},
// ];

// /* ─── Helpers ────────────────────────────────────────────────────── */
// function Stars({rating=5,size=13}){
//   return <div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:size,color:n<=rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>;
// }
// const scrollTo=id=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});

// /* ─── Isolated memo sub-components ──────────────────────────────── */
// const HeroVideo=memo(()=>{
//   const r=useRef(null);
//   useEffect(()=>{if(r.current){r.current.muted=true;r.current.play().catch(()=>{});}});
//   return(
//     <div className="kp-hero-vid-wrap">
//       <video ref={r} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} src="/assets/videos/Kids_Birthday.mp4" muted autoPlay loop playsInline preload="none"/>
//       <div className="kp-hero-vid-ovl"/>
//       <div className="kp-hero-vid-badge"><div className="kp-hero-vid-pulse"/><span className="kp-hero-vid-label">🎉 LIVE — Real Birthday Celebrations</span></div>
//     </div>
//   );
// });

// const ThemeCarousel=memo(({navigate})=>{
//   const [idx,setIdx]=useState(0);
//   useEffect(()=>{const t=setInterval(()=>setIdx(i=>(i+1)%KID_THEMES.length),3500);return()=>clearInterval(t);},[]);
//   return(
//     <section className="kp-sec" style={{background:C.dark,overflow:"hidden"}}>
//       <div className="container">
//         <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:44,flexWrap:"wrap",gap:20}}>
//           <div><span className="cc-tag cc-tag-light">✦ 20+ Dream Themes ✦</span><h2 className="cc-h cc-h-white">Your Child's <span className="gold">Fantasy</span> Brought to Life</h2></div>
//           <div style={{display:"flex",gap:10}}>
//             <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i-1+KID_THEMES.length)%KID_THEMES.length)}>‹</button>
//             <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i+1)%KID_THEMES.length)}>›</button>
//           </div>
//         </div>
//         <div style={{overflow:"hidden"}}>
//           <div style={{display:"flex",gap:18,transition:"transform .7s cubic-bezier(.25,1,.5,1)",transform:`translateX(calc(-${idx*(280+18)}px))`}}>
//             {[...KID_THEMES,...KID_THEMES].map((t,i)=>(
//               <div key={i} className="theme-card" onClick={()=>navigate("/locations")}>
//                 <div className="kp-emoji-badge">{t.emoji}</div>
//                 <img src={t.img} alt={t.name} className="theme-img" loading="lazy"/>
//                 <div className="theme-ovl">
//                   <div className="theme-name">{t.name}</div>
//                   <div className="theme-booked">🔥 {t.bookings} booked</div>
//                   <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>{t.tags.map((tg,j)=><span key={j} className="theme-tag">{tg}</span>)}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:26}}>
//           {KID_THEMES.map((_,i)=><button key={i} onClick={()=>setIdx(i)} style={{width:i===idx?26:8,height:8,borderRadius:8,background:i===idx?C.gold:"rgba(255,255,255,.2)",border:"none",cursor:"pointer",transition:"all .4s"}}/>)}
//         </div>
//       </div>
//     </section>
//   );
// });

// const ReelsSection=memo(()=>{
//   const [idx,setIdx]=useState(0);
//   const [hovered,setHovered]=useState(false);
//   const [vis,setVis]=useState(4);
//   const tRef=useRef(null);
//   useEffect(()=>{const u=()=>{const w=window.innerWidth;setVis(w<540?1:w<768?2:w<1100?3:4);};u();window.addEventListener("resize",u);return()=>window.removeEventListener("resize",u);},[]);
//   const max=REELS.length-vis;
//   const start=useCallback(()=>{clearInterval(tRef.current);tRef.current=setInterval(()=>setIdx(i=>i>=max?0:i+1),3000);},[max]);
//   useEffect(()=>{if(!hovered)start();else clearInterval(tRef.current);return()=>clearInterval(tRef.current);},[hovered,start]);
//   const IGIcon=()=><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>;
//   return(
//     <section className="kr-sec">
//       <div className="kr-orb" style={{width:460,height:460,background:"radial-gradient(circle,rgba(94,14,115,.28) 0%,transparent 70%)",top:-80,left:-80}}/>
//       <div className="kr-orb" style={{width:320,height:320,background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)",bottom:-60,right:-40}}/>
//       <div className="kr-container">
//         <div className="kr-header">
//           <div>
//             <div className="kr-eyebrow"><div className="kr-eyebrow-line"/>Party Reels<div className="kr-eyebrow-line"/></div>
//             <h2 className="kr-title">Watch the <em>Magic</em><br/>Happen Live</h2>
//             <p className="kr-sub">Real parties. Real smiles. Real unforgettable moments from our little guests.</p>
//           </div>
//           <div className="kr-nav">
//             <button className="kr-nav-btn" onClick={()=>{setIdx(i=>Math.max(0,i-1));start();}}>‹</button>
//             <button className="kr-nav-btn" onClick={()=>{setIdx(i=>i>=max?0:i+1);start();}}>›</button>
//           </div>
//         </div>
//         <div className="kr-wrap" onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)}>
//           <div className="kr-track" style={{transform:`translateX(${-(idx*280)}px)`}}>
//             {REELS.map((r,i)=>(
//               <div key={i} className="kr-card">
//                 <video className="kr-video" src={r.video} autoPlay muted loop playsInline preload="none"/>
//                 <div className="kr-ovl"/>
//                 <div className="kr-views">👁 {r.views}</div>
//                 <div className="kr-play">▶</div>
//                 <div className="kr-info"><div className="kr-tag-pill">{r.tag}</div><h3>{r.title}</h3></div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="kr-dots">
//           {Array.from({length:REELS.length-vis+1}).map((_,i)=>(
//             <button key={i} className={`kr-dot${i===idx?" active":""}`} style={{width:i===idx?28:8}} onClick={()=>{setIdx(i);start();}}/>
//           ))}
//         </div>
//         <div className="kr-cta">
//           <a href="https://www.instagram.com/carnivalcastle.in" target="_blank" rel="noopener noreferrer" className="kr-btn-ig"><IGIcon/> Follow @carnivalcastle</a>
//           <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kr-btn-gold">🎈 Book Your Party</a>
//         </div>
//       </div>
//     </section>
//   );
// });

// const VideoTestimonials=memo(()=>{
//   const [ai,setAi]=useState(0);
//   const [playing,setPlaying]=useState(false);
//   const [muted,setMuted]=useState(true);
//   const [progress,setProgress]=useState(0);
//   const [trans,setTrans]=useState(false);
//   const [showCtrl,setShowCtrl]=useState(false);
//   const vRef=useRef(null),sRef=useRef(null),aRef=useRef(null),cRef=useRef(null);
//   const cur=VID_TESTI[ai];
//   useEffect(()=>{const el=sRef.current;if(!el)return;const o=new IntersectionObserver(([e])=>{if(!e.isIntersecting){vRef.current?.pause();setPlaying(false);}},{threshold:.25});o.observe(el);return()=>o.disconnect();},[]);
//   useEffect(()=>{const v=vRef.current;if(!v)return;v.pause();v.currentTime=0;setPlaying(false);setProgress(0);},[ai]);
//   useEffect(()=>{const v=vRef.current;if(!v)return;const t=()=>{if(v.duration)setProgress((v.currentTime/v.duration)*100);};const e=()=>{setPlaying(false);setProgress(0);};v.addEventListener("timeupdate",t);v.addEventListener("ended",e);return()=>{v.removeEventListener("timeupdate",t);v.removeEventListener("ended",e);};},[ai]);
//   useEffect(()=>{if(vRef.current)vRef.current.muted=muted;},[muted]);
//   const sc=()=>{setShowCtrl(true);clearTimeout(cRef.current);cRef.current=setTimeout(()=>setShowCtrl(false),2500);};
//   const onEnter=()=>{sc();const v=vRef.current;if(v&&!playing){v.muted=muted;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
//   const onLeave=()=>{setShowCtrl(false);clearTimeout(cRef.current);if(vRef.current&&playing){vRef.current.pause();setPlaying(false);}};
//   const onTouch=e=>{e.preventDefault();sc();const v=vRef.current;if(!v)return;if(playing){v.pause();setPlaying(false);}else{v.muted=muted;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
//   const tog=e=>{e.stopPropagation();const v=vRef.current;if(!v)return;if(playing){v.pause();setPlaying(false);}else{v.muted=muted;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
//   const goTo=useCallback(i=>{if(i===ai||trans)return;setTrans(true);setTimeout(()=>{setAi(i);setTrans(false);},300);},[ai,trans]);
//   useEffect(()=>{if(!playing){aRef.current=setInterval(()=>setAi(i=>(i+1)%VID_TESTI.length),5000);}else{clearInterval(aRef.current);}return()=>clearInterval(aRef.current);},[playing]);
//   return(
//     <section className="kvt-sec" ref={sRef}>
//       <div className="kvt-header">
//         <div><div className="kvt-eyebrow"><div className="kvt-eyebrow-line"/>Parent Stories<div className="kvt-eyebrow-line"/></div><h2 className="kvt-h">Real Parents,<br/><em>Real Happy Kids</em></h2></div>
//         <div className="kvt-counter"><span>{String(ai+1).padStart(2,"0")}</span>{" / "+String(VID_TESTI.length).padStart(2,"0")}</div>
//       </div>
//       <div className="kvt-stage">
//         <div className={`kvt-transition${trans?" show":""}`}/>
//         <div className="kvt-pane">
//           <div className={`kvt-glow${playing?" active":""}`}/>
//           <div className={`kvt-reel${playing?" playing":""}`} onMouseEnter={onEnter} onMouseLeave={onLeave} onMouseMove={sc} onTouchStart={onTouch}>
//             <div className="kvt-notch"/>
//             <div className="kvt-prog"><div className="kvt-prog-fill" style={{width:`${progress}%`}}/></div>
//             <video key={ai} ref={vRef} className="kvt-video" src={cur.src} muted={muted} playsInline preload="metadata"/>
//             <div className="kvt-ovl"/>
//             {!playing&&<div className="kvt-pulse-ring"/>}
//             <div className="kvt-play-area">
//               <button className={`kvt-play-btn${showCtrl?" show":""}`} onClick={tog}>
//                 {playing?<svg width="20" height="20" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>:<svg width="20" height="20" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>}
//               </button>
//             </div>
//             <div className={`kvt-top-ctrl${showCtrl?" show":""}`}>
//               <button className="kvt-ctrl-btn" onClick={e=>{e.stopPropagation();setMuted(m=>!m);}}>{muted?"🔇":"🔊"}</button>
//               <span className="kvt-hint">{playing?"Move away to stop":"Hover to play"}</span>
//             </div>
//             <div className="kvt-info" key={ai}>
//               <div className="kvt-stars">{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:13,color:n<=cur.rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>
//               <p className="kvt-quote">{cur.quote}</p>
//               <div className="kvt-identity">
//                 <div className="kvt-avatar">{cur.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</div>
//                 <div><div className="kvt-name">{cur.name}</div><div className="kvt-meta"><span className="kvt-pill">{cur.event}</span><span className="kvt-loc">📍 {cur.loc}</span></div></div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="kvt-queue">
//           <div className="kvt-queue-header"><div className="kvt-queue-title">Up Next</div></div>
//           <div className="kvt-queue-list">
//             {VID_TESTI.map((t,i)=>(
//               <div key={i} className={`kvt-q-item${i===ai?" active":""}`} onClick={()=>goTo(i)}>
//                 <div className="kvt-q-thumb"><div className="kvt-q-bg"/><span className="kvt-q-init">{t.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</span>
//                   {i===ai&&playing&&<div className="kvt-q-eq-wrap"><div className="kvt-q-eq"><div className="kvt-q-bar"/><div className="kvt-q-bar"/><div className="kvt-q-bar"/></div></div>}
//                 </div>
//                 <div className="kvt-q-info"><div className="kvt-q-name">{t.name}</div><div className="kvt-q-event">{t.event} · {t.loc}</div></div>
//                 <div className="kvt-q-num">{String(i+1).padStart(2,"0")}</div>
//               </div>
//             ))}
//           </div>
//           <div className="kvt-queue-nav">
//             <span className="kvt-nav-label">Navigate</span>
//             <div className="kvt-nav-arrows">
//               <button className="kvt-nav-btn" onClick={()=>goTo((ai-1+VID_TESTI.length)%VID_TESTI.length)}>‹</button>
//               <button className="kvt-nav-btn" onClick={()=>goTo((ai+1)%VID_TESTI.length)}>›</button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="kvt-strip">
//         <div className="kvt-ratings">
//           {[{num:"4.9★",label:"Google"},{num:"4.8★",label:"Facebook"},{num:"2000+",label:"Parties"},{num:"99%",label:"Happy Parents"}].map((item,i,arr)=>(
//             <React.Fragment key={i}>{i>0&&<div className="kvt-r-sep"/>}<div className="kvt-r-item"><div className="kvt-r-num">{item.num}</div><div className="kvt-r-label">{item.label}</div></div></React.Fragment>
//           ))}
//         </div>
//         <button onClick={()=>scrollTo("enquiry")} className="kvt-btn-gold">🎈 Book Your Party</button>
//       </div>
//     </section>
//   );
// });

// const WrittenReviews=memo(()=>{
//   const [ai,setAi]=useState(0);
//   const aRef=useRef(null);
//   const start=()=>{clearInterval(aRef.current);aRef.current=setInterval(()=>setAi(i=>(i+1)%REVIEWS.length),4800);};
//   useEffect(()=>{start();return()=>clearInterval(aRef.current);},[]);
//   const goTo=i=>{setAi((i+REVIEWS.length)%REVIEWS.length);clearInterval(aRef.current);start();};
//   const cur=REVIEWS[ai];
//   const prev=REVIEWS[(ai-1+REVIEWS.length)%REVIEWS.length];
//   const next=REVIEWS[(ai+1)%REVIEWS.length];
//   const avg=(REVIEWS.reduce((s,r)=>s+r.rating,0)/REVIEWS.length).toFixed(1);
//   return(
//     <section className="kt-sec">
//       <div className="container" style={{position:"relative",zIndex:1}}>
//         <div className="text-center">
//           <span className="kt-tag">✦ Parent Stories ✦</span>
//           <h2 className="kt-h">Real Parties,<br/><span>Real Happy Kids</span></h2>
//           <p className="kt-sub">Hear from parents — their children's joy, their stories, their most magical moments.</p>
//         </div>
//         <div className="kt-stats">
//           <div className="kt-stat"><div className="kt-sn">{avg}</div><div style={{display:"flex",justifyContent:"center",gap:2,margin:"5px 0 4px"}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div><div className="kt-sl">Average Rating</div></div>
//           <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">2000+</div><div className="kt-sl">Happy Parties</div></div>
//           <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">99%</div><div className="kt-sl">Would Return</div></div>
//           <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">4.9</div><div className="kt-sl">Google Rating</div></div>
//         </div>
//         <div style={{marginTop:56}}>
//           <div className="row g-4 align-items-stretch">
//             <div className="col-lg-7" style={{display:"flex"}}>
//               <div className="kt-feat">
//                 <div className="kt-big-q">"</div>
//                 <div className="kt-feat-in">
//                   <div className="kt-fi-wrap"><img key={ai} src={cur.image} alt={cur.name} className="kt-fi" loading="lazy"/><div className="kt-fi-ovl"/><div className="kt-fi-badge">🎉 {cur.occasion}</div></div>
//                   <div style={{marginBottom:14}}><Stars rating={cur.rating} size={15}/></div>
//                   <p className="kt-review">"{cur.text}"</p>
//                   <div className="kt-div"/>
//                   <div className="kt-author">
//                     <img src={cur.avatar} alt={cur.name} className="kt-avatar" loading="lazy"/>
//                     <div><div className="kt-aname">{cur.name}</div><div className="kt-aloc">{cur.location}</div></div>
//                     <div className="kt-v">✓</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-5" style={{display:"flex",flexDirection:"column",gap:16}}>
//               {[prev,next].map((rv,i)=>(
//                 <div key={i} className="kt-prev" onClick={()=>goTo(i===0?(ai-1+REVIEWS.length)%REVIEWS.length:(ai+1)%REVIEWS.length)}>
//                   <img src={rv.image} alt={rv.name} className="kt-pi" loading="lazy"/>
//                   <div className="kt-pb"><Stars rating={rv.rating} size={11}/><p className="kt-pt">"{rv.text}"</p><div className="kt-pn">{rv.name}</div><div className="kt-pl">{rv.location}</div><span className="kt-pr">Read Full →</span></div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="kt-nav">
//             <button className="kt-arr" onClick={()=>goTo(ai-1)}>‹</button>
//             {REVIEWS.map((_,i)=><button key={i} className={`kt-dot${i===ai?" on":""}`} onClick={()=>goTo(i)}/>)}
//             <button className="kt-arr" onClick={()=>goTo(ai+1)}>›</button>
//           </div>
//         </div>
//         <div className="kt-plat">
//           {[{name:"Google",score:"4.9",count:"200+ reviews"},{name:"Facebook",score:"4.8",count:"150+ reviews"},{name:"JustDial",score:"4.7",count:"80+ reviews"},{name:"Instagram",score:"5.0",count:"50k+ followers"}].map((p,i)=>(
//             <React.Fragment key={i}>
//               {i>0&&<div className="kt-psep"/>}
//               <div className="kt-plat-item"><div className="kt-plat-name">{p.name}</div><div className="kt-plat-row"><span className="kt-plat-sc">{p.score}</span><div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div></div><div className="kt-plat-cnt">{p.count}</div></div>
//             </React.Fragment>
//           ))}
//         </div>
//         <div className="kt-cta">
//           <h3 className="kt-cta-h">Ready to Create <span>Pure Magic?</span></h3>
//           <p className="kt-cta-sub">Join 2000+ happy families who celebrated their child's most special moments with us.</p>
//           <div className="kt-cta-row">
//             <button onClick={()=>scrollTo("enquiry")} className="kt-btn-bk">🎈 Book My Party</button>
//             <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kt-btn-wa"><i className="bi bi-whatsapp"/> Chat With Us</a>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// });

// const ScrollRevealWatcher=memo(()=>{
//   useEffect(()=>{
//     const o=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting)x.target.classList.add("in");}),{threshold:.08});
//     const run=()=>document.querySelectorAll(".rv:not(.in)").forEach(el=>o.observe(el));
//     run();const t=setTimeout(run,600);
//     return()=>{o.disconnect();clearTimeout(t);};
//   },[]);
//   return null;
// });

// function GalleryEntranceObserver(){
//   useEffect(()=>{
//     const items=document.querySelectorAll(".gal-bento-item");
//     const o=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){const i=Array.from(items).indexOf(e.target);e.target.style.transitionDelay=`${i*.08}s`;e.target.classList.add("in");o.unobserve(e.target);}});},{threshold:.1});
//     items.forEach(el=>o.observe(el));
//     return()=>o.disconnect();
//   },[]);
//   return null;
// }

// /* ─── Main Page ──────────────────────────────────────────────────── */
// export default function KidsPage(){
//   const [loading,setLoading]=useState(true);
//   const [faq,setFaq]=useState(null);
//   const [showPopup,setShowPopup]=useState(false);
//   const [popupImg,setPopupImg]=useState("");
//   const [galIdx,setGalIdx]=useState(0);
//   const [form,setForm]=useState({name:"",email:"",mobileNumber:"",childAge:"",theme:"",date:"",guests:""});
//   const galRef=useRef(null);
//   const navigate=useNavigate();

//   useEffect(()=>{setTimeout(()=>setLoading(false),400);},[]);
//   const onChange=useCallback(e=>setForm(f=>({...f,[e.target.name]:e.target.value})),[]);
//   const onSubmit=useCallback(e=>{e.preventDefault();toast.success("🎉 Amazing! We'll call you within 2 hours to plan the perfect party!");setForm({name:"",email:"",mobileNumber:"",childAge:"",theme:"",date:"",guests:""});},[]);
//   const galItem=useCallback(src=><img src={src} alt="" style={{width:"100%",display:"block",borderRadius:14}}/>,[]);
//   const galThumb=useCallback(src=><img src={src} alt="" style={{width:58,height:58,objectFit:"cover",display:"block",borderRadius:8}}/>,[]);

//   if(loading)return(
//     <div style={{background:C.dark,height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:18}}>
//       <div style={{width:68,height:68,border:`4px solid ${C.primaryPale}`,borderTop:`4px solid ${C.gold}`,borderRadius:"50%",animation:"_spin 1s linear infinite"}}/>
//       <p style={{color:C.gold,fontWeight:600,letterSpacing:2,fontSize:14}}>Loading Magic…</p>
//       <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
//     </div>
//   );

//   return(
//     <>
//       <style>{GLOBAL_CSS}</style>
//       <Helmet>
//         <title>Carnival Castle Kids | Magical Birthday Parties in Hyderabad</title>
//         <meta name="description" content="Themed birthday parties for kids — Princess, Superhero, Dino & 20+ themes. Premium packages from ₹4,999."/>
//       </Helmet>
//       <ScrollRevealWatcher/>
//       <div className="kp-root">
//         <Header/>

//         {/* Ticker */}
//         <div className="kp-ticker"><div className="kp-ticker-track">
//           {[...Array(4)].map((_,k)=>["🎈 20+ Magical Themes","⭐ 2000+ Happy Parties","🛡️ 100% Child Safe","📸 Photography Included","⚡ Book in 2 Minutes","🎂 Custom Cakes Available"].map((item,i)=><span key={`${k}-${i}`} className="kp-ticker-item">{item}</span>))}
//         </div></div>

//         {/* Hero */}
//         <section className="kp-hero">
//           <div className="kp-hero-orb" style={{width:500,height:500,background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`,top:-100,right:-80}}/>
//           <div className="kp-hero-orb" style={{width:300,height:300,background:"radial-gradient(circle,rgba(236,72,153,.16) 0%,transparent 70%)",bottom:80,left:-60}}/>
//           <div className="container kp-hero-cnt">
//             <div className="row align-items-center g-5">
//               <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both"}}>
//                 <div className="kp-hero-badge">🎉 Hyderabad's #1 Kids Party Venue</div>
//                 <h1 className="kp-hero-title pf">Create <span>Magical</span><br/>Birthday Memories</h1>
//                 <p className="kp-hero-sub">From princess castles to dino adventures — 20+ incredible themes, professional setups, and memories your child will cherish forever.</p>
//                 <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
//                   <button onClick={()=>scrollTo("enquiry")} className="cc-btn-gold">🎈 Explore Packages</button>
//                   <button onClick={()=>scrollTo("enquiry")} className="cc-btn-outline" style={{borderColor:"rgba(255,255,255,.4)",color:"#fff"}}>📞 Get a Callback</button>
//                 </div>
//                 <div className="kp-trust-row">
//                   {[["2000+","Parties"],["4.9★","Rating"],["20+","Themes"]].map(([n,l])=>(
//                     <div key={l} className="kp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
//                   ))}
//                 </div>
//               </div>
//               <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both"}}>
//                 <div style={{position:"relative"}}>
//                   <HeroVideo/>
//                   <div className="kp-hero-float d-none d-md-block" style={{bottom:80,left:-28,animationDelay:"0s"}}>
//                     <div style={{fontSize:10,color:"#888",marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>Just Booked!</div>
//                     <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>👑</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>Princess Royal</div><div style={{fontSize:11,color:C.primary}}>Priya's 5th Birthday</div></div></div>
//                   </div>
//                   <div className="kp-hero-float d-none d-md-block" style={{top:32,right:-28,animationDelay:"1.5s"}}>
//                     <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>⭐</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>4.9 / 5.0</div><div style={{fontSize:11,color:"#888"}}>2000+ Happy Parties</div></div></div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         <ReelsSection/>
//         <VideoTestimonials/>
//         <ThemeCarousel navigate={navigate}/>

//         {/* Services */}
//         <section className="kp-sec" style={{background:"#fff",overflow:"hidden"}}>
//           <div className="container">
//             <div className="text-center rv" style={{marginBottom:44}}>
//               <span className="cc-tag">✦ Party Services ✦</span>
//               <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Party</h2>
//               <p className="cc-sub">Decor, cakes, food, photography — curated to make your child's day perfect.</p>
//             </div>
//             <div className="kp-divider"><div className="kp-dl"/><div className="kp-dg"/><div className="kp-dl"/></div>
//             <div className="svc-grid rv">
//               {SERVICE_CARDS.map((s,i)=>(
//                 <div key={i} className="svc-card">
//                   <div className="svc-img-wrap"><img src={s.img} alt={s.label} className="svc-img" loading="lazy"/><div className="svc-glow"/><div className="svc-num">0{i+1}</div><div className="svc-pill">{["✨ Trending","🎂 Custom","🍽️ Fresh","📸 Pro"][i]}</div></div>
//                   <div className="svc-body"><div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div><div className="svc-title pf">{s.label}</div><span className="svc-line"/><p className="svc-desc">{s.desc}</p></div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         {/* Activities */}
//         <section className="kp-sec" style={{background:C.cream}}>
//           <div className="container">
//             <div className="text-center rv" style={{marginBottom:44}}>
//               <span className="cc-tag">✦ Fun Activities ✦</span>
//               <h2 className="cc-h">Keep the Kids <span>Entertained All Day</span></h2>
//             </div>
//             <div className="row g-4">
//               {KID_ACTIVITIES.map((act,i)=>(
//                 <div key={i} className={`col-md-3 col-6 rv d${i+1}`}>
//                   <div className="act-card">
//                     <div style={{overflow:"hidden",height:185}}><img src={act.img} alt={act.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} loading="lazy"/></div>
//                     <div style={{padding:"14px"}}><h3 style={{fontSize:15,fontWeight:700,marginBottom:5,color:C.dark}}>{act.name}</h3><div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888"}}><span>⏱️ {act.dur}</span><span>👶 {act.age}</span></div></div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>

//         <WrittenReviews/>

//         {/* Gallery */}
//         <section className="kp-sec" style={{background:C.cream,overflow:"hidden"}}>
//           <div className="container">
//             <div className="text-center rv" style={{marginBottom:50}}>
//               <span className="cc-tag">✦ Happy Moments ✦</span>
//               <h2 className="cc-h">Real Memories from <span>Real Parties</span></h2>
//               <p className="cc-sub">Captured moments from our little guests' most magical days.</p>
//             </div>
//             <div className="gal-bento rv">
//               {KID_GALLERY.map((img,i)=>(
//                 <div key={i} className={`gal-bento-item gbi-${i+1}`} onClick={()=>{setGalIdx(i);galRef.current?.show();}}>
//                   <img src={img} alt={`Party ${i+1}`} loading="lazy"/><div className="gal-bento-ovl">🔍</div>
//                 </div>
//               ))}
//             </div>
//             <Galleria ref={galRef} value={KID_GALLERY} numVisible={5} activeIndex={galIdx} onItemChange={e=>setGalIdx(e.index)} circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb}/>
//             <div style={{display:"flex",gap:14,justifyContent:"center",marginTop:34,flexWrap:"wrap"}}>
//               <a href="/locations" className="cc-btn">Book Your Party →</a>
//               <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/> Chat With Us</a>
//             </div>
//           </div>
//           <GalleryEntranceObserver/>
//         </section>

//         <CouponSection/>

//         {/* Enquiry */}
//         <section id="enquiry" className="kp-sec" style={{background:C.beige}}>
//           <div className="container">
//             <div className="text-center rv" style={{marginBottom:44}}>
//               <span className="cc-tag">✦ Book Your Party ✦</span>
//               <h2 className="cc-h">Plan the Party <span>of Their Dreams</span></h2>
//               <p className="cc-sub">Fill in the details and our party specialist will call you within 2 hours.</p>
//             </div>
//             <div className="enq-wrap rv" style={{maxWidth:980,margin:"0 auto"}}>
//               <div className="row g-0">
//                 <div className="col-lg-4">
//                   <div className="enq-left h-100">
//                     <div>
//                       <h3 className="pf" style={{color:"#fff",fontSize:23,fontWeight:700,marginBottom:8}}>Let's Create <span style={{color:C.goldLight}}>Magic</span> Together</h3>
//                       <p style={{color:"rgba(255,255,255,.58)",fontSize:13,lineHeight:1.7,marginBottom:24}}>Share your event details and we'll craft an unforgettable kids' party experience.</p>
//                     </div>
//                     <div>
//                       {[{icon:"⚡",label:"2-Hour Callback",val:"We call within 2 hours"},{icon:"🎨",label:"Free Theme Consult",val:"Expert advice included"},{icon:"💰",label:"Price Match",val:"Best price guaranteed"},{icon:"💬",label:"WhatsApp Us",val:"+91 8374777834",href:"https://wa.me/918374777834"}].map((it,i)=>(
//                         <div key={i} className="enq-contact-info"><div className="enq-ci-icon">{it.icon}</div><div><div className="enq-ci-label">{it.label}</div>{it.href?<a href={it.href} style={{color:"#fff",fontWeight:500,fontSize:13,textDecoration:"none"}}>{it.val}</a>:<span style={{color:"#fff",fontWeight:500,fontSize:13}}>{it.val}</span>}</div></div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-8">
//                   <div className="enq-right">
//                     <h3 className="pf" style={{fontSize:21,fontWeight:700,color:C.dark,marginBottom:4}}>Book Your <span style={{color:C.primary}}>Kid's Party!</span></h3>
//                     <p style={{color:"#aaa",fontSize:13,marginBottom:22}}>Free callback within 2 hours • No obligation</p>
//                     <form onSubmit={onSubmit}>
//                       <div className="row g-3">
//                         <div className="col-md-6"><label className="enq-label">Your Name *</label><input type="text" name="name" className="enq-input" placeholder="e.g. Priya Sharma" value={form.name} onChange={onChange} required/></div>
//                         <div className="col-md-6"><label className="enq-label">Phone Number *</label><input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={onChange} required/></div>
//                         <div className="col-md-6"><label className="enq-label">Email Address</label><input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={onChange}/></div>
//                         <div className="col-md-6"><label className="enq-label">Child's Age *</label><input type="text" name="childAge" className="enq-input" placeholder="e.g. 6 years" value={form.childAge} onChange={onChange} required/></div>
//                         <div className="col-md-6"><label className="enq-label">Preferred Theme *</label><select name="theme" className="enq-input" value={form.theme} onChange={onChange} required><option value="">Choose a theme…</option>{KID_THEMES.map((t,i)=><option key={i} value={t.name}>{t.emoji} {t.name}</option>)}</select></div>
//                         <div className="col-md-6"><label className="enq-label">Party Date *</label><input type="date" name="date" className="enq-input" value={form.date} onChange={onChange} required/></div>
//                         <div className="col-12"><label className="enq-label">Number of Kids *</label><select name="guests" className="enq-input" value={form.guests} onChange={onChange} required><option value="">How many kids are coming?</option><option>5–10 kids</option><option>11–20 kids</option><option>21–30 kids</option><option>30+ kids</option></select></div>
//                         <div className="col-12" style={{marginTop:4}}>
//                           <button type="submit" className="cc-btn-gold" style={{width:"100%",justifyContent:"center",padding:"15px",fontSize:15}}>🎉 Request a Free Callback 🎉</button>
//                           <p style={{textAlign:"center",fontSize:11,color:"#aaa",marginTop:10}}>No spam. We'll call to discuss your party and that's it.</p>
//                         </div>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* FAQ */}
//         <section className="kp-sec" style={{background:"#fff"}}>
//           <div className="container">
//             <div className="text-center rv" style={{marginBottom:44}}>
//               <span className="cc-tag">✦ FAQ ✦</span>
//               <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
//             </div>
//             <div className="row justify-content-center"><div className="col-lg-8">
//               {KID_FAQ.map((q,i)=>(
//                 <div key={i} className={`kp-faq-item${faq===i?" open":""}`} onClick={()=>setFaq(faq===i?null:i)}>
//                   <div className="kp-faq-q"><span>{q.q}</span><div className="kp-faq-arrow">▾</div></div>
//                   {faq===i&&<div className="kp-faq-a">{q.a}</div>}
//                 </div>
//               ))}
//             </div></div>
//           </div>
//         </section>

//         {/* CTA */}
//         <section className="kp-cta-sec kp-sec-sm">
//           <div className="container text-center" style={{position:"relative",zIndex:1}}>
//             <span style={{fontSize:50}}>🎂</span>
//             <h2 className="pf" style={{fontSize:"clamp(24px,4vw,42px)",color:"#fff",fontWeight:900,marginTop:12,marginBottom:12}}>
//               Ready to Create <span style={{background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Pure Magic?</span>
//             </h2>
//             <p style={{color:"rgba(255,255,255,.63)",fontSize:15,marginBottom:26,maxWidth:460,margin:"0 auto 26px"}}>Book your child's dream party today. We handle everything so you just celebrate.</p>
//             <button className="cc-btn-gold" style={{fontSize:15,padding:"15px 40px"}} onClick={()=>scrollTo("enquiry")}>🎈 Book Your Party Now</button>
//             <p style={{color:"rgba(255,255,255,.32)",fontSize:12,marginTop:12}}>Join 2000+ happy families who celebrated with us</p>
//           </div>
//         </section>

//         <Footer/>
//         <ToastContainer position="top-center" autoClose={4000} theme="dark"/>
//         <PopupModal show={showPopup} handleClose={()=>setShowPopup(false)} image={popupImg}/>
//       </div>
//     </>
//   );
// }

import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import { Galleria } from "primereact/galleria";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import CouponSection from "../components/Coupons";
import PopupModal from "../components/PopUpModal";
import TestimonialsSection from "../components/TestimonialsSection";

/* ─── Brand palette ─────────────────────────────────────────────── */
const C = {
  primary:"#5E0E73", primaryLight:"#6E1A85", primaryDeep:"#3A0847",
  primaryPale:"#F3E5F7", cream:"#E8E1D6", beige:"#D6CFC4",
  gold:"#C9A84C", goldLight:"#E8D5A0", goldBright:"#F5D87A",
  dark:"#1A0030", dark2:"#120020",
};

/* ─── ALL CSS ────────────────────────────────────────────────────── */
const GLOBAL_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,900;1,600&family=DM+Sans:wght@300;400;500;600;700&display=swap');
:root{--p:#5E0E73;--pl:#6E1A85;--pd:#3A0847;--pp:#F3E5F7;--cream:#E8E1D6;--beige:#D6CFC4;--gold:#C9A84C;--gl:#E8D5A0;--gb:#F5D87A;--dark:#1A0030;--dark2:#120020;}
*,*::before,*::after{box-sizing:border-box;}
.kp-root,.kp-root *{font-family:'DM Sans',sans-serif;}
.pf{font-family:'Playfair Display',serif!important;}

@keyframes _fadeUp{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
@keyframes _ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes _spin{to{transform:rotate(360deg)}}
@keyframes _float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
@keyframes _pulse{0%,100%{opacity:.7}50%{opacity:1}}
@keyframes _shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
@keyframes kr-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}
@keyframes kr-fadeUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-pulse{0%,100%{transform:scale(1);opacity:.45}50%{transform:scale(1.2);opacity:.85}}
@keyframes kvt-quoteIn{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:translateX(0)}}
@keyframes kvt-nameIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-ctrlIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
@keyframes kvt-eqBar{0%,100%{height:5px}50%{height:18px}}
@keyframes kvt-shine{0%,100%{opacity:0;transform:translateX(-100%)}40%,60%{opacity:1}100%{transform:translateX(200%)}}

.rv{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s cubic-bezier(.16,1,.3,1);}
.rv.in{opacity:1;transform:translateY(0);}
.rv.d1{transition-delay:.08s}.rv.d2{transition-delay:.16s}.rv.d3{transition-delay:.24s}.rv.d4{transition-delay:.32s}

.kp-sec{padding:72px 0;}.kp-sec-sm{padding:44px 0;}

.cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
.cc-tag-light{color:var(--gl)!important;}
.cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
.cc-h-white{color:#fff!important;}
.cc-h span{color:var(--p);}
.cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
.cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
.cc-sub-light{color:rgba(255,255,255,.55)!important;}

.cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;position:relative;}
.cc-btn:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
.cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,background .25s,color .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
.cc-btn-outline:hover{background:var(--p);color:#fff;transform:translateY(-2px);}
.cc-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B 0%,var(--gold) 50%,#9A6E10 100%);color:var(--dark);border:none;border-radius:50px;padding:13px 28px;font-weight:800;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;transition:transform .25s,opacity .25s;box-shadow:0 4px 18px rgba(201,168,76,.35);}
.cc-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:_shine 3.5s ease infinite;pointer-events:none;}
.cc-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:var(--dark);}
.wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:transform .25s,opacity .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;}
.wa-btn:hover{transform:translateY(-2px);opacity:.88;color:#fff;}
.cc-nav-btn{width:44px;height:44px;border-radius:50%;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;}
.cc-nav-btn:hover{background:var(--gold);color:var(--dark);border-color:var(--gold);transform:scale(1.08);}

.kp-ticker{background:var(--pd);padding:10px 0;overflow:hidden;border-bottom:1px solid rgba(201,168,76,.15);}
.kp-ticker-track{display:flex;width:max-content;animation:_ticker 26s linear infinite;will-change:transform;}
.kp-ticker-item{color:rgba(255,255,255,.6);font-size:11px;font-weight:600;letter-spacing:1px;text-transform:uppercase;padding:0 40px;border-right:1px solid rgba(255,255,255,.1);white-space:nowrap;}

.kp-hero{position:relative;min-height:88vh;background:linear-gradient(135deg,rgba(26,0,48,.75) 0%,rgba(94,14,115,.6) 50%,rgba(18,0,32,.82) 100%),url('https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.22_PM_1_pldwyn.jpg') center/cover no-repeat;display:flex;align-items:center;overflow-x:clip;}
.kp-hero-orb{position:absolute;border-radius:50%;filter:blur(60px);pointer-events:none;}
.kp-hero-cnt{position:relative;z-index:2;padding:100px 0 80px;}
.kp-hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.38);border-radius:60px;padding:8px 20px;color:var(--gold);font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;margin-bottom:22px;width:fit-content;}
.kp-hero-title{font-family:'Playfair Display',serif;font-size:clamp(36px,6vw,70px);font-weight:900;color:#fff;line-height:1.07;margin-bottom:22px;text-shadow:0 2px 12px rgba(0,0,0,.3);}
.kp-hero-title span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
.kp-hero-sub{font-size:clamp(14px,2vw,17px);color:rgba(255,255,255,.7);line-height:1.7;max-width:520px;margin-bottom:32px;}
.kp-hero-vid-wrap{position:relative;border-radius:28px;border:2px solid rgba(201,168,76,.3);overflow:hidden;aspect-ratio:9/16;max-height:500px;background:#000;}
.kp-hero-vid-wrap video{width:100%;height:100%;object-fit:cover;display:block;}
.kp-hero-vid-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.55) 0%,transparent 55%);pointer-events:none;}
.kp-hero-vid-badge{position:absolute;bottom:14px;left:14px;right:14px;display:flex;align-items:center;gap:10px;background:rgba(0,0,0,.55);border-radius:10px;padding:9px 12px;border:1px solid rgba(201,168,76,.2);}
.kp-hero-vid-pulse{width:8px;height:8px;border-radius:50%;background:#EF4444;flex-shrink:0;animation:_pulse 1.8s ease-in-out infinite;}
.kp-hero-vid-label{font-size:11px;color:rgba(255,255,255,.8);font-weight:600;letter-spacing:.5px;}
.kp-hero-float{position:absolute;background:#fff;border-radius:14px;padding:10px 14px;box-shadow:0 8px 24px rgba(0,0,0,.18);animation:_float 5s ease-in-out infinite;white-space:nowrap;will-change:transform;}
.kp-trust-row{display:flex;gap:28px;flex-wrap:wrap;margin-top:34px;}
.kp-trust-item .num{font-family:'Playfair Display',serif;font-size:26px;font-weight:900;color:var(--gold);line-height:1;}
.kp-trust-item .lbl{font-size:10px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:1px;margin-top:2px;}

.theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
.theme-card:hover{transform:translateY(-6px);}
.theme-img{width:100%;height:320px;object-fit:cover;transition:transform .45s;display:block;}
.theme-card:hover .theme-img{transform:scale(1.05);}
.theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.9) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
.theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
.theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
.theme-tag{background:rgba(255,255,255,.12);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}
.kp-emoji-badge{position:absolute;top:14px;right:14px;z-index:2;background:rgba(0,0,0,.44);border-radius:50%;width:46px;height:46px;display:flex;align-items:center;justify-content:center;font-size:21px;border:1px solid rgba(255,255,255,.12);}

.svc-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-bottom:38px;}
.svc-card{border-radius:22px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.08);transition:transform .35s;cursor:pointer;position:relative;}
.svc-card:hover{transform:translateY(-10px);}
.svc-card::before{content:'';position:absolute;inset:0;border-radius:22px;box-shadow:0 24px 56px rgba(94,14,115,.18);opacity:0;transition:opacity .35s;z-index:-1;}
.svc-card:hover::before{opacity:1;}
.svc-card::after{content:'';position:absolute;bottom:0;left:50%;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;transition:width .35s,left .35s;}
.svc-card:hover::after{width:100%;left:0;}
.svc-img-wrap{position:relative;height:200px;overflow:hidden;}
.svc-img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .45s;}
.svc-card:hover .svc-img{transform:scale(1.07);}
.svc-glow{position:absolute;inset:0;background:linear-gradient(to top,rgba(94,14,115,.45) 0%,transparent 60%);opacity:0;transition:opacity .3s;}
.svc-card:hover .svc-glow{opacity:1;}
.svc-num{position:absolute;top:12px;right:12px;width:30px;height:30px;border-radius:50%;background:rgba(26,0,48,.6);border:1.5px solid rgba(201,168,76,.5);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:var(--gl);}
.svc-pill{position:absolute;bottom:12px;left:12px;background:linear-gradient(135deg,var(--gold),var(--gl));color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;transform:translateY(8px);opacity:0;transition:transform .3s,opacity .3s;}
.svc-card:hover .svc-pill{transform:translateY(0);opacity:1;}
.svc-body{padding:22px 14px 18px;position:relative;}
.svc-float-icon{position:absolute;top:-15px;left:14px;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;font-size:14px;transition:transform .3s;}
.svc-card:hover .svc-float-icon{transform:rotate(-6deg) scale(1.1);}
.svc-title{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);transition:color .2s;}
.svc-card:hover .svc-title{color:var(--p);}
.svc-line{display:block;width:0;height:2px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;margin:7px 0 9px;transition:width .35s;}
.svc-card:hover .svc-line{width:42px;}
.svc-desc{font-size:12px;color:#888;line-height:1.6;}

.act-card{border-radius:18px;overflow:hidden;background:#fff;border:1px solid rgba(94,14,115,.07);transition:transform .3s;cursor:pointer;position:relative;}
.act-card::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 16px 40px rgba(94,14,115,.15);opacity:0;transition:opacity .3s;z-index:-1;}
.act-card:hover{transform:translateY(-6px) scale(1.01);}
.act-card:hover::before{opacity:1;}

.gal-bento{display:grid;grid-template-columns:repeat(12,1fr);gap:14px;margin-bottom:8px;}
.gbi-1{grid-column:span 5;grid-row:span 2;min-height:370px;}.gbi-2{grid-column:span 4;min-height:178px;}.gbi-3{grid-column:span 3;min-height:178px;}.gbi-4{grid-column:span 4;min-height:178px;}.gbi-5{grid-column:span 3;min-height:178px;}.gbi-6{grid-column:span 7;min-height:215px;}
.gal-bento-item{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;background:var(--dark);opacity:0;transform:translateY(24px) scale(.98);transition:opacity .55s ease,transform .55s cubic-bezier(.25,1,.5,1);}
.gal-bento-item.in{opacity:1;transform:translateY(0) scale(1);}
.gal-bento-item::before{content:'';position:absolute;inset:0;border-radius:18px;box-shadow:0 20px 56px rgba(94,14,115,.25);opacity:0;transition:opacity .3s;z-index:1;pointer-events:none;}
.gal-bento-item:hover::before{opacity:1;}
.gal-bento-item img{width:100%;height:100%;object-fit:cover;display:block;position:absolute;inset:0;transition:transform .5s;}
.gal-bento-item:hover img{transform:scale(1.05);}
.gal-bento-ovl{position:absolute;inset:0;background:rgba(94,14,115,.32);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;font-size:28px;color:#fff;z-index:2;}
.gal-bento-item:hover .gal-bento-ovl{opacity:1;}

.kp-faq-item{background:#fff;border-radius:18px;border:1px solid rgba(94,14,115,.09);overflow:hidden;cursor:pointer;transition:border-color .25s;margin-bottom:12px;}
.kp-faq-item:hover{border-color:rgba(201,168,76,.4);}
.kp-faq-q{padding:18px 22px;display:flex;justify-content:space-between;align-items:center;font-size:15px;font-weight:700;color:var(--dark);gap:14px;}
.kp-faq-a{padding:0 22px 16px;font-size:14px;color:#666;line-height:1.7;}
.kp-faq-arrow{width:28px;height:28px;border-radius:50%;background:rgba(94,14,115,.1);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .25s,background .25s;font-size:15px;color:var(--p);}
.kp-faq-item.open .kp-faq-arrow{transform:rotate(180deg);background:var(--p);color:#fff;}

.enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;}
.enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:44px 32px;display:flex;flex-direction:column;justify-content:space-between;}
.enq-right{background:#fff;padding:40px 36px;}
.enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
.enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:13px 16px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s;color:var(--dark);}
.enq-input:focus{border-color:var(--p);}
.enq-input option{background:var(--dark);color:#fff;}
.enq-contact-info{display:flex;align-items:center;gap:12px;padding:13px 14px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:10px;}
.enq-ci-icon{width:38px;height:38px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
.enq-ci-label{font-size:10px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
.enq-ci-val{font-size:13px;color:#fff;font-weight:500;}

.kp-cta-sec{position:relative;overflow:hidden;background:linear-gradient(135deg,var(--pd) 0%,var(--p) 50%,var(--pd) 100%);}
.kp-cta-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 60% 80% at 50% 50%,rgba(201,168,76,.07) 0%,transparent 70%);pointer-events:none;}
.kp-divider{display:flex;align-items:center;gap:16px;margin:0 0 44px;}
.kp-dl{flex:1;height:1px;background:linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent);}
.kp-dg{width:8px;height:8px;background:var(--gold);transform:rotate(45deg);flex-shrink:0;}

/* ── Reels ── */
.kr-sec{padding:100px 0 110px;background:#120020;overflow:hidden;position:relative;font-family:'DM Sans',sans-serif;}
.kr-orb{position:absolute;border-radius:50%;filter:blur(70px);pointer-events:none;}
.kr-container{width:min(1320px,92%);margin:auto;position:relative;z-index:2;}
.kr-header{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:52px;flex-wrap:wrap;gap:20px;animation:kr-fadeUp .8s cubic-bezier(.16,1,.3,1) both;}
.kr-eyebrow{display:inline-flex;align-items:center;gap:8px;color:#E8D5A0;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;margin-bottom:14px;}
.kr-eyebrow-line{width:32px;height:1px;background:#C9A84C;opacity:.6;}
.kr-title{font-family:'Playfair Display',serif;font-size:clamp(32px,5vw,54px);font-weight:900;color:#fff;line-height:1.08;margin:0 0 10px;letter-spacing:-.5px;}
.kr-title em{font-style:italic;color:#C9A84C;}
.kr-sub{color:rgba(255,255,255,.5);font-size:15px;line-height:1.6;max-width:400px;}
.kr-nav{display:flex;gap:12px;align-items:center;}
.kr-nav-btn{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1.5px solid rgba(255,255,255,.14);color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .2s,background .2s;font-weight:700;flex-shrink:0;}
.kr-nav-btn:hover{background:#C9A84C;color:#120020;border-color:#C9A84C;transform:scale(1.08);}
.kr-wrap{overflow:hidden;width:100%;}
.kr-track{display:flex;gap:20px;transition:transform .65s cubic-bezier(.25,1,.5,1);will-change:transform;}
.kr-card{position:relative;width:260px;min-width:260px;height:470px;border-radius:26px;overflow:hidden;background:#000;border:1px solid rgba(255,255,255,.07);transition:transform .4s cubic-bezier(.25,1,.5,1);flex-shrink:0;cursor:pointer;}
.kr-card:hover{transform:translateY(-10px) scale(1.02);border-color:rgba(201,168,76,.5);}
.kr-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
.kr-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.95) 0%,rgba(13,0,24,.4) 45%,rgba(13,0,24,.08) 100%);pointer-events:none;}
.kr-views{position:absolute;top:14px;left:14px;z-index:5;padding:5px 11px;border-radius:999px;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.12);color:#fff;font-size:11px;font-weight:700;display:flex;align-items:center;gap:5px;}
.kr-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(.85);z-index:5;width:52px;height:52px;border-radius:50%;background:rgba(201,168,76,.9);display:flex;align-items:center;justify-content:center;font-size:18px;opacity:0;transition:opacity .3s,transform .3s;}
.kr-card:hover .kr-play{opacity:1;transform:translate(-50%,-50%) scale(1);}
.kr-info{position:absolute;left:0;right:0;bottom:0;z-index:5;padding:20px 18px 22px;}
.kr-tag-pill{display:inline-block;background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.45);color:#C9A84C;font-size:9px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:3px 10px;border-radius:50px;margin-bottom:8px;}
.kr-info h3{margin:0;color:#fff;font-family:'Playfair Display',serif;font-size:17px;font-weight:700;line-height:1.3;}
.kr-dots{display:flex;gap:8px;justify-content:center;margin-top:36px;}
.kr-dot{height:8px;border-radius:4px;background:rgba(255,255,255,.2);border:none;cursor:pointer;transition:all .4s;}
.kr-dot.active{width:28px!important;background:linear-gradient(90deg,#C9A84C,#E8D5A0);}
.kr-cta{margin-top:52px;display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap;}
.kr-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#120020;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
.kr-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kr-shine 3.5s ease infinite;pointer-events:none;}
.kr-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#120020;}
.kr-btn-ig{display:inline-flex;align-items:center;gap:9px;border:1.5px solid rgba(255,255,255,.2);background:rgba(255,255,255,.05);color:#fff;border-radius:50px;padding:12px 28px;font-weight:700;font-size:14px;cursor:pointer;font-family:'DM Sans',sans-serif;text-decoration:none;transition:transform .25s,opacity .25s;}
.kr-btn-ig:hover{border-color:rgba(201,168,76,.5);color:#C9A84C;transform:translateY(-2px);}

/* ── Video Testimonials ── */
.kvt-sec{background:#120020;font-family:'DM Sans',sans-serif;position:relative;overflow:hidden;}
.kvt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 65% 50% at 20% 10%,rgba(94,14,115,.28) 0%,transparent 65%),radial-gradient(ellipse 50% 40% at 80% 90%,rgba(201,168,76,.08) 0%,transparent 65%);pointer-events:none;z-index:0;}
.kvt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:180px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kvt-header{padding:72px clamp(20px,5vw,60px) 52px;display:flex;align-items:flex-end;justify-content:space-between;flex-wrap:wrap;gap:20px;position:relative;z-index:2;}
.kvt-header::after{content:'';position:absolute;bottom:0;left:clamp(20px,5vw,60px);right:clamp(20px,5vw,60px);height:1px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.25),transparent);}
.kvt-eyebrow{display:flex;align-items:center;gap:10px;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:14px;}
.kvt-eyebrow-line{width:26px;height:1px;background:#C9A84C;opacity:.55;}
.kvt-h{font-family:'Playfair Display',serif;font-size:clamp(28px,4vw,46px);font-weight:700;color:#fff;line-height:1.1;margin:0;}
.kvt-h em{font-style:italic;color:#C9A84C;}
.kvt-counter{font-family:'Playfair Display',serif;font-size:14px;color:rgba(255,255,255,.3);flex-shrink:0;align-self:flex-end;}
.kvt-counter span{color:#fff;font-size:18px;font-weight:700;}
.kvt-stage{display:grid;grid-template-columns:1fr 340px;min-height:580px;position:relative;z-index:1;}
.kvt-pane{position:relative;display:flex;align-items:center;justify-content:center;padding:40px 0 40px clamp(20px,5vw,60px);overflow:hidden;}
.kvt-glow{position:absolute;width:420px;height:420px;border-radius:50%;background:radial-gradient(circle,rgba(94,14,115,.22) 0%,transparent 70%);top:50%;left:45%;transform:translate(-50%,-50%);pointer-events:none;z-index:0;transition:background .5s;}
.kvt-glow.active{background:radial-gradient(circle,rgba(201,168,76,.1) 0%,rgba(94,14,115,.15) 50%,transparent 70%);}
.kvt-reel{position:relative;width:min(300px,82%);aspect-ratio:9/16;border-radius:32px;overflow:hidden;background:#000;border:2px solid rgba(255,255,255,.1);box-shadow:0 40px 100px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.08);cursor:pointer;transition:border-color .35s;z-index:1;flex-shrink:0;-webkit-tap-highlight-color:transparent;user-select:none;}
.kvt-reel:hover,.kvt-reel.playing{border-color:rgba(201,168,76,.5);}
.kvt-notch{position:absolute;top:14px;left:50%;transform:translateX(-50%);width:80px;height:5px;background:rgba(255,255,255,.1);border-radius:3px;z-index:8;pointer-events:none;}
.kvt-prog{position:absolute;top:0;left:0;right:0;height:3px;background:rgba(255,255,255,.08);z-index:6;}
.kvt-prog-fill{height:100%;background:linear-gradient(90deg,#5E0E73,#C9A84C);border-radius:0 2px 2px 0;transition:width .1s linear;}
.kvt-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;}
.kvt-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(13,0,24,.96) 0%,rgba(13,0,24,.22) 45%,transparent 100%),linear-gradient(to bottom,rgba(13,0,24,.5) 0%,transparent 25%);pointer-events:none;z-index:2;}
.kvt-pulse-ring{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:68px;height:68px;border-radius:50%;border:1.5px solid rgba(201,168,76,.5);z-index:4;pointer-events:none;animation:kvt-pulse 2.4s ease-in-out infinite;}
.kvt-reel.playing .kvt-pulse-ring{display:none;}
.kvt-play-area{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5;pointer-events:none;}
.kvt-play-btn{width:68px;height:68px;border-radius:50%;background:rgba(255,255,255,.12);border:2px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;transition:all .3s cubic-bezier(.25,1,.5,1);opacity:0;transform:scale(.8);pointer-events:all;cursor:pointer;}
.kvt-play-btn.show{opacity:1;transform:scale(1);animation:kvt-ctrlIn .22s ease-out;}
.kvt-play-btn:hover{background:#C9A84C;border-color:#C9A84C;transform:scale(1.08);}
.kvt-play-btn:hover svg{fill:#1A0030;}
.kvt-play-btn svg{fill:#fff;transition:fill .2s;}
@media(hover:none) and (pointer:coarse){
  .kvt-play-btn{opacity:1!important;transform:scale(1)!important;background:rgba(201,168,76,.85);}
  .kvt-play-btn svg{fill:#1A0030;}
  .kvt-hint{display:none!important;}
}
.kvt-top-ctrl{position:absolute;top:24px;right:14px;z-index:7;display:flex;flex-direction:column;align-items:center;gap:8px;opacity:0;pointer-events:none;transition:opacity .22s;}
.kvt-top-ctrl.show{opacity:1;pointer-events:all;}
.kvt-ctrl-btn{width:34px;height:34px;border-radius:50%;background:rgba(0,0,0,.55);border:1px solid rgba(255,255,255,.15);color:#fff;font-size:13px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
.kvt-ctrl-btn:hover{background:rgba(201,168,76,.35);border-color:#C9A84C;}
.kvt-hint{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:.5px;text-transform:uppercase;background:rgba(0,0,0,.45);padding:3px 8px;border-radius:6px;border:1px solid rgba(255,255,255,.08);white-space:nowrap;}
.kvt-info{position:absolute;bottom:0;left:0;right:0;padding:18px 16px 22px;z-index:4;}
.kvt-stars{display:flex;gap:3px;margin-bottom:9px;}
.kvt-quote{font-family:'Playfair Display',serif;font-size:13px;font-style:italic;font-weight:600;color:#fff;line-height:1.55;margin:0 0 14px;animation:kvt-quoteIn .4s cubic-bezier(.25,1,.5,1) both;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
.kvt-quote::before{content:'"';font-size:1.5em;line-height:0;vertical-align:-.35em;color:#C9A84C;margin-right:3px;opacity:.8;}
.kvt-identity{display:flex;align-items:center;gap:10px;animation:kvt-nameIn .4s cubic-bezier(.25,1,.5,1) .07s both;}
.kvt-avatar{width:38px;height:38px;border-radius:50%;border:2px solid rgba(201,168,76,.55);background:linear-gradient(135deg,#5E0E73,#6E1A85);display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:12px;font-weight:700;color:#E8D5A0;flex-shrink:0;}
.kvt-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;margin-bottom:3px;}
.kvt-meta{display:flex;align-items:center;gap:5px;flex-wrap:wrap;}
.kvt-pill{background:rgba(201,168,76,.2);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:8px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;padding:2px 8px;border-radius:50px;}
.kvt-loc{font-size:10px;color:rgba(255,255,255,.4);}
.kvt-transition{position:absolute;inset:0;background:#120020;z-index:10;opacity:0;pointer-events:none;transition:opacity .28s;}
.kvt-transition.show{opacity:1;pointer-events:all;}
.kvt-queue{background:rgba(255,255,255,.025);border-left:1px solid rgba(255,255,255,.06);display:flex;flex-direction:column;overflow:hidden;}
.kvt-queue-header{padding:24px 24px 18px;border-bottom:1px solid rgba(255,255,255,.06);flex-shrink:0;}
.kvt-queue-title{font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:rgba(255,255,255,.3);}
.kvt-queue-list{flex:1;overflow-y:auto;padding:12px 0;scrollbar-width:thin;scrollbar-color:rgba(201,168,76,.2) transparent;}
.kvt-queue-list::-webkit-scrollbar{width:4px;}.kvt-queue-list::-webkit-scrollbar-thumb{background:rgba(201,168,76,.2);border-radius:2px;}
.kvt-q-item{display:flex;align-items:center;gap:14px;padding:12px 20px;cursor:pointer;transition:background .2s;border-left:3px solid transparent;}
.kvt-q-item:hover{background:rgba(255,255,255,.04);}
.kvt-q-item.active{background:rgba(201,168,76,.07);border-left-color:#C9A84C;}
.kvt-q-thumb{width:50px;height:74px;border-radius:10px;overflow:hidden;flex-shrink:0;position:relative;border:1px solid rgba(255,255,255,.07);display:flex;align-items:center;justify-content:center;transition:border-color .2s;}
.kvt-q-item.active .kvt-q-thumb{border-color:rgba(201,168,76,.4);}
.kvt-q-bg{position:absolute;inset:0;background:linear-gradient(155deg,#3A0847 0%,#5E0E73 60%,rgba(201,168,76,.25) 100%);}
.kvt-q-init{position:relative;z-index:1;font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:rgba(255,255,255,.75);}
.kvt-q-item.active .kvt-q-init{color:#E8D5A0;}
.kvt-q-eq-wrap{position:absolute;inset:0;background:rgba(13,0,24,.65);display:flex;align-items:center;justify-content:center;border-radius:9px;z-index:2;}
.kvt-q-eq{display:flex;align-items:flex-end;gap:2.5px;height:18px;}
.kvt-q-bar{width:3px;background:#C9A84C;border-radius:2px;animation:kvt-eqBar 1s ease-in-out infinite;}
.kvt-q-bar:nth-child(2){animation-delay:.18s;}.kvt-q-bar:nth-child(3){animation-delay:.36s;}
.kvt-q-info{flex:1;min-width:0;}
.kvt-q-name{font-family:'Playfair Display',serif;font-size:13px;font-weight:700;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:3px;}
.kvt-q-item.active .kvt-q-name{color:#E8D5A0;}
.kvt-q-event{font-size:11px;color:rgba(255,255,255,.35);}
.kvt-q-num{font-size:11px;color:rgba(255,255,255,.2);flex-shrink:0;font-family:'Playfair Display',serif;}
.kvt-q-item.active .kvt-q-num{color:#C9A84C;font-weight:700;}
.kvt-queue-nav{padding:16px 20px;border-top:1px solid rgba(255,255,255,.06);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.kvt-nav-label{font-size:11px;color:rgba(255,255,255,.25);letter-spacing:1px;text-transform:uppercase;}
.kvt-nav-arrows{display:flex;gap:8px;}
.kvt-nav-btn{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.55);font-size:17px;font-weight:700;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:transform .2s,background .2s;}
.kvt-nav-btn:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
.kvt-strip{padding:28px clamp(20px,5vw,60px) 56px;display:flex;align-items:center;justify-content:space-between;gap:20px;flex-wrap:wrap;border-top:1px solid rgba(255,255,255,.05);position:relative;z-index:2;}
.kvt-ratings{display:flex;align-items:center;gap:28px;flex-wrap:wrap;}
.kvt-r-item{text-align:center;}
.kvt-r-num{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#C9A84C;line-height:1;}
.kvt-r-label{font-size:10px;color:rgba(255,255,255,.28);text-transform:uppercase;letter-spacing:1px;margin-top:4px;}
.kvt-r-sep{width:1px;height:36px;background:rgba(255,255,255,.06);}
.kvt-btn-gold{position:relative;overflow:hidden;background:linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);color:#1A0030;border:none;border-radius:50px;padding:13px 30px;font-weight:800;font-size:14px;cursor:pointer;display:inline-flex;align-items:center;gap:8px;font-family:'DM Sans',sans-serif;text-decoration:none;flex-shrink:0;transition:transform .25s,opacity .25s;}
.kvt-btn-gold::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(105deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:kvt-shine 3.5s ease infinite;pointer-events:none;}
.kvt-btn-gold:hover{transform:translateY(-2px);opacity:.92;color:#1A0030;}

/* ── Written Reviews ── */
.kt-sec{padding:100px 0 88px;background:#1A0030;position:relative;overflow:hidden;font-family:'DM Sans',sans-serif;}
.kt-sec::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 55% at 15% 5%,rgba(94,14,115,.32) 0%,transparent 65%),radial-gradient(ellipse 55% 45% at 85% 95%,rgba(201,168,76,.09) 0%,transparent 65%);pointer-events:none;}
.kt-sec::after{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:200px;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:#C9A84C;margin-bottom:10px;}
.kt-h{font-family:'Playfair Display',serif;font-size:clamp(30px,4.5vw,52px);font-weight:700;line-height:1.15;color:#fff;margin:0;}
.kt-h span{color:#C9A84C;}
.kt-sub{color:rgba(255,255,255,.5);font-size:14px;line-height:1.75;margin:12px auto 0;max-width:500px;}
.kt-stats{display:flex;align-items:center;justify-content:center;gap:40px;margin-top:40px;flex-wrap:wrap;}
.kt-stat{text-align:center;}
.kt-sn{font-family:'Playfair Display',serif;font-size:34px;font-weight:700;color:#C9A84C;line-height:1;}
.kt-sl{font-size:10px;color:rgba(255,255,255,.4);letter-spacing:1.5px;text-transform:uppercase;margin-top:5px;}
.kt-ssep{width:1px;height:44px;background:rgba(255,255,255,.08);}
.kt-feat{border-radius:28px;overflow:hidden;width:100%;height:100%;background:rgba(255,255,255,.04);border:1px solid rgba(201,168,76,.22);position:relative;}
.kt-feat::before{content:'';display:block;width:100%;height:2px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-feat-in{padding:30px 28px 26px;}
.kt-big-q{font-family:'Playfair Display',serif;font-size:130px;font-weight:900;line-height:.8;color:rgba(201,168,76,.055);position:absolute;top:20px;right:16px;user-select:none;pointer-events:none;}
.kt-fi-wrap{position:relative;width:100%;height:240px;overflow:hidden;border-radius:18px;margin-bottom:22px;}
.kt-fi{width:100%;height:100%;object-fit:cover;display:block;transition:transform .6s;}
.kt-feat:hover .kt-fi{transform:scale(1.04);}
.kt-fi-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.75) 0%,transparent 55%);}
.kt-fi-badge{position:absolute;bottom:14px;left:14px;background:rgba(201,168,76,.18);border:1px solid rgba(201,168,76,.4);color:#E8D5A0;font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;padding:4px 12px;border-radius:50px;}
.kt-review{font-size:15px;color:rgba(255,255,255,.82);line-height:1.8;font-style:italic;margin:0 0 22px;}
.kt-div{height:1px;margin-bottom:18px;background:linear-gradient(90deg,transparent,rgba(201,168,76,.28),transparent);}
.kt-author{display:flex;align-items:center;gap:14px;}
.kt-avatar{width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2.5px solid rgba(201,168,76,.45);}
.kt-aname{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:#fff;}
.kt-aloc{font-size:11px;color:rgba(255,255,255,.4);text-transform:uppercase;letter-spacing:.5px;margin-top:2px;}
.kt-v{margin-left:auto;flex-shrink:0;width:30px;height:30px;border-radius:50%;background:linear-gradient(135deg,#5E0E73,#C9A84C);display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;font-weight:700;}
.kt-prev{background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.08);border-radius:20px;overflow:hidden;cursor:pointer;transition:transform .3s;display:flex;flex-direction:column;flex:1;}
.kt-prev:hover{transform:translateY(-5px);background:rgba(255,255,255,.06);border-color:rgba(201,168,76,.28);}
.kt-pi{width:100%;height:155px;object-fit:cover;display:block;transition:transform .4s;filter:brightness(.8);}
.kt-prev:hover .kt-pi{transform:scale(1.04);filter:brightness(1);}
.kt-pb{padding:15px 17px;flex:1;display:flex;flex-direction:column;}
.kt-pt{font-size:12px;color:rgba(255,255,255,.55);line-height:1.65;font-style:italic;margin:8px 0 10px;flex:1;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;}
.kt-pn{font-size:13px;font-weight:700;color:rgba(255,255,255,.85);font-family:'Playfair Display',serif;}
.kt-pl{font-size:10px;color:rgba(255,255,255,.3);margin-top:2px;}
.kt-pr{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;color:#C9A84C;letter-spacing:1px;text-transform:uppercase;padding:4px 12px;border:1px solid rgba(201,168,76,.25);border-radius:50px;background:transparent;width:fit-content;transition:background .2s;}
.kt-prev:hover .kt-pr{background:rgba(201,168,76,.12);border-color:rgba(201,168,76,.5);}
.kt-nav{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:36px;}
.kt-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.15);border:none;cursor:pointer;transition:width .35s,background .35s;}
.kt-dot.on{width:34px;border-radius:4px;background:linear-gradient(90deg,#5E0E73,#C9A84C);}
.kt-arr{width:46px;height:46px;border-radius:50%;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:rgba(255,255,255,.6);font-size:20px;cursor:pointer;transition:transform .2s,background .2s;display:flex;align-items:center;justify-content:center;}
.kt-arr:hover{background:#C9A84C;color:#1A0030;border-color:#C9A84C;transform:scale(1.08);}
.kt-plat{display:flex;justify-content:center;align-items:center;gap:32px;flex-wrap:wrap;margin-top:60px;padding:26px 44px;background:rgba(255,255,255,.025);border:1px solid rgba(255,255,255,.055);border-radius:22px;}
.kt-plat-item{text-align:center;}
.kt-plat-name{font-size:10px;color:rgba(255,255,255,.3);letter-spacing:2px;text-transform:uppercase;margin-bottom:6px;}
.kt-plat-row{display:flex;align-items:center;gap:7px;}
.kt-plat-sc{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:#fff;}
.kt-plat-cnt{font-size:10px;color:rgba(255,255,255,.25);margin-top:3px;}
.kt-psep{width:1px;height:40px;background:rgba(255,255,255,.07);}
.kt-cta{text-align:center;margin-top:60px;padding:52px 40px;background:linear-gradient(135deg,rgba(94,14,115,.15),rgba(26,0,48,.5));border:1px solid rgba(201,168,76,.1);border-radius:28px;position:relative;overflow:hidden;}
.kt-cta::before{content:'';position:absolute;top:0;left:50%;transform:translateX(-50%);width:120px;height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);}
.kt-cta-h{font-family:'Playfair Display',serif;font-size:clamp(22px,3vw,32px);font-weight:700;color:#fff;margin:0 0 8px;}
.kt-cta-h span{color:#C9A84C;}
.kt-cta-sub{font-size:14px;color:rgba(255,255,255,.4);margin-bottom:28px;}
.kt-cta-row{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;}
.kt-btn-bk{background:linear-gradient(135deg,#5E0E73,#6E1A85);color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-block;transition:transform .25s,opacity .25s;}
.kt-btn-bk:hover{transform:translateY(-2px);opacity:.9;color:#fff;}
.kt-btn-wa{background:#25D366;color:#fff;border:none;border-radius:50px;padding:14px 32px;font-weight:700;font-size:14px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;transition:transform .25s,opacity .25s;}
.kt-btn-wa:hover{transform:translateY(-2px);opacity:.9;color:#fff;}

/* ── Responsive ── */
@media(max-width:1024px){
  .kvt-stage{grid-template-columns:1fr 280px;}
  .kvt-header,.kvt-strip{padding-left:32px;padding-right:32px;}
  .kvt-pane{padding-left:40px;}
  .svc-grid{grid-template-columns:repeat(2,1fr);gap:16px;}
}
/* ══ MOBILE HERO — video-first, full-screen ══════════════════════ */
@media(max-width:768px){

  /* Hero: stack video on top, text below — video is the star */
  .kp-hero{min-height:100svh;align-items:flex-start;overflow-x:clip;}
  .kp-hero-cnt{padding:0!important;width:100%;overflow:hidden;}

  /* Neutralize Bootstrap row negative margins that cause left-clip */
  .kp-hero .row{flex-direction:column-reverse!important;gap:0!important;margin-left:0!important;margin-right:0!important;}

  /* VIDEO COL — full width, tall */
  .kp-hero .col-lg-6:last-child{
    padding:0!important;
    width:100%!important;
    max-width:100%!important;
    flex:none!important;
  }
  .kp-hero-vid-wrap{
    width:100%!important;
    max-height:none!important;
    height:72svh!important;
    border-radius:0!important;
    border:none!important;
    border-bottom:2px solid rgba(201,168,76,.3)!important;
    aspect-ratio:unset!important;
  }

  /* TEXT COL — compact strip below video */
  .kp-hero .col-lg-6:first-child{
    width:100%!important;
    max-width:100%!important;
    flex:none!important;
    padding:20px 20px 24px!important;
    box-sizing:border-box!important;
  }
  .kp-hero-badge{font-size:10px;padding:6px 14px;margin-bottom:10px;}
  .kp-hero-title{font-size:clamp(24px,6.5vw,34px)!important;margin-bottom:10px;line-height:1.1;}
  .kp-hero-sub{display:none!important;}           /* hide subtitle — video shows it */
  .kp-trust-row{display:none!important;}           /* hide stats — cleaner on mobile */
  .kp-hero-float{display:none!important;}

  /* Buttons — side by side, compact */
  .kp-hero .col-lg-6:first-child>div[style]{flex-wrap:nowrap!important;gap:10px!important;}
  .kp-hero-cnt .cc-btn-gold{flex:1;justify-content:center;padding:12px 14px!important;font-size:13px!important;}
  .kp-hero-cnt .cc-btn-outline{flex:1;justify-content:center;padding:11px 14px!important;font-size:13px!important;}

  /* Section spacing */
  .kp-sec{padding:52px 0;}
  .kp-sec-sm{padding:28px 0;}

  /* Themes */
  .theme-card{width:200px;}.theme-img{height:240px;}

  /* Gallery */
  .gal-bento{grid-template-columns:repeat(6,1fr);gap:10px;}
  .gbi-1{grid-column:span 3;grid-row:span 2;min-height:250px;}
  .gbi-2,.gbi-3{grid-column:span 3;min-height:120px;}
  .gbi-4,.gbi-5,.gbi-6{grid-column:span 2;min-height:135px;}

  /* Enquiry form */
  .enq-wrap .row{flex-direction:column;}
  .enq-left{order:2;padding:26px 22px;}
  .enq-right{order:1;padding:26px 22px;}

  /* Reels section */
  .kr-sec{padding:70px 0 80px;}
  .kr-header{margin-bottom:36px;}
  .kr-title{font-size:clamp(28px,7vw,38px);}

  /* Video testimonials */
  .kvt-stage{grid-template-columns:1fr;grid-template-rows:auto auto;}
  .kvt-pane{padding:32px 20px;min-height:480px;}
  .kvt-reel{width:min(250px,74%);}
  .kvt-queue{border-left:none;border-top:1px solid rgba(255,255,255,.06);max-height:none;}
  .kvt-queue-header{padding:14px 20px 10px;}
  .kvt-queue-list{display:flex;flex-direction:row;overflow-x:auto;overflow-y:hidden;padding:10px 16px 14px;gap:10px;-webkit-overflow-scrolling:touch;}
  .kvt-queue-list::-webkit-scrollbar{display:none;}
  .kvt-queue-nav{padding:12px 20px;}
  .kvt-q-item{flex-direction:column;align-items:center;text-align:center;min-width:84px;border-left:none;border-bottom:3px solid transparent;padding:8px;border-radius:12px;}
  .kvt-q-item.active{border-bottom-color:#C9A84C;border-left-color:transparent;}
  .kvt-q-thumb{width:50px;height:76px;}
  .kvt-q-num{display:none;}
  .kvt-header{padding:40px 20px 32px;}
  .kvt-header::after{left:20px;right:20px;}
  .kvt-strip{padding:20px 20px 36px;flex-direction:column;align-items:flex-start;}
  .kvt-r-sep{display:none;}

  /* Written reviews */
  .kt-sec{padding:64px 0 56px;}
  .kt-fi-wrap{height:200px;}
  .kt-ssep{display:none;}
  .kt-plat{gap:20px;padding:20px 24px;}
  .kt-psep{display:none;}
}

/* ══ 640px — phones ══════════════════════════════════════════════ */
@media(max-width:640px){
  .kp-hero-vid-wrap{height:75svh!important;}
  .kp-hero .col-lg-6:first-child{padding:16px 16px 20px!important;}
  .kp-hero-title{font-size:clamp(22px,6.5vw,28px)!important;}

  .kp-sec{padding:44px 0;}
  .container{padding-left:16px;padding-right:16px;}
  .cc-h{font-size:clamp(22px,6.5vw,30px);}
  .cc-btn,.cc-btn-gold,.cc-btn-outline,.wa-btn{min-height:46px;font-size:13px;}
  .theme-card{width:170px;}.theme-img{height:210px;}
  .svc-grid{grid-template-columns:1fr 1fr;gap:10px;}
  .svc-img-wrap{height:130px;}
  .kr-card{height:420px;}.kr-info h3{font-size:15px;}.kr-nav-btn{width:40px;height:40px;font-size:17px;}
  .gal-bento{grid-template-columns:1fr 1fr;gap:8px;}
  .gbi-1{grid-column:span 2;min-height:175px;grid-row:span 1;}
  .gbi-2,.gbi-3,.gbi-4,.gbi-5{grid-column:span 1;min-height:125px;}
  .gbi-6{grid-column:span 2;min-height:145px;}
  .enq-left,.enq-right{padding:18px 14px;}
  .enq-input{padding:11px 13px;font-size:13px;}
  .kp-faq-q{font-size:13px;padding:12px 16px;}
  .kp-faq-a{font-size:12px;padding:0 16px 12px;}
  .kvt-h{font-size:clamp(24px,7vw,32px);}
  .kt-feat-in{padding:20px 18px;}
  .kt-fi-wrap{height:170px;}
  .kt-review{font-size:13px;}
  .kt-cta{padding:32px 18px;}
  .kt-plat{padding:18px 16px;gap:16px;}

  /* Reel cards on small phones */
  .kvt-reel{width:min(220px,80%);}
}

/* ══ 400px — small/older phones ═════════════════════════════════ */
@media(max-width:400px){
  .kp-hero-vid-wrap{height:78svh!important;}
  .kp-hero-title{font-size:clamp(20px,6.5vw,24px)!important;}
  .cc-h{font-size:clamp(20px,7vw,26px);}
  .svc-grid{grid-template-columns:1fr;}
  .theme-card{width:150px;}
}
@media(hover:none) and (pointer:coarse){
  .theme-card:hover,.svc-card:hover,.act-card:hover,.kr-card:hover,.kt-prev:hover,.gal-bento-item:hover{transform:none!important;}
  .svc-card:hover::before,.act-card:hover::before,.gal-bento-item:hover::before{opacity:0!important;}
  .svc-card:hover .svc-img,.theme-card:hover .theme-img,.gal-bento-item:hover img{transform:none!important;}
  .svc-card:hover .svc-glow,.gal-bento-item:hover .gal-bento-ovl{opacity:0!important;}
  .kp-hero-float{animation:none!important;display:none!important;}
  .kp-ticker-track{animation-duration:40s!important;}
}
`;

/* ─── Static data ────────────────────────────────────────────────── */
// const KID_THEMES=[
//   {name:"Dinosaur Adventure",bookings:"487",tags:["Dinos","Jungle"],img:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=600&q=80",emoji:"🦕"},
//   {name:"Princess Royal",bookings:"562",tags:["Princess","Castle"],img:"https://plus.unsplash.com/premium_photo-1664205766214-9e3f453ef4cc?q=80",emoji:"👑"},
//   {name:"Space Explorer",bookings:"398",tags:["Space","Galaxy"],img:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=600&q=80",emoji:"🚀"},
//   {name:"Underwater World",bookings:"312",tags:["Ocean","Fish"],img:"https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600&q=80",emoji:"🐠"},
//   {name:"Superhero Academy",bookings:"445",tags:["Hero","Action"],img:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=600&q=80",emoji:"⚡"},
//   {name:"Candyland",bookings:"534",tags:["Sweet","Candy"],img:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=600&q=80",emoji:"🍭"},
// ];
const KID_THEMES = [
  // { name:"Royal Maharaja",    bookings:"312 bookings", tags:["Ethnic","Grand","Gold"],      img:theme1 },
  { name:"Joy Theatre",   bookings:"189 bookings", tags:["Dark","Stars","Neon"],        img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.22_PM_1_pldwyn.jpg" },
  // { name:"Joy Theatre", bookings:"276 bookings", tags:["Cute","Soft","Kids"],         img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.19_PM_1_y3dlud.jpg" },
  { name:"Royal Theatre",  bookings:"234 bookings", tags:["Nature","Lush","Boho"],       img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770059/WhatsApp_Image_2026-04-13_at_2.11.24_PM_1_lwwaae.jpg" },
  { name:"Amora Theatre",    bookings:"158 bookings", tags:["Rustic","Flowers","Outdoor"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.27_PM_1_rswxuu.jpg" },
  { name:"Iris Theatre",  bookings:"198 bookings", tags:["1920s","Art Deco","Elegant"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.25_PM_4_diawmo.jpg" },
  {name:"Galaxy Theatre", bookings:"221 bookings", tags:["Beach","Bright","Relaxed"],    img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.25_PM_3_vrlsy1.jpg" },
  {name:"Bloom Theatre", bookings:"305 bookings", tags:["Fantasy","Whimsical","Grand"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.26_PM_3_mm0ugp.jpg" },
  {name:"Joy Theatre", bookings:"142 bookings", tags:["Boho","Eclectic","Colorful"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.26_PM_2_dztn3a.jpg" },
  {name:"Couple Cove Theatre", bookings:"167 bookings", tags:["Dark","Dramatic","Elegant"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.27_PM_xwu00r.jpg" },
  {name:"Lilac Theatre", bookings:"189 bookings", tags:["Colorful","Fun","Whimsical"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770058/WhatsApp_Image_2026-04-13_at_2.11.29_PM_ta4p58.jpg" },
  {name:"Radiant Theatre", bookings:"173 bookings", tags:["Rustic","Cozy","Warm"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.30_PM_uzcfwp.jpg" },
  {name:"Modern Minimalist", bookings:"154 bookings", tags:["Sleek","Clean","Contemporary"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.29_PM_1_fgtfve.jpg" },
  {name:"Lyra", bookings:"198 bookings", tags:["Glamorous","Classic","Red Carpet"], img:"https://res.cloudinary.com/dt3jzl980/image/upload/v1779770057/WhatsApp_Image_2026-04-13_at_2.11.28_PM_mhltwy.jpg" },
  {name:"Carnival Den", bookings:"210 bookings", tags:["Carnival","Fun","Colorful"], img:"https://api.carnivalcastle.com/uploads/theatreImg/1765449525498-WhatsApp%20Image%202025-12-10%20at%205.56.04%20PM.jpeg" },
  {name:"Vibe Theatre", bookings:"195 bookings", tags:["Vibrant","Energetic","Trendy"], img:"https://api.carnivalcastle.com/uploads/theatreImg/1765450701857-WhatsApp%20Image%202025-12-11%20at%204.20.31%20PM%20(1).jpeg" },
];

const KID_ACTIVITIES=[
  {name:"Movie Screening",dur:"30 mins",age:"3–12",img:"https://images.unsplash.com/photo-1632765471084-9f2ab98365bf?q=80"},
  {name:"play withBalloon",dur:"45 mins",age:"All ages",img:"https://images.unsplash.com/photo-1727695034153-ff948d488bb1?q=80"},
  {name:"Face Painting",dur:"1 hour",age:"3–12",img:"https://images.unsplash.com/photo-1661708733650-58062da7eecf?q=80"},
  {name:"Magic Show",dur:"30 mins",age:"All ages",img:"https://images.unsplash.com/photo-1641478859026-c2728062c1e1?q=80"},
];
const SERVICE_CARDS=[
  {label:"Themed Decor",img:"https://images.unsplash.com/photo-1765947382841-24c48f1c987e?q=80",desc:"Complete themed decor — balloons, backdrops, props & more."},
  {label:"Custom Cakes",img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80",desc:"3D themed cakes crafted by our in-house bakers."},
  {label:"Food & Snacks",img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80",desc:"Kid-friendly menus with vegetarian & non-veg options."},
  {label:"Photography",img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80",desc:"Professional candid photography — memories forever."},
];
const REELS=[
  {views:"487K",title:"Birthday Celebration",tag:"Iris Decor",video:"/assets/videos/Kids_Birthday.mp4"},
  {views:"312K",title:"Birthday Celebration",tag:"Kids Car Entry",video:"/assets/videos/Car_Entry.mp4"},
  {views:"534K",title:"Birthday Celebration",tag:"Iris Decor",video:"/assets/videos/Private_Theatres.mp4"},
  {views:"445K",title:"Birthday Celebration",tag:"Jungle Theme",video:"/assets/videos/Ayansh_Birthday.mp4"},
  {views:"398K",title:"Birthday Celebration",tag:"Jungle Theme",video:"/assets/videos/Little_bundle_of_joy_Svojass.mp4"},
  {views:"562K",title:"Birthday Celebration",tag:"Jungle Theme",video:"/assets/videos/Angel_Dhanvika.mp4"},
];
// const VID_TESTI=[
//   {src:"/assets/videos/Car_Entry.mp4",name:"Priya & Family",event:"Princess Royal",loc:"Banjara Hills",quote:"The princess setup was out of this world. Our daughter was speechless!",rating:5},
//   {src:"/assets/videos/Private_Theatres.mp4",name:"Ravi Mehta",event:"Superhero Academy",loc:"Jubilee Hills",quote:"Every child felt like a real superhero. Absolutely unforgettable party!",rating:5},
//   {src:"/assets/videos/Kids_Birthday.mp4",name:"Sunita Verma",event:"Dinosaur Adventure",loc:"Madhapur",quote:"The Dino theme was executed perfectly. Kids were amazed the whole time.",rating:5},
//   {src:"/assets/videos/Little_bundle_of_joy_Svojass.mp4",name:"Arjun & Deepa",event:"Candyland Theme",loc:"Kondapur",quote:"My daughter still talks about her Candyland party every single day!",rating:5},
//   {src:"/assets/videos/Ayansh_Birthday.mp4",name:"Kavitha Nair",event:"Space Explorer",loc:"Gachibowli",quote:"The galaxy décor and space activities were beyond our expectations!",rating:5},
// ];

const VID_TESTI = [
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name: "Aisha & Rahul",
    event: "Anniversary Night",
    loc: "Banjara Hills",
    quote: "It was absolutely cinematic — every detail felt made just for us.",
    rating: 5,
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226083/Celebrations_turn_magical_at_Carnival_Castle_Kondapur_From_vibrant_ambience_to_mouth-waterin_n2kzca.mp4",
    name: "Karan Mehta",
    event: "Birthday Surprise",
    loc: "Jubilee Hills",
    quote: "She was completely speechless. The entire vibe was flawless.",
    rating: 5,
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226095/A_proud_parent_celebrated_their_daughter_s_1st_birthday_at_Carnival_Castle_and_shared_Your_fsomov.mp4",
    name: "Rohit & Priya",
    event: "Love Proposal",
    loc: "Kondapur",
    quote: "She said YES! The candles, the roses, the slideshow — perfect.",
    rating: 5,
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779225770/%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8F_%EF%B8%8FAmazing_Experience_at_Carnival_Castle_Carnival_Castle_is_truly_an_outstanding_place_fo_c9kccn.mp4",
    name: "Sruthi Varma",
    event: "Bride To Be",
    loc: "Madhapur",
    quote: "Every single detail was taken care of. We're already planning our next event!",
    rating: 5,
  },
  {
    src: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779226107/A_truly_magical_celebration_at_Carnival_Castle_From_the_fog_entrance_effect_to_the_beautiful_nbcvka.mp4",
    name: "Divya Nair",
    event: "Mom To Be",
    loc: "Gachibowli",
    quote: "The team went above and beyond. My sister was in happy tears!",
    rating: 5,
  },
];
const REVIEWS=[
  {name:"Priya & Arjun",location:"Banjara Hills",rating:5,occasion:"Princess Royal Theme",text:"My daughter's 5th birthday was absolutely magical! The princess theme was so detailed — from the crown décor to the pink fog entry. She was in tears of joy.",image:"https://images.unsplash.com/photo-1535556114965-a5dfc3cda7b9?w=800&q=80",avatar:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=80"},
  {name:"Rahul Mehta",location:"Jubilee Hills",rating:5,occasion:"Superhero Academy",text:"Booked the Superhero theme for my son's birthday and every child was completely blown away. The costumes, the activities, the cake — all perfect.",image:"https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=800&q=80",avatar:"https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=80"},
  {name:"Sunita Varma",location:"Madhapur",rating:5,occasion:"Dinosaur Adventure",text:"The Dinosaur theme was beyond imagination. Kids were running around in awe, the activities were age-perfect and the photographer captured every precious moment.",image:"https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=800&q=80",avatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80"},
  {name:"Vikram Desai",location:"Kondapur",rating:5,occasion:"Candyland Theme",text:"Candyland for my daughter's 7th birthday — she still talks about it every week! The attention to detail in the sweet-themed décor and the custom cake was incredible.",image:"https://images.unsplash.com/photo-1582058091505-f87a2e55a40f?w=800&q=80",avatar:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80"},
  {name:"Kavitha Nair",location:"Gachibowli",rating:5,occasion:"Space Explorer",text:"Space Explorer theme exceeded every expectation. The galaxy décor, the activities, the glow-in-dark props — the kids felt like real astronauts.",image:"https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=800&q=80",avatar:"https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=120&q=80"},
  {name:"Sanjay Pillai",location:"Kukatpally",rating:5,occasion:"Royal Celebration",text:"The Royal Celebration package for my son's 8th birthday — the magic show, goodie bags, 3-tier custom cake. Every detail handled with care.",image:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80",avatar:"https://images.unsplash.com/photo-1552058544-f2b08422138a?w=120&q=80"},
];
const KID_GALLERY=["/assets/img/m1.jpg","/assets/img/m2.jpg","/assets/img/m3.jpg","/assets/img/m4.jpg","/assets/img/m5.jpg","/assets/img/m6.jpg"];
const KID_FAQ=[
  {q:"What age group are these parties for?",a:"Our kids' parties are designed for children aged 2–12 years. Every theme and activity is age-appropriate and fully customizable."},
  {q:"Can we bring our own cake?",a:"Absolutely! You're welcome to bring your own cake. We'll display it beautifully as part of the celebration decor."},
  {q:"Do you provide return gifts?",a:"Yes! Personalized goodie bags, toys, stationery — tailored to your budget and chosen theme."},
  {q:"How far in advance should we book?",a:"We recommend 2–3 weeks for weekdays, 4–6 weeks for popular weekend themes like Princess & Superhero."},
  {q:"Is parental supervision required?",a:"Our trained staff supervises all activities, but we recommend 2–3 guardians stay present throughout the party."},
];

/* ─── Helpers ────────────────────────────────────────────────────── */
function Stars({rating=5,size=13}){
  return <div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:size,color:n<=rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>;
}
const scrollTo=id=>document.getElementById(id)?.scrollIntoView({behavior:"smooth"});

/* ─── Isolated memo sub-components ──────────────────────────────── */
const HeroVideo=memo(()=>{
  const r=useRef(null);
  useEffect(()=>{if(r.current){r.current.muted=true;r.current.play().catch(()=>{});}});
  return(
    <div className="kp-hero-vid-wrap">
      <video ref={r} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} src="/assets/videos/Kids_Birthday.mp4" muted autoPlay loop playsInline preload="none"/>
      <div className="kp-hero-vid-ovl"/>
      <div className="kp-hero-vid-badge"><div className="kp-hero-vid-pulse"/><span className="kp-hero-vid-label">🎉 LIVE — Real Birthday Celebrations</span></div>
    </div>
  );
});

const ThemeCarousel=memo(({navigate})=>{
  const [idx,setIdx]=useState(0);
  useEffect(()=>{const t=setInterval(()=>setIdx(i=>(i+1)%KID_THEMES.length),3500);return()=>clearInterval(t);},[]);
  return(
    <section className="kp-sec" style={{background:C.dark,overflow:"hidden"}}>
      <div className="container">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:44,flexWrap:"wrap",gap:20}}>
          <div><span className="cc-tag cc-tag-light">✦ 15+ Dream Themes ✦</span><h2 className="cc-h cc-h-white">Your Child's <span className="gold">Fantasy</span> Celebrations Decor</h2></div>
          <div style={{display:"flex",gap:10}}>
            <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i-1+KID_THEMES.length)%KID_THEMES.length)}>‹</button>
            <button className="cc-nav-btn" onClick={()=>setIdx(i=>(i+1)%KID_THEMES.length)}>›</button>
          </div>
        </div>
        <div style={{overflow:"hidden"}}>
          <div style={{display:"flex",gap:18,transition:"transform .7s cubic-bezier(.25,1,.5,1)",transform:`translateX(calc(-${idx*(280+18)}px))`}}>
            {[...KID_THEMES,...KID_THEMES].map((t,i)=>(
              <div key={i} className="theme-card" onClick={()=>navigate("/locations")}>
                <div className="kp-emoji-badge">{t.emoji}</div>
                <img src={t.img} alt={t.name} className="theme-img" loading="lazy"/>
                <div className="theme-ovl">
                  <div className="theme-name">{t.name}</div>
                  {/* <div className="theme-booked">🔥 {t.bookings} booked</div>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>{t.tags.map((tg,j)=><span key={j} className="theme-tag">{tg}</span>)}</div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:26}}>
          {KID_THEMES.map((_,i)=><button key={i} onClick={()=>setIdx(i)} style={{width:i===idx?26:8,height:8,borderRadius:8,background:i===idx?C.gold:"rgba(255,255,255,.2)",border:"none",cursor:"pointer",transition:"all .4s"}}/>)}
        </div>
      </div>
    </section>
  );
});

const ReelsSection=memo(()=>{
  const [idx,setIdx]=useState(0);
  const [hovered,setHovered]=useState(false);
  const [vis,setVis]=useState(4);
  const tRef=useRef(null);
  useEffect(()=>{const u=()=>{const w=window.innerWidth;setVis(w<540?1:w<768?2:w<1100?3:4);};u();window.addEventListener("resize",u);return()=>window.removeEventListener("resize",u);},[]);
  const max=REELS.length-vis;
  const start=useCallback(()=>{clearInterval(tRef.current);tRef.current=setInterval(()=>setIdx(i=>i>=max?0:i+1),3000);},[max]);
  useEffect(()=>{if(!hovered)start();else clearInterval(tRef.current);return()=>clearInterval(tRef.current);},[hovered,start]);
  const IGIcon=()=><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>;
  return(
    <section className="kr-sec">
      <div className="kr-orb" style={{width:460,height:460,background:"radial-gradient(circle,rgba(94,14,115,.28) 0%,transparent 70%)",top:-80,left:-80}}/>
      <div className="kr-orb" style={{width:320,height:320,background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)",bottom:-60,right:-40}}/>
      <div className="kr-container">
        <div className="kr-header">
          <div>
            <div className="kr-eyebrow"><div className="kr-eyebrow-line"/>Party Reels<div className="kr-eyebrow-line"/></div>
            <h2 className="kr-title">Watch the <em>Magic</em><br/>Happen Live</h2>
            <p className="kr-sub">Real parties. Real smiles. Real unforgettable moments from our little guests.</p>
          </div>
          <div className="kr-nav">
            <button className="kr-nav-btn" onClick={()=>{setIdx(i=>Math.max(0,i-1));start();}}>‹</button>
            <button className="kr-nav-btn" onClick={()=>{setIdx(i=>i>=max?0:i+1);start();}}>›</button>
          </div>
        </div>
        <div className="kr-wrap" onMouseEnter={()=>setHovered(true)} onMouseLeave={()=>setHovered(false)}>
          <div className="kr-track" style={{transform:`translateX(${-(idx*280)}px)`}}>
            {REELS.map((r,i)=>(
              <div key={i} className="kr-card">
                <video className="kr-video" src={r.video} autoPlay muted loop playsInline preload="none"/>
                <div className="kr-ovl"/>
                <div className="kr-views">👁 {r.views}</div>
                <div className="kr-play">▶</div>
                <div className="kr-info"><div className="kr-tag-pill">{r.tag}</div><h3>{r.title}</h3></div>
              </div>
            ))}
          </div>
        </div>
        <div className="kr-dots">
          {Array.from({length:REELS.length-vis+1}).map((_,i)=>(
            <button key={i} className={`kr-dot${i===idx?" active":""}`} style={{width:i===idx?28:8}} onClick={()=>{setIdx(i);start();}}/>
          ))}
        </div>
        <div className="kr-cta">
          <a href="https://www.instagram.com/carnival_castle_/" target="_blank" rel="noopener noreferrer" className="kr-btn-ig"><IGIcon/> Follow @carnivalcastle</a>
          <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kr-btn-gold">🎈 Book Your Party</a>
        </div>
      </div>
    </section>
  );
});

const VideoTestimonials=memo(()=>{
  const [ai,setAi]=useState(0);
  const [playing,setPlaying]=useState(false);
  const [progress,setProgress]=useState(0);
  const [trans,setTrans]=useState(false);
  const [showCtrl,setShowCtrl]=useState(false);
  const vRef=useRef(null),sRef=useRef(null),aRef=useRef(null),cRef=useRef(null);
  const cur=VID_TESTI[ai];
  /* stop when scrolled out */
  useEffect(()=>{const el=sRef.current;if(!el)return;const o=new IntersectionObserver(([e])=>{if(!e.isIntersecting){vRef.current?.pause();setPlaying(false);}},{threshold:.25});o.observe(el);return()=>o.disconnect();},[]);
  /* reset on index change */
  useEffect(()=>{const v=vRef.current;if(!v)return;v.pause();v.currentTime=0;v.muted=false;setPlaying(false);setProgress(0);},[ai]);
  useEffect(()=>{const v=vRef.current;if(!v)return;const t=()=>{if(v.duration)setProgress((v.currentTime/v.duration)*100);};const e=()=>{setPlaying(false);setProgress(0);};v.addEventListener("timeupdate",t);v.addEventListener("ended",e);return()=>{v.removeEventListener("timeupdate",t);v.removeEventListener("ended",e);};},[ai]);
  const sc=()=>{setShowCtrl(true);clearTimeout(cRef.current);cRef.current=setTimeout(()=>setShowCtrl(false),2500);};
  const isTouchDevice=()=>window.matchMedia("(hover:none) and (pointer:coarse)").matches;
  const onEnter=()=>{if(isTouchDevice())return;sc();const v=vRef.current;if(v&&!playing){v.muted=false;v.play().then(()=>setPlaying(true)).catch(()=>{});}}; 
  const onLeave=()=>{if(isTouchDevice())return;setShowCtrl(false);clearTimeout(cRef.current);if(vRef.current&&playing){vRef.current.pause();setPlaying(false);}};
  const toggleVideo=()=>{const v=vRef.current;if(!v)return;if(playing){v.pause();v.muted=false;setPlaying(false);}else{v.muted=false;v.play().then(()=>setPlaying(true)).catch(()=>{});}};
  const onReelClick=()=>{sc();toggleVideo();};
  const tog=e=>{e.stopPropagation();toggleVideo();};
  const goTo=useCallback(i=>{if(i===ai||trans)return;setTrans(true);setTimeout(()=>{setAi(i);setTrans(false);},300);},[ai,trans]);
  useEffect(()=>{if(!playing){aRef.current=setInterval(()=>setAi(i=>(i+1)%VID_TESTI.length),5000);}else{clearInterval(aRef.current);}return()=>clearInterval(aRef.current);},[playing]);
  return(
    <section className="kvt-sec" ref={sRef}>
      <div className="kvt-header">
        <div><div className="kvt-eyebrow"><div className="kvt-eyebrow-line"/>Parent Stories<div className="kvt-eyebrow-line"/></div><h2 className="kvt-h">Real Parents,<br/><em>Real Happy Kids</em></h2></div>
        <div className="kvt-counter"><span>{String(ai+1).padStart(2,"0")}</span>{" / "+String(VID_TESTI.length).padStart(2,"0")}</div>
      </div>
      <div className="kvt-stage">
        <div className={`kvt-transition${trans?" show":""}`}/>
        <div className="kvt-pane">
          <div className={`kvt-glow${playing?" active":""}`}/>
          <div className={`kvt-reel${playing?" playing":""}`} onMouseEnter={onEnter} onMouseLeave={onLeave} onMouseMove={sc} onClick={onReelClick}>
            <div className="kvt-notch"/>
            <div className="kvt-prog"><div className="kvt-prog-fill" style={{width:`${progress}%`}}/></div>
            <video key={ai} ref={vRef} className="kvt-video" src={cur.src} muted={false} playsInline preload="metadata"/>
            <div className="kvt-ovl"/>
            {!playing&&<div className="kvt-pulse-ring"/>}
            {/* Play button — always visible, hides when playing */}
            {!playing&&(
              <div className="kvt-play-area">
                <button className="kvt-play-btn show" onClick={tog}>
                  <svg width="22" height="22" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                </button>
              </div>
            )}
            {/* Info — only stars + name */}
            <div className="kvt-info" key={ai}>
              <div className="kvt-stars">{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:15,color:n<=cur.rating?C.gold:"rgba(201,168,76,.2)"}}>★</span>)}</div>
              <div className="kvt-identity">
                <div className="kvt-avatar">{cur.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</div>
                <div><div className="kvt-name">{cur.name}</div></div>
              </div>
            </div>
          </div>
        </div>
        <div className="kvt-queue">
          <div className="kvt-queue-header"><div className="kvt-queue-title">Up Next</div></div>
          <div className="kvt-queue-list">
            {VID_TESTI.map((t,i)=>(
              <div key={i} className={`kvt-q-item${i===ai?" active":""}`} onClick={()=>goTo(i)}>
                <div className="kvt-q-thumb"><div className="kvt-q-bg"/><span className="kvt-q-init">{t.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</span>
                  {i===ai&&playing&&<div className="kvt-q-eq-wrap"><div className="kvt-q-eq"><div className="kvt-q-bar"/><div className="kvt-q-bar"/><div className="kvt-q-bar"/></div></div>}
                </div>
                <div className="kvt-q-info"><div className="kvt-q-name">{t.name}</div><div className="kvt-q-event">{t.event} · {t.loc}</div></div>
                <div className="kvt-q-num">{String(i+1).padStart(2,"0")}</div>
              </div>
            ))}
          </div>
          <div className="kvt-queue-nav">
            <span className="kvt-nav-label">Navigate</span>
            <div className="kvt-nav-arrows">
              <button className="kvt-nav-btn" onClick={()=>goTo((ai-1+VID_TESTI.length)%VID_TESTI.length)}>‹</button>
              <button className="kvt-nav-btn" onClick={()=>goTo((ai+1)%VID_TESTI.length)}>›</button>
            </div>
          </div>
        </div>
      </div>
      <div className="kvt-strip">
        <div className="kvt-ratings">
          {[{num:"4.9★",label:"Google"},{num:"4.8★",label:"Facebook"},{num:"2000+",label:"Parties"},{num:"99%",label:"Happy Parents"}].map((item,i,arr)=>(
            <React.Fragment key={i}>{i>0&&<div className="kvt-r-sep"/>}<div className="kvt-r-item"><div className="kvt-r-num">{item.num}</div><div className="kvt-r-label">{item.label}</div></div></React.Fragment>
          ))}
        </div>
        <button onClick={()=>scrollTo("enquiry")} className="kvt-btn-gold">🎈 Book Your Party</button>
      </div>
    </section>
  );
});

const WrittenReviews=memo(()=>{
  const [ai,setAi]=useState(0);
  const aRef=useRef(null);
  const start=()=>{clearInterval(aRef.current);aRef.current=setInterval(()=>setAi(i=>(i+1)%REVIEWS.length),4800);};
  useEffect(()=>{start();return()=>clearInterval(aRef.current);},[]);
  const goTo=i=>{setAi((i+REVIEWS.length)%REVIEWS.length);clearInterval(aRef.current);start();};
  const cur=REVIEWS[ai];
  const prev=REVIEWS[(ai-1+REVIEWS.length)%REVIEWS.length];
  const next=REVIEWS[(ai+1)%REVIEWS.length];
  const avg=(REVIEWS.reduce((s,r)=>s+r.rating,0)/REVIEWS.length).toFixed(1);
  return(
    <section className="kt-sec">
      <div className="container" style={{position:"relative",zIndex:1}}>
        <div className="text-center">
          <span className="kt-tag">✦ Parent Stories ✦</span>
          <h2 className="kt-h">Real Parties,<br/><span>Real Happy Kids</span></h2>
          <p className="kt-sub">Hear from parents — their children's joy, their stories, their most magical moments.</p>
        </div>
        <div className="kt-stats">
          <div className="kt-stat"><div className="kt-sn">{avg}</div><div style={{display:"flex",justifyContent:"center",gap:2,margin:"5px 0 4px"}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div><div className="kt-sl">Average Rating</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">2000+</div><div className="kt-sl">Happy Parties</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">99%</div><div className="kt-sl">Would Return</div></div>
          <div className="kt-ssep"/><div className="kt-stat"><div className="kt-sn">4.9</div><div className="kt-sl">Google Rating</div></div>
        </div>
        <div style={{marginTop:56}}>
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7" style={{display:"flex"}}>
              <div className="kt-feat">
                <div className="kt-big-q">"</div>
                <div className="kt-feat-in">
                  <div className="kt-fi-wrap"><img key={ai} src={cur.image} alt={cur.name} className="kt-fi" loading="lazy"/><div className="kt-fi-ovl"/><div className="kt-fi-badge">🎉 {cur.occasion}</div></div>
                  <div style={{marginBottom:14}}><Stars rating={cur.rating} size={15}/></div>
                  <p className="kt-review">"{cur.text}"</p>
                  <div className="kt-div"/>
                  <div className="kt-author">
                    <img src={cur.avatar} alt={cur.name} className="kt-avatar" loading="lazy"/>
                    <div><div className="kt-aname">{cur.name}</div><div className="kt-aloc">{cur.location}</div></div>
                    <div className="kt-v">✓</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5" style={{display:"flex",flexDirection:"column",gap:16}}>
              {[prev,next].map((rv,i)=>(
                <div key={i} className="kt-prev" onClick={()=>goTo(i===0?(ai-1+REVIEWS.length)%REVIEWS.length:(ai+1)%REVIEWS.length)}>
                  <img src={rv.image} alt={rv.name} className="kt-pi" loading="lazy"/>
                  <div className="kt-pb"><Stars rating={rv.rating} size={11}/><p className="kt-pt">"{rv.text}"</p><div className="kt-pn">{rv.name}</div><div className="kt-pl">{rv.location}</div><span className="kt-pr">Read Full →</span></div>
                </div>
              ))}
            </div>
          </div>
          <div className="kt-nav">
            <button className="kt-arr" onClick={()=>goTo(ai-1)}>‹</button>
            {REVIEWS.map((_,i)=><button key={i} className={`kt-dot${i===ai?" on":""}`} onClick={()=>goTo(i)}/>)}
            <button className="kt-arr" onClick={()=>goTo(ai+1)}>›</button>
          </div>
        </div>
        <div className="kt-plat">
          {[{name:"Google",score:"4.9",count:"200+ reviews"},{name:"Facebook",score:"4.8",count:"150+ reviews"},{name:"JustDial",score:"4.7",count:"80+ reviews"},{name:"Instagram",score:"5.0",count:"50k+ followers"}].map((p,i)=>(
            <React.Fragment key={i}>
              {i>0&&<div className="kt-psep"/>}
              <div className="kt-plat-item"><div className="kt-plat-name">{p.name}</div><div className="kt-plat-row"><span className="kt-plat-sc">{p.score}</span><div style={{display:"flex",gap:2}}>{[1,2,3,4,5].map(n=><span key={n} style={{fontSize:11,color:C.gold}}>★</span>)}</div></div><div className="kt-plat-cnt">{p.count}</div></div>
            </React.Fragment>
          ))}
        </div>
        <div className="kt-cta">
          <h3 className="kt-cta-h">Ready to Create <span>Pure Magic?</span></h3>
          <p className="kt-cta-sub">Join 2000+ happy families who celebrated their child's most special moments with us.</p>
          <div className="kt-cta-row">
            <button onClick={()=>scrollTo("enquiry")} className="kt-btn-bk">🎈 Book My Party</button>
            <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="kt-btn-wa"><i className="bi bi-whatsapp"/> Chat With Us</a>
          </div>
        </div>
      </div>
    </section>
  );
});

const ScrollRevealWatcher=memo(()=>{
  useEffect(()=>{
    const o=new IntersectionObserver(e=>e.forEach(x=>{if(x.isIntersecting)x.target.classList.add("in");}),{threshold:.08});
    const run=()=>document.querySelectorAll(".rv:not(.in)").forEach(el=>o.observe(el));
    run();const t=setTimeout(run,600);
    return()=>{o.disconnect();clearTimeout(t);};
  },[]);
  return null;
});

function GalleryEntranceObserver(){
  useEffect(()=>{
    const items=document.querySelectorAll(".gal-bento-item");
    const o=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){const i=Array.from(items).indexOf(e.target);e.target.style.transitionDelay=`${i*.08}s`;e.target.classList.add("in");o.unobserve(e.target);}});},{threshold:.1});
    items.forEach(el=>o.observe(el));
    return()=>o.disconnect();
  },[]);
  return null;
}

/* ─── Main Page ──────────────────────────────────────────────────── */
export default function KidsPage(){
  const [loading,setLoading]=useState(true);
  const [faq,setFaq]=useState(null);
  const [showPopup,setShowPopup]=useState(false);
  const [popupImg,setPopupImg]=useState("");
  const [galIdx,setGalIdx]=useState(0);
  const [form,setForm]=useState({name:"",email:"",mobileNumber:"",childAge:"",theme:"",date:"",guests:""});
  const galRef=useRef(null);
  const navigate=useNavigate();

  useEffect(()=>{setTimeout(()=>setLoading(false),400);},[]);
  const onChange=useCallback(e=>setForm(f=>({...f,[e.target.name]:e.target.value})),[]);
  const onSubmit=useCallback(e=>{e.preventDefault();toast.success("🎉 Amazing! We'll call you within 2 hours to plan the perfect party!");setForm({name:"",email:"",mobileNumber:"",childAge:"",theme:"",date:"",guests:""});},[]);
  const galItem=useCallback(src=><img src={src} alt="" style={{width:"100%",display:"block",borderRadius:14}}/>,[]);
  const galThumb=useCallback(src=><img src={src} alt="" style={{width:58,height:58,objectFit:"cover",display:"block",borderRadius:8}}/>,[]);

  if(loading)return(
    <div style={{background:C.dark,height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:18}}>
      <div style={{width:68,height:68,border:`4px solid ${C.primaryPale}`,borderTop:`4px solid ${C.gold}`,borderRadius:"50%",animation:"_spin 1s linear infinite"}}/>
      <p style={{color:C.gold,fontWeight:600,letterSpacing:2,fontSize:14}}>Loading Magic…</p>
      <style>{`@keyframes _spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  return(
    <>
      <style>{GLOBAL_CSS}</style>
      <Helmet>
        <title>Carnival Castle Kids | Magical Birthday Parties in Hyderabad</title>
        <meta name="description" content="Themed birthday parties for kids — Princess, Superhero, Dino & 20+ themes. Premium packages from ₹4,999."/>
      </Helmet>
      <ScrollRevealWatcher/>
      <div className="kp-root">
        <Header/>

        {/* Ticker */}
        <div className="kp-ticker"><div className="kp-ticker-track">
          {[...Array(4)].map((_,k)=>["🎈 20+ Magical Themes","⭐ 2000+ Happy Parties","🛡️ 100% Child Safe","📸 Photography Included","⚡ Book in 2 Minutes","🎂 Custom Cakes Available"].map((item,i)=><span key={`${k}-${i}`} className="kp-ticker-item">{item}</span>))}
        </div></div>

        {/* Hero */}
        <section className="kp-hero">
          <div className="kp-hero-orb" style={{width:500,height:500,background:`radial-gradient(circle,${C.primary}36 0%,transparent 70%)`,top:-100,right:-80}}/>
          <div className="kp-hero-orb" style={{width:300,height:300,background:"radial-gradient(circle,rgba(236,72,153,.16) 0%,transparent 70%)",bottom:80,left:-60}}/>
          <div className="container kp-hero-cnt">
            <div className="row align-items-center g-5">
              <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) both"}}>
                <div className="kp-hero-badge">🎉 Hyderabad's #1 Kids Party Venue</div>
                <h1 className="kp-hero-title pf">Create <span>Magical</span><br/>Birthday Memories</h1>
                <p className="kp-hero-sub">From princess castles to dino adventures — 20+ incredible themes, professional setups, and memories your child will cherish forever.</p>
                <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                  <button onClick={()=>scrollTo("enquiry")} className="cc-btn-gold">🎈 Book a Party</button>
                  <button onClick={()=>scrollTo("enquiry")} className="cc-btn-outline" style={{borderColor:"rgba(255,255,255,.4)",color:"#fff"}}>📞 Callback</button>
                </div>
                <div className="kp-trust-row">
                  {[["2000+","Parties"],["4.9★","Rating"],["20+","Themes"]].map(([n,l])=>(
                    <div key={l} className="kp-trust-item"><div className="num">{n}</div><div className="lbl">{l}</div></div>
                  ))}
                </div>
              </div>
              <div className="col-lg-6" style={{animation:"_fadeUp .9s cubic-bezier(.16,1,.3,1) .2s both"}}>
                <div style={{position:"relative"}}>
                  <HeroVideo/>
                  <div className="kp-hero-float d-none d-md-block" style={{bottom:80,left:-28,animationDelay:"0s"}}>
                    <div style={{fontSize:10,color:"#888",marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>Just Booked!</div>
                    <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>👑</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>Princess Royal</div><div style={{fontSize:11,color:C.primary}}>Priya's 5th Birthday</div></div></div>
                  </div>
                  <div className="kp-hero-float d-none d-md-block" style={{top:32,right:-28,animationDelay:"1.5s"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:18}}>⭐</span><div><div style={{fontSize:13,fontWeight:700,color:C.dark}}>4.9 / 5.0</div><div style={{fontSize:11,color:"#888"}}>2000+ Happy Parties</div></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ReelsSection/>
        <VideoTestimonials/>
        <ThemeCarousel navigate={navigate}/>

        {/* Services */}
        <section className="kp-sec" style={{background:"#fff",overflow:"hidden"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Party Services ✦</span>
              <h2 className="cc-h">Everything You <span>Need</span> for the Perfect Party</h2>
              <p className="cc-sub">Decor, cakes, food, photography — curated to make your child's day perfect.</p>
            </div>
            <div className="kp-divider"><div className="kp-dl"/><div className="kp-dg"/><div className="kp-dl"/></div>
            <div className="svc-grid rv">
              {SERVICE_CARDS.map((s,i)=>(
                <div key={i} className="svc-card">
                  <div className="svc-img-wrap"><img src={s.img} alt={s.label} className="svc-img" loading="lazy"/><div className="svc-glow"/><div className="svc-num">0{i+1}</div><div className="svc-pill">{["✨ Trending","🎂 Custom","🍽️ Fresh","📸 Pro"][i]}</div></div>
                  <div className="svc-body"><div className="svc-float-icon">{["🎪","🎂","🍔","📸"][i]}</div><div className="svc-title pf">{s.label}</div><span className="svc-line"/><p className="svc-desc">{s.desc}</p></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Activities */}
        <section className="kp-sec" style={{background:C.cream}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Fun Activities ✦</span>
              <h2 className="cc-h">Keep the Kids <span>Entertained All Day</span></h2>
            </div>
            <div className="row g-4">
              {KID_ACTIVITIES.map((act,i)=>(
                <div key={i} className={`col-md-3 col-6 rv d${i+1}`}>
                  <div className="act-card">
                    <div style={{overflow:"hidden",height:185}}><img src={act.img} alt={act.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}} loading="lazy"/></div>
                    <div style={{padding:"14px"}}><h3 style={{fontSize:15,fontWeight:700,marginBottom:5,color:C.dark}}>{act.name}</h3><div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888"}}><span>⏱️ {act.dur}</span><span>👶 {act.age}</span></div></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <WrittenReviews/> */}
        <TestimonialsSection />


        {/* Gallery */}
        <section className="kp-sec" style={{background:C.cream,overflow:"hidden"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:50}}>
              <span className="cc-tag">✦ Happy Moments ✦</span>
              <h2 className="cc-h">Real Memories from <span>Real Parties</span></h2>
              <p className="cc-sub">Captured moments from our little guests' most magical days.</p>
            </div>
            <div className="gal-bento rv">
              {KID_GALLERY.map((img,i)=>(
                <div key={i} className={`gal-bento-item gbi-${i+1}`} onClick={()=>{setGalIdx(i);galRef.current?.show();}}>
                  <img src={img} alt={`Party ${i+1}`} loading="lazy"/><div className="gal-bento-ovl">🔍</div>
                </div>
              ))}
            </div>
            <Galleria ref={galRef} value={KID_GALLERY} numVisible={5} activeIndex={galIdx} onItemChange={e=>setGalIdx(e.index)} circular fullScreen showItemNavigators showThumbnails={false} item={galItem} thumbnail={galThumb}/>
            <div style={{display:"flex",gap:14,justifyContent:"center",marginTop:34,flexWrap:"wrap"}}>
              <a href="/locations" className="cc-btn">Book Your Party →</a>
              <a href="https://wa.me/918374777834" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/> Chat With Us</a>
            </div>
          </div>
          <GalleryEntranceObserver/>
        </section>

        <CouponSection/>

        {/* Enquiry */}
        <section id="enquiry" className="kp-sec" style={{background:C.beige}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ Book Your Party ✦</span>
              <h2 className="cc-h">Plan the Party <span>of Their Dreams</span></h2>
              <p className="cc-sub">Fill in the details and our party specialist will call you within 2 hours.</p>
            </div>
            <div className="enq-wrap rv" style={{maxWidth:980,margin:"0 auto"}}>
              <div className="row g-0">
                <div className="col-lg-4">
                  <div className="enq-left h-100">
                    <div>
                      <h3 className="pf" style={{color:"#fff",fontSize:23,fontWeight:700,marginBottom:8}}>Let's Create <span style={{color:C.goldLight}}>Magic</span> Together</h3>
                      <p style={{color:"rgba(255,255,255,.58)",fontSize:13,lineHeight:1.7,marginBottom:24}}>Share your event details and we'll craft an unforgettable kids' party experience.</p>
                    </div>
                    <div>
                      {[{icon:"⚡",label:"2-Hour Callback",val:"We call within 2 hours"},{icon:"🎨",label:"Free Theme Consult",val:"Expert advice included"},{icon:"💰",label:"Price Match",val:"Best price guaranteed"},{icon:"💬",label:"WhatsApp Us",val:"+91 8374777834",href:"https://wa.me/918374777834"}].map((it,i)=>(
                        <div key={i} className="enq-contact-info"><div className="enq-ci-icon">{it.icon}</div><div><div className="enq-ci-label">{it.label}</div>{it.href?<a href={it.href} style={{color:"#fff",fontWeight:500,fontSize:13,textDecoration:"none"}}>{it.val}</a>:<span style={{color:"#fff",fontWeight:500,fontSize:13}}>{it.val}</span>}</div></div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="enq-right">
                    <h3 className="pf" style={{fontSize:21,fontWeight:700,color:C.dark,marginBottom:4}}>Book Your <span style={{color:C.primary}}>Kid's Party!</span></h3>
                    <p style={{color:"#aaa",fontSize:13,marginBottom:22}}>Free callback within 2 hours • No obligation</p>
                    <form onSubmit={onSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6"><label className="enq-label">Your Name *</label><input type="text" name="name" className="enq-input" placeholder="e.g. Priya Sharma" value={form.name} onChange={onChange} required/></div>
                        <div className="col-md-6"><label className="enq-label">Phone Number *</label><input type="tel" name="mobileNumber" className="enq-input" placeholder="+91 98765 43210" value={form.mobileNumber} onChange={onChange} required/></div>
                        <div className="col-md-6"><label className="enq-label">Email Address</label><input type="email" name="email" className="enq-input" placeholder="you@email.com" value={form.email} onChange={onChange}/></div>
                        <div className="col-md-6"><label className="enq-label">Child's Age *</label><input type="text" name="childAge" className="enq-input" placeholder="e.g. 6 years" value={form.childAge} onChange={onChange} required/></div>
                        <div className="col-md-6"><label className="enq-label">Preferred Theme *</label><select name="theme" className="enq-input" value={form.theme} onChange={onChange} required><option value="">Choose a theme…</option>{KID_THEMES.map((t,i)=><option key={i} value={t.name}>{t.emoji} {t.name}</option>)}</select></div>
                        <div className="col-md-6"><label className="enq-label">Party Date *</label><input type="date" name="date" className="enq-input" value={form.date} onChange={onChange} required/></div>
                        <div className="col-12"><label className="enq-label">Number of Kids *</label><select name="guests" className="enq-input" value={form.guests} onChange={onChange} required><option value="">How many kids are coming?</option><option>5–10 kids</option><option>11–20 kids</option><option>21–30 kids</option><option>30+ kids</option></select></div>
                        <div className="col-12" style={{marginTop:4}}>
                          <button type="submit" className="cc-btn-gold" style={{width:"100%",justifyContent:"center",padding:"15px",fontSize:15}}>🎉 Request a Free Callback 🎉</button>
                          <p style={{textAlign:"center",fontSize:11,color:"#aaa",marginTop:10}}>No spam. We'll call to discuss your party and that's it.</p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="kp-sec" style={{background:"#fff"}}>
          <div className="container">
            <div className="text-center rv" style={{marginBottom:44}}>
              <span className="cc-tag">✦ FAQ ✦</span>
              <h2 className="cc-h">Got <span>Questions?</span> We've Got Answers</h2>
            </div>
            <div className="row justify-content-center"><div className="col-lg-8">
              {KID_FAQ.map((q,i)=>(
                <div key={i} className={`kp-faq-item${faq===i?" open":""}`} onClick={()=>setFaq(faq===i?null:i)}>
                  <div className="kp-faq-q"><span>{q.q}</span><div className="kp-faq-arrow">▾</div></div>
                  {faq===i&&<div className="kp-faq-a">{q.a}</div>}
                </div>
              ))}
            </div></div>
          </div>
        </section>

        {/* CTA */}
        <section className="kp-cta-sec kp-sec-sm">
          <div className="container text-center" style={{position:"relative",zIndex:1}}>
            <span style={{fontSize:50}}>🎂</span>
            <h2 className="pf" style={{fontSize:"clamp(24px,4vw,42px)",color:"#fff",fontWeight:900,marginTop:12,marginBottom:12}}>
              Ready to Create <span style={{background:`linear-gradient(135deg,${C.goldLight},${C.goldBright})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Pure Magic?</span>
            </h2>
            <p style={{color:"rgba(255,255,255,.63)",fontSize:15,marginBottom:26,maxWidth:460,margin:"0 auto 26px"}}>Book your child's dream party today. We handle everything so you just celebrate.</p>
            <button className="cc-btn-gold" style={{fontSize:15,padding:"15px 40px"}} onClick={()=>scrollTo("enquiry")}>🎈 Book Your Party Now</button>
            <p style={{color:"rgba(255,255,255,.32)",fontSize:12,marginTop:12}}>Join 2000+ happy families who celebrated with us</p>
          </div>
        </section>

        <Footer/>
        <ToastContainer position="top-center" autoClose={4000} theme="dark"/>
        <PopupModal show={showPopup} handleClose={()=>setShowPopup(false)} image={popupImg}/>
      </div>
    </>
  );
}